/*! Copyright (c) 2016 madai */
var madai = madai || {}; madai["web"] = madai["web"] || {}; madai["web"]["user"] = madai["web"]["user"] || {}; madai["web"]["user"]["App"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _events = __webpack_require__(2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Server = __webpack_require__(5);
	
	var _Server2 = _interopRequireDefault(_Server);
	
	var _domainBuildHeightNotifier = __webpack_require__(10);
	
	var _domainBuildHeightNotifier2 = _interopRequireDefault(_domainBuildHeightNotifier);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainUUID = __webpack_require__(61);
	
	var _domainUUID2 = _interopRequireDefault(_domainUUID);
	
	var _domainLoad_districts = __webpack_require__(62);
	
	var _domainLoad_districts2 = _interopRequireDefault(_domainLoad_districts);
	
	var _domainTarget = __webpack_require__(65);
	
	var _domainTarget2 = _interopRequireDefault(_domainTarget);
	
	var _domainSocial_target = __webpack_require__(68);
	
	var _domainSocial_target2 = _interopRequireDefault(_domainSocial_target);
	
	var _domainSetPurlCookies = __webpack_require__(69);
	
	var _domainSetPurlCookies2 = _interopRequireDefault(_domainSetPurlCookies);
	
	var _domainToUrl = __webpack_require__(66);
	
	var _domainToUrl2 = _interopRequireDefault(_domainToUrl);
	
	var _domainCancel_target = __webpack_require__(71);
	
	var _domainCancel_target2 = _interopRequireDefault(_domainCancel_target);
	
	var _domainSharePurchase = __webpack_require__(72);
	
	var _domainSharePurchase2 = _interopRequireDefault(_domainSharePurchase);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainGoogle_Analytics = __webpack_require__(116);
	
	var _domainGoogle_Analytics2 = _interopRequireDefault(_domainGoogle_Analytics);
	
	var _domainUser = __webpack_require__(117);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainAnonymous = __webpack_require__(118);
	
	var _domainAnonymous2 = _interopRequireDefault(_domainAnonymous);
	
	var _domainRegistered = __webpack_require__(119);
	
	var _domainRegistered2 = _interopRequireDefault(_domainRegistered);
	
	var _domainIsModal = __webpack_require__(14);
	
	var _domainIsModal2 = _interopRequireDefault(_domainIsModal);
	
	var _componentsAlert = __webpack_require__(158);
	
	var _componentsAlert2 = _interopRequireDefault(_componentsAlert);
	
	var _componentsConfirm = __webpack_require__(159);
	
	var _componentsConfirm2 = _interopRequireDefault(_componentsConfirm);
	
	var _componentsMarkdownComponent = __webpack_require__(160);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _createCallback = __webpack_require__(163);
	
	var _createCallback2 = _interopRequireDefault(_createCallback);
	
	var _routePurchase = __webpack_require__(164);
	
	var _routePurchase2 = _interopRequireDefault(_routePurchase);
	
	var _routePurchases = __webpack_require__(189);
	
	var _routePurchases2 = _interopRequireDefault(_routePurchases);
	
	var _routeChangePassword = __webpack_require__(197);
	
	var _routeChangePassword2 = _interopRequireDefault(_routeChangePassword);
	
	var _routeAccount = __webpack_require__(200);
	
	var _routeAccount2 = _interopRequireDefault(_routeAccount);
	
	var _routeLogin = __webpack_require__(205);
	
	var _routeLogin2 = _interopRequireDefault(_routeLogin);
	
	var _routeResendPassword = __webpack_require__(209);
	
	var _routeResendPassword2 = _interopRequireDefault(_routeResendPassword);
	
	var _routeUnexpectedError = __webpack_require__(213);
	
	var _routeUnexpectedError2 = _interopRequireDefault(_routeUnexpectedError);
	
	var _routeNoCookies = __webpack_require__(214);
	
	var _routeNoCookies2 = _interopRequireDefault(_routeNoCookies);
	
	var _cookiesJs = __webpack_require__(67);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	var _parseQuerystring = __webpack_require__(70);
	
	var _parseQuerystring2 = _interopRequireDefault(_parseQuerystring);
	
	var _lodashStringTemplate = __webpack_require__(25);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var _jsdkTemplate = __webpack_require__(216);
	
	var _jsdkTemplate2 = _interopRequireDefault(_jsdkTemplate);
	
	_tcomb2['default'].form.Form.templates = _jsdkTemplate2['default'];
	
	var on_start = function on_start() {
	  // comunica con il container quando l'applicazione è ospitata in una modale
	  // e se il container supporta l'api postMessage()
	  this.height_notifier = (0, _domainBuildHeightNotifier2['default'])(this);
	
	  // ensure initial resize
	  document.getElementsByTagName('body')[0].click = this.height_notifier;
	  setInterval(this.height_notifier, 100);
	};
	
	// gestionde della privacy dei cookies
	var doAcceptCookies = function doAcceptCookies() {
	  _cookiesJs2['default'].set('accept_cookies', true, {
	    path: '/'
	  });
	  document.getElementById('cookies_disclaimer').style.display = 'none';
	};
	
	var getNavigateToFacebookLoginCommand = function getNavigateToFacebookLoginCommand(app) {
	  var errorHandler = function errorHandler(err) {
	    return app.go_unexpected_err(err);
	  };
	  var successHandler = function successHandler(result) {
	    app.emit('go_social_login', ['facebook']);
	    window.top.location.href = result.loginUri;
	  };
	  return function () {
	    return app.server.loadFacebook({ target: (0, _domainSocial_target2['default'])(app), locale: app.locale }, (0, _createCallback2['default'])(successHandler, errorHandler));
	  };
	};
	
	var getNavigateToGoogleLoginCommand = function getNavigateToGoogleLoginCommand(app) {
	  var errorHandler = function errorHandler(err) {
	    return app.go_unexpected_err(err);
	  };
	  var successHandler = function successHandler(result) {
	    app.emit('go_social_login', ['google']);
	    window.top.location.href = result.loginUri;
	  };
	  return function () {
	    return app.server.loadGoogle({ target: (0, _domainSocial_target2['default'])(app), locale: app.locale }, (0, _createCallback2['default'])(successHandler, errorHandler));
	  };
	};
	
	var getNavigateToTwitterLoginCommand = function getNavigateToTwitterLoginCommand(app) {
	  var errorHandler = function errorHandler(err) {
	    return app.go_unexpected_err(err);
	  };
	  var successHandler = function successHandler(result) {
	    app.emit('go_social_login', ['twitter']);
	    window.top.location.href = result.loginUri;
	  };
	  return function () {
	    return app.server.loadTwitter({ target: (0, _domainSocial_target2['default'])(app), locale: app.locale }, (0, _createCallback2['default'])(successHandler, errorHandler));
	  };
	};
	
	var getNavigateToMicrosoftLoginCommand = function getNavigateToMicrosoftLoginCommand(app) {
	  var errorHandler = function errorHandler(err) {
	    return app.go_unexpected_err(err);
	  };
	  var successHandler = function successHandler(result) {
	    app.emit('go_social_login', ['microsoft']);
	    window.top.location.href = result.loginUri;
	  };
	  return function () {
	    return app.server.loadMicrosoft({ target: (0, _domainSocial_target2['default'])(app), locale: app.locale }, (0, _createCallback2['default'])(successHandler, errorHandler));
	  };
	};
	
	var doLogout = function doLogout(app) {
	  app.server.doLogout(function (err, user) {
	    if (err) {
	      app.go_unexpected_err(err);
	    } else {
	      app.user = user;
	      app.transact(new LoginRoute());
	    }
	  });
	};
	
	function getInitialRoute(err, user) {
	  if (err) {
	    _tcomb2['default'].assert(_tcomb2['default'].maybe(_tcomb2['default'].Str).is(err));
	    return new LoginRoute(_react2['default'].createElement(
	      _componentsAlert2['default'],
	      { type: 'error' },
	      err,
	      '>'
	    ));
	  } else {
	    var params = (0, _parseQuerystring2['default'])(location.search);
	    if (params.purchase_id) {
	      return new PurchaseRoute(params.purchase_id);
	    } else if (_domainAnonymous2['default'].is(user)) {
	      return new LoginRoute();
	    } else {
	      return new PurchasesRoute();
	    }
	  }
	}
	
	var App = (function (_EventEmitter) {
	  _inherits(App, _EventEmitter);
	
	  _createClass(App, [{
	    key: 'Share_Purchase',
	
	    /* FIXME */
	    value: function Share_Purchase() {
	      return _domainSharePurchase2['default'];
	    }
	  }], [{
	    key: 'go',
	    value: function go(mountNode, options) {
	      (0, _domainSetPurlCookies2['default'])();
	      var server = new _Server2['default'](options.api_url);
	
	      options.locale = _domainLocale2['default'].of(options.locale);
	      if (options.user && options.user.com_locale) {
	        options.user.com_locale = _domainLocale2['default'].of(options.user.com_locale);
	      }
	      options.user = (0, _domainUser2['default'])(options.user);
	
	      options.route = getInitialRoute(options.err, options.user);
	
	      var app = new App(mountNode, server, options);
	
	      // track analytics infos
	      var googleAnalytics = new _domainGoogle_Analytics2['default']();
	
	      function getPageview(name, args) {
	        args = args || {};
	        return (0, _domainToUrl2['default'])('user/' + name, _tcomb2['default'].mixin({
	          locale: app.locale.toJSON(),
	          is_modal: (0, _domainIsModal2['default'])(),
	          profile: _domainAnonymous2['default'].is(app.user) ? 'anonymous' : _domainRegistered2['default'].is(app.user) ? 'registered' : 'verified'
	        }, args));
	      }
	
	      // emitted when route changes
	      app.on('route:change', function (route) {
	        googleAnalytics.track_pageview(getPageview(route.name));
	      });
	
	      // emitted when a purchase is shared by the buyer
	      app.on('do_share_purchase', function () {
	        googleAnalytics.track_pageview(getPageview('do_share_purchase', {
	          type: 'user'
	        }));
	      });
	
	      // emitted when the user try to login with socials
	      app.on('go_social_login', function (args) {
	        var type = args[0];
	        googleAnalytics.track_pageview(getPageview('go_social_login', { type: type }));
	      });
	
	      app.transact(options.route);
	
	      on_start.bind(app)();
	
	      return app;
	    }
	  }]);
	
	  function App(mountNode, server, options) {
	    _classCallCheck(this, App);
	
	    _get(Object.getPrototypeOf(App.prototype), 'constructor', this).call(this);
	    _tcomb2['default'].assert(_tcomb2['default'].Str.is(options.lib_url));
	    _tcomb2['default'].assert(_domainLocale2['default'].is(options.locale));
	    _tcomb2['default'].assert(_domainUser2['default'].is(options.user));
	    _tcomb2['default'].assert(_tcomb2['default'].Obj.is(options.route));
	    _tcomb2['default'].assert(_tcomb2['default'].Str.is(options.share_purchase_url));
	
	    _tcomb2['default'].mixin(this, options);
	    this.mountNode = mountNode;
	    this.server = server;
	    this.height_notifier = (0, _domainBuildHeightNotifier2['default'])(this);
	  }
	
	  //
	  // routes
	  //
	
	  // da chiamare quando si riceve una access denied da una chiamata alle api sotto autenticazione
	
	  _createClass(App, [{
	    key: 'go_expired_session',
	    value: function go_expired_session(locale) {
	      var bundle = (0, _domainGet_bundle2['default'])(locale);
	      this.user = (0, _domainUser2['default'])({ profile: 'anonymous' });
	      this.transact(new LoginRoute(_react2['default'].createElement(
	        _componentsAlert2['default'],
	        { type: 'error' },
	        bundle['template_message']['login.access denied']
	      )));
	    }
	  }, {
	    key: 'go_unexpected_err',
	    value: function go_unexpected_err(err) {
	      this.transact(new UnexpectedErrorRoute(err));
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      _reactDom2['default'].unmountComponentAtNode(this.mountNode);
	    }
	  }, {
	    key: 'transact',
	    value: function transact(route) {
	      var _this = this;
	
	      this.stop();
	      this.route = route;
	      route.to_widget(this, function (widget) {
	        _reactDom2['default'].render(widget, _this.mountNode);
	        _this.emit('route:change', route);
	        _this.height_notifier();
	        window.scrollTo(0, 0);
	      });
	    }
	  }]);
	
	  return App;
	})(_events.EventEmitter);
	
	exports['default'] = App;
	
	var UnexpectedErrorRoute = (function () {
	  function UnexpectedErrorRoute(err) {
	    _classCallCheck(this, UnexpectedErrorRoute);
	
	    this.name = 'unexpected_error';
	    this.err = err;
	  }
	
	  _createClass(UnexpectedErrorRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	
	      var doRefresh = function doRefresh() {
	        location.reload();
	      };
	
	      callback(_react2['default'].createElement(_routeUnexpectedError2['default'], {
	        locale: app.locale,
	        err: this.err,
	        doAcceptCookies: doAcceptCookies,
	        doRefresh: doRefresh }));
	    }
	  }]);
	
	  return UnexpectedErrorRoute;
	})();
	
	var ResendPasswordRoute = (function () {
	  function ResendPasswordRoute(message) {
	    _classCallCheck(this, ResendPasswordRoute);
	
	    this.name = 'resend_password';
	    this.message = message;
	  }
	
	  _createClass(ResendPasswordRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale);
	
	      var doResendPassword = function doResendPassword(email) {
	        app.server.doResendPassword({ email: email }, function (err) {
	          if (err) {
	            switch (err.message) {
	              case 'invalid emailAddress':
	                var msg = (0, _lodashStringTemplate2['default'])(bundle['template_message']['invalid emailAddress'])({
	                  email: email
	                });
	                app.transact(new ResendPasswordRoute(_react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'error' },
	                  msg
	                )));
	                break;
	              default:
	                app.go_unexpected_err(err);
	            }
	          } else {
	            var msg = (0, _lodashStringTemplate2['default'])(bundle['template_message']['resend_password.done'])({
	              email: email
	            });
	            app.transact(new LoginRoute(_react2['default'].createElement(
	              _componentsAlert2['default'],
	              { type: 'success' },
	              _react2['default'].createElement(
	                _componentsMarkdownComponent2['default'],
	                null,
	                msg
	              )
	            )));
	          }
	        });
	      };
	
	      var go_login = function go_login() {
	        app.transact(new LoginRoute());
	      };
	
	      callback(_react2['default'].createElement(_routeResendPassword2['default'], {
	        locale: locale,
	        message: this.message,
	        doResendPassword: doResendPassword,
	        goLogin: go_login,
	        doAcceptCookies: doAcceptCookies }));
	    }
	  }]);
	
	  return ResendPasswordRoute;
	})();
	
	var LoginRoute = (function () {
	  function LoginRoute(message) {
	    _classCallCheck(this, LoginRoute);
	
	    this.name = 'login';
	    this.message = message;
	  }
	
	  _createClass(LoginRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale)['template_message'];
	
	      var goResendPassword = function goResendPassword() {
	        app.transact(new ResendPasswordRoute());
	      };
	
	      var doLogin = function doLogin(email, password) {
	        app.server.doLogin({ email: email, password: password }, function (err, user) {
	          if (err) {
	            switch (err.message) {
	              case 'account deleted':
	              case 'invalid emailAddress':
	                var msg = (0, _lodashStringTemplate2['default'])(bundle[err.message])({
	                  email: email
	                });
	                app.transact(new LoginRoute(_react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'error' },
	                  msg
	                )));
	                break;
	              case 'access denied':
	                app.transact(new LoginRoute(_react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'error' },
	                  bundle['login.access denied']
	                )));
	                break;
	              default:
	                app.go_unexpected_err(err);
	            }
	          } else {
	            user.com_locale = _domainLocale2['default'].of(user.com_locale);
	            app.user = (0, _domainUser2['default'])(user);
	            app.transact(new PurchasesRoute());
	          }
	        });
	      };
	
	      callback(_react2['default'].createElement(_routeLogin2['default'], {
	        locale: locale,
	        message: this.message,
	        goResendPassword: goResendPassword,
	        doLogin: doLogin,
	        goFacebookLogin: getNavigateToFacebookLoginCommand(app),
	        goGoogleLogin: getNavigateToGoogleLoginCommand(app),
	        goTwitterLogin: getNavigateToTwitterLoginCommand(app),
	        goMicrosoftLogin: getNavigateToMicrosoftLoginCommand(app),
	        doAcceptCookies: doAcceptCookies }));
	    }
	  }]);
	
	  return LoginRoute;
	})();
	
	var ChangePasswordRoute = (function () {
	  function ChangePasswordRoute(message) {
	    _classCallCheck(this, ChangePasswordRoute);
	
	    this.name = 'change_password';
	    this.message = message;
	  }
	
	  _createClass(ChangePasswordRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var locale = app.locale;
	
	      var goAccount = function goAccount() {
	        app.transact(new AccountRoute());
	      };
	
	      var goPurchases = function goPurchases() {
	        app.transact(new PurchasesRoute());
	      };
	
	      var goChangePassword = function goChangePassword() {
	        app.transact(new ChangePasswordRoute());
	      };
	
	      var doChangePassword = function doChangePassword(old_password, new_password) {
	        var bundle = (0, _domainGet_bundle2['default'])(locale)['template_message'];
	        app.server.doChangePassword({ old_password: old_password, new_password: new_password }, function (err) {
	          if (err) {
	            switch (err.message) {
	              case 'access denied':
	                app.go_expired_session();
	                break;
	              case 'invalid old password':
	              case 'invalid new password':
	                app.transact(new ChangePasswordRoute(_react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'error' },
	                  bundle['change_password.' + err.message]
	                )));
	                break;
	              default:
	                app.go_unexpected_err(err);
	            }
	          } else {
	            app.transact(new ChangePasswordRoute(_react2['default'].createElement(
	              _componentsAlert2['default'],
	              { type: 'success' },
	              bundle['change_password.done']
	            )));
	          }
	        });
	      };
	
	      var _doLogout = function _doLogout() {
	        doLogout(app);
	      };
	
	      callback(_react2['default'].createElement(_routeChangePassword2['default'], { user: app.user,
	        locale: locale,
	        message: this.message,
	        doChangePassword: doChangePassword,
	        goAccount: goAccount,
	        goChangePassword: goChangePassword,
	        goPurchases: goPurchases,
	        doLogout: _doLogout,
	        doAcceptCookies: doAcceptCookies }));
	    }
	  }]);
	
	  return ChangePasswordRoute;
	})();
	
	var AccountRoute = (function () {
	  function AccountRoute(message) {
	    _classCallCheck(this, AccountRoute);
	
	    this.name = 'account';
	    this.message = message;
	  }
	
	  _createClass(AccountRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var _this2 = this;
	
	      var locale = app.locale;
	      var user = app.user;
	      var lib_url = app.lib_url;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale);
	
	      (0, _domainLoad_districts2['default'])(lib_url, user.country, function (districts) {
	
	        var load_districts_bck = _domainLoad_districts2['default']; //TODO ERRORE
	
	        var _load_districts = function _load_districts(country, callback) {
	          (0, _domainLoad_districts2['default'])(lib_url, country, callback);
	        };
	
	        var goAccount = function goAccount() {
	          app.transact(new AccountRoute());
	        };
	
	        var goPurchases = function goPurchases() {
	          app.transact(new PurchasesRoute());
	        };
	
	        var goChangePassword = function goChangePassword() {
	          app.transact(new ChangePasswordRoute());
	        };
	
	        var doUpdateAccount = function doUpdateAccount(name, surname, gender, birth_date, country, district, zip, com_locale) {
	
	          app.server.doUpdateAccount({ name: name, surname: surname, gender: gender, birth_date: birth_date, country: country, district: district, zip: zip, com_locale: _domainLocale2['default'].of(com_locale) }, function (err, user) {
	            if (err) {
	              switch (err.message) {
	                case 'access denied':
	                  app.go_expired_session();
	                  break;
	                default:
	                  app.go_unexpected_err(err);
	              }
	            } else {
	              load_districts_bck(lib_url, country, function () {
	                user.com_locale = _domainLocale2['default'].of(user.com_locale);
	                app.user = (0, _domainUser2['default'])(user);
	                app.transact(new AccountRoute(_react2['default'].createElement(
	                  _componentsAlert2['default'],
	                  { type: 'success' },
	                  bundle['template_message']['account.done']
	                )));
	              });
	            }
	          });
	        };
	
	        var _doLogout = function _doLogout() {
	          doLogout(app);
	        };
	
	        callback(_react2['default'].createElement(_routeAccount2['default'], {
	          locale: locale,
	          user: user,
	          districts: districts,
	          loadDistricts: _load_districts,
	          locale: locale,
	          message: _this2.message,
	          doUpdateAccount: doUpdateAccount,
	          goAccount: goAccount,
	          goChangePassword: goChangePassword,
	          goPurchases: goPurchases,
	          doLogout: _doLogout,
	          doAcceptCookies: doAcceptCookies }));
	      });
	    }
	  }]);
	
	  return AccountRoute;
	})();
	
	var PurchasesRoute = (function () {
	  function PurchasesRoute() {
	    _classCallCheck(this, PurchasesRoute);
	
	    this.name = 'purchases';
	  }
	
	  _createClass(PurchasesRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      app.server.loadPurchases(function (err, purchases_raw) {
	        if (err) {
	          switch (err.message) {
	            case 'access denied':
	              app.go_expired_session(app.locale);
	              break;
	            default:
	              app.go_unexpected_err(err);
	          }
	        } else {
	          var goPurchase = function goPurchase(id) {
	            app.transact(new PurchaseRoute(id));
	          };
	
	          var goAccount = function goAccount() {
	            app.transact(new AccountRoute());
	          };
	
	          var goPurchases = function goPurchases() {
	            app.transact(new PurchasesRoute());
	          };
	
	          var goChangePassword = function goChangePassword() {
	            app.transact(new ChangePasswordRoute());
	          };
	
	          var _doLogout = function _doLogout() {
	            doLogout(app);
	          };
	          callback(_react2['default'].createElement(_routePurchases2['default'], {
	            user: app.user,
	            locale: app.locale,
	            purchases: purchases_raw,
	            goPurchase: goPurchase,
	            goAccount: goAccount,
	            goChangePassword: goChangePassword,
	            goPurchases: goPurchases,
	            doLogout: _doLogout,
	            doAcceptCookies: doAcceptCookies }));
	        }
	      });
	    }
	  }]);
	
	  return PurchasesRoute;
	})();
	
	var PurchaseRoute = (function () {
	  function PurchaseRoute(purchase_id, message) {
	    _classCallCheck(this, PurchaseRoute);
	
	    _tcomb2['default'].assert(_domainUUID2['default'].is(purchase_id));
	    this.name = 'purchase';
	    this.purchase_id = purchase_id;
	    this.message = message;
	  }
	
	  _createClass(PurchaseRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      var _this3 = this;
	
	      var locale = app.locale;
	      var purchase_id = this.purchase_id;
	
	      var goAccount = function goAccount() {
	        app.transact(new AccountRoute());
	      };
	
	      var goPurchases = function goPurchases() {
	        app.transact(new PurchasesRoute());
	      };
	
	      var goChangePassword = function goChangePassword() {
	        app.transact(new ChangePasswordRoute());
	      };
	
	      app.server.loadPurchase({ purchase_id: purchase_id, target: (0, _domainTarget2['default'])(app, purchase_id), cancel_target: (0, _domainCancel_target2['default'])(app) }, function (err, purchase) {
	        if (err) {
	          switch (err.message) {
	            case 'access denied':
	              app.go_expired_session();
	              break;
	            default:
	              app.go_unexpected_err(err);
	          }
	        } else {
	
	          _domainSharePurchase2['default'].create(app.share_purchase_url, app.locale, purchase, function () {
	            return true;
	          });
	
	          var do_send_gift_card_code = function do_send_gift_card_code(gift_card_code) {
	            var bundle = (0, _domainGet_bundle2['default'])(locale);
	            var cbk = function cbk(b) {
	              if (b) {
	                app.server.doSendGiftCardCode({ purchase_id: purchase_id, target: (0, _domainTarget2['default'])(app), cancel_target: (0, _domainCancel_target2['default'])(app, purchase_id), gift_card_code: gift_card_code }, function (err) {
	                  if (err) {
	                    switch (err.message) {
	                      case 'access denied':
	                        app.go_expired_session();
	                        break;
	                      case 'gift card error':
	                        app.transact(new PurchaseRoute(purchase_id, _react2['default'].createElement(
	                          _componentsAlert2['default'],
	                          { type: 'error' },
	                          bundle['template_message']['purchase.gift card error']
	                        )));
	                        break;
	                      default:
	                        app.go_unexpected_err(err);
	                    }
	                  } else {
	                    app.transact(new PurchaseRoute(purchase_id));
	                  }
	                });
	              } else {
	                _reactDom2['default'].unmountComponentAtNode(document.getElementById('modal-container'));
	              }
	            };
	            _reactDom2['default'].render(_react2['default'].createElement(
	              _componentsConfirm2['default'],
	              { callback: cbk, locale: locale, width: '600', title: bundle.order.gift_card.confirm_title },
	              _react2['default'].createElement(
	                _componentsAlert2['default'],
	                { type: 'warning' },
	                _react2['default'].createElement(
	                  _componentsMarkdownComponent2['default'],
	                  null,
	                  bundle.order.gift_card.confirm_body
	                )
	              )
	            ), document.getElementById('modal-container'));
	          };
	
	          var _doLogout = function _doLogout() {
	            doLogout(app);
	          };
	
	          callback(_react2['default'].createElement(_routePurchase2['default'], {
	            locale: locale,
	            message: _this3.message,
	            purchase: purchase,
	            user: app.user,
	            share_purchase: _domainSharePurchase2['default'].current.html(),
	            custom_payments: purchase.custom_payments || [],
	            pending_purchase_message: purchase.pending_purchase_message,
	            doSendGiftCardCode: do_send_gift_card_code,
	            goAccount: goAccount,
	            goChangePassword: goChangePassword,
	            goPurchases: goPurchases,
	            doLogout: _doLogout,
	            doAcceptCookies: doAcceptCookies }));
	        }
	      });
	    }
	  }]);
	
	  return PurchaseRoute;
	})();
	
	var NoCookiesRoute = (function () {
	  function NoCookiesRoute() {
	    _classCallCheck(this, NoCookiesRoute);
	
	    this.name = 'no_cookies';
	  }
	
	  _createClass(NoCookiesRoute, [{
	    key: 'to_widget',
	    value: function to_widget(app, callback) {
	      callback(_react2['default'].createElement(_routeNoCookies2['default'], { locale: app.locale }));
	    }
	  }]);
	
	  return NoCookiesRoute;
	})();

	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/*! @preserve
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2014-2015 Giulio Canti
	 *
	 */
	
	'use strict';
	
	// overrideable by the user
	exports.stringify = function stringify(x) {
	  try { // handle "Converting circular structure to JSON" error
	    return JSON.stringify(x, null, 2);
	  }
	  catch (e) {
	    return String(x);
	  }
	};
	
	function isNil(x) {
	  return x === null || x === void 0;
	}
	
	function isBoolean(x) {
	  return x === true || x === false;
	}
	
	function isString(x) {
	  return typeof x === 'string';
	}
	
	function isNumber(x) {
	  return typeof x === 'number' && isFinite(x) && !isNaN(x);
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	function isArray(x) {
	  return x instanceof Array;
	}
	
	function isObject(x) {
	  return !isNil(x) && typeof x === 'object' && !isArray(x);
	}
	
	function isType(x) {
	  return isFunction(x) && isObject(x.meta);
	}
	
	function isStruct(x) {
	  return isType(x) && ( x.meta.kind === 'struct' );
	}
	
	function isMaybe(x) {
	  return isType(x) && ( x.meta.kind === 'maybe' );
	}
	
	function isUnion(x) {
	  return isType(x) && ( x.meta.kind === 'union' );
	}
	
	function isTypeName(name) {
	  return isNil(name) || isString(name);
	}
	
	// returns true if x is an instance of type
	function is(x, type) {
	  if (isType(type)) {
	    return type.is(x);
	  }
	  return x instanceof type; // type should be a class constructor
	}
	
	// return true if the type constructor behaves like the identity function (exceptions are the structs)
	function isIdentity(type) {
	  if (isType(type)) {
	    return type.meta.identity;
	  }
	  return true; // ES6 classes are identity for tcomb
	}
	
	// creates an instance of a type, handling the optional new operator
	function create(type, value, path) {
	  if (isType(type)) {
	    // for structs the new operator is allowed
	    return isStruct(type) ? new type(value, path) : type(value, path);
	  }
	
	  if (false) {
	    // here type should be a class constructor and value some instance, just check membership and return the value
	    path = path || [getFunctionName(type)];
	    assert(value instanceof type, function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/'); });
	  }
	
	  return value;
	}
	
	function getFunctionName(f) {
	  return f.displayName || f.name || '<function' + f.length + '>';
	}
	
	function getTypeName(constructor) {
	  if (isType(constructor)) {
	    return constructor.displayName;
	  }
	  return getFunctionName(constructor);
	}
	
	// overrideable by the user
	exports.fail = function fail(message) {
	  throw new TypeError('[tcomb] ' + message);
	};
	
	function assert(guard, message) {
	  if (guard !== true) {
	    if (isFunction(message)) { // handle lazy messages
	      message = message();
	    }
	    else if (isNil(message)) { // use a default message
	      message = 'Assert failed (turn on "Pause on exceptions" in your Source panel)';
	    }
	    exports.fail(message);
	  }
	}
	
	// safe mixin, cannot override props unless specified
	function mixin(target, source, overwrite) {
	  if (isNil(source)) { return target; }
	  for (var k in source) {
	    if (source.hasOwnProperty(k)) {
	      if (overwrite !== true) {
	        if (false) {
	          assert(!target.hasOwnProperty(k), function () { return 'Invalid call to mixin(target, source, [overwrite]): cannot overwrite property "' + k + '" of target object'; });
	        }
	      }
	      target[k] = source[k];
	    }
	  }
	  return target;
	}
	
	function forbidNewOperator(x, type) {
	  assert(!(x instanceof type), function () { return 'Cannot use the new operator to instantiate the type ' + getTypeName(type); });
	}
	
	function getShallowCopy(x) {
	  if (isArray(x)) {
	    return x.concat();
	  }
	  if (isObject(x)) {
	    return mixin({}, x);
	  }
	  return x;
	}
	
	// immutability helper
	function update(instance, spec) {
	
	  if (false) {
	    assert(isObject(spec), function () { return 'Invalid argument spec ' + exports.stringify(spec) + ' supplied to function update(instance, spec): expected an object containing commands'; });
	  }
	
	  var value = getShallowCopy(instance);
	  var isChanged = false;
	  for (var k in spec) {
	    if (spec.hasOwnProperty(k)) {
	      if (update.commands.hasOwnProperty(k)) {
	        return update.commands[k](spec[k], value);
	      }
	      else {
	        var newValue = update(value[k], spec[k]);
	        isChanged = isChanged || ( newValue !== value[k] );
	        value[k] = newValue;
	      }
	    }
	  }
	  return isChanged ? value : instance;
	}
	
	// built-in commands
	
	function $apply(f, value) {
	  if (false) {
	    assert(isFunction(f), 'Invalid argument f supplied to immutability helper { $apply: f } (expected a function)');
	  }
	  return f(value);
	}
	
	function $push(elements, arr) {
	  if (false) {
	    assert(isArray(elements), 'Invalid argument elements supplied to immutability helper { $push: elements } (expected an array)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $push (expected an array)');
	  }
	  return arr.concat(elements);
	}
	
	function $remove(keys, obj) {
	  if (false) {
	    assert(isArray(keys), 'Invalid argument keys supplied to immutability helper { $remove: keys } (expected an array)');
	    assert(isObject(obj), 'Invalid value supplied to immutability helper $remove (expected an object)');
	  }
	  for (var i = 0, len = keys.length; i < len; i++ ) {
	    delete obj[keys[i]];
	  }
	  return obj;
	}
	
	function $set(value) {
	  return value;
	}
	
	function $splice(splices, arr) {
	  if (false) {
	    assert(list(Arr).is(splices), 'Invalid argument splices supplied to immutability helper { $splice: splices } (expected an array of arrays)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $splice (expected an array)');
	  }
	  return splices.reduce(function (acc, splice) {
	    acc.splice.apply(acc, splice);
	    return acc;
	  }, arr);
	}
	
	function $swap(config, arr) {
	  if (false) {
	    assert(isObject(config), 'Invalid argument config supplied to immutability helper { $swap: config } (expected an object)');
	    assert(isNumber(config.from), 'Invalid argument config.from supplied to immutability helper { $swap: config } (expected a number)');
	    assert(isNumber(config.to), 'Invalid argument config.to supplied to immutability helper { $swap: config } (expected a number)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $swap (expected an array)');
	  }
	  var element = arr[config.to];
	  arr[config.to] = arr[config.from];
	  arr[config.from] = element;
	  return arr;
	}
	
	function $unshift(elements, arr) {
	  if (false) {
	    assert(isArray(elements), 'Invalid argument elements supplied to immutability helper {$unshift: elements} (expected an array)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $unshift (expected an array)');
	  }
	  return elements.concat(arr);
	}
	
	function $merge(obj, value) {
	  return mixin(mixin({}, value), obj, true);
	}
	
	update.commands = {
	  $apply: $apply,
	  $push: $push,
	  $remove: $remove,
	  $set: $set,
	  $splice: $splice,
	  $swap: $swap,
	  $unshift: $unshift,
	  $merge: $merge
	};
	
	function irreducible(name, predicate) {
	
	  if (false) {
	    assert(isString(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to irreducible(name, predicate) (expected a string)'; });
	    assert(isFunction(predicate), 'Invalid argument predicate ' + exports.stringify(predicate) + ' supplied to irreducible(name, predicate) (expected a function)');
	  }
	
	  function Irreducible(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Irreducible);
	      path = path || [name];
	      assert(predicate(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return value;
	  }
	
	  Irreducible.meta = {
	    kind: 'irreducible',
	    name: name,
	    identity: true
	  };
	
	  Irreducible.displayName = name;
	
	  Irreducible.is = predicate;
	
	  return Irreducible;
	}
	
	var Any = irreducible('Any', function () {
	  return true;
	});
	
	var Nil = irreducible('Nil', isNil);
	
	var Str = irreducible('String', isString);
	
	var Num = irreducible('Number', isNumber);
	
	var Bool = irreducible('Boolean', isBoolean);
	
	var Arr = irreducible('Array', isArray);
	
	var Obj = irreducible('Object', isObject);
	
	var Func = irreducible('Function', isFunction);
	
	var Err = irreducible('Error', function (x) {
	  return x instanceof Error;
	});
	
	var Re = irreducible('RegExp', function (x) {
	  return x instanceof RegExp;
	});
	
	var Dat = irreducible('Date', function (x) {
	  return x instanceof Date;
	});
	
	function struct(props, name) {
	
	  if (false) {
	    assert(dict(Str, Func).is(props), function () { return 'Invalid argument props ' + exports.stringify(props) + ' supplied to struct(props, [name]) combinator (expected a dictionary String -> Type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to struct(props, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || struct.getDefaultName(props);
	
	  function Struct(value, path) {
	
	    if (Struct.is(value)) { // implements idempotency
	      return value;
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isObject(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an object)'; });
	    }
	
	    if (!(this instanceof Struct)) { // `new` is optional
	      return new Struct(value);
	    }
	
	    for (var k in props) {
	      if (props.hasOwnProperty(k)) {
	        var expected = props[k];
	        var actual = value[k];
	        this[k] = create(expected, actual, (  false ? path.concat(k + ': ' + getTypeName(expected)) : null ));
	      }
	    }
	
	    if (false) {
	      Object.freeze(this);
	    }
	
	  }
	
	  Struct.meta = {
	    kind: 'struct',
	    props: props,
	    name: name,
	    identity: false
	  };
	
	  Struct.displayName = displayName;
	
	  Struct.is = function (x) {
	    return x instanceof Struct;
	  };
	
	  Struct.update = function (instance, spec) {
	    return new Struct(exports.update(instance, spec));
	  };
	
	  Struct.extend = function (structs, name) {
	    var props = {};
	    var prototype = {};
	    [Struct].concat(structs).forEach(function (struct, i) {
	      if (isObject(struct)) {
	        mixin(props, struct);
	      }
	      else {
	        if (false) {
	          assert(isStruct(struct), function () { return 'Invalid argument structs[' + i + '] ' + exports.stringify(struct) + ' supplied to ' + displayName + '.extend(structs, name)'; });
	        }
	        mixin(props, struct.meta.props);
	        mixin(prototype, struct.prototype);
	      }
	    });
	    var ret = struct(props, name);
	    mixin(ret.prototype, prototype);
	    return ret;
	  };
	
	  return Struct;
	}
	
	struct.getDefaultName = function (props) {
	  return '{' + Object.keys(props).map(function (prop) {
	    return prop + ': ' + getTypeName(props[prop]);
	  }).join(', ') + '}';
	};
	
	function union(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction) && types.length >= 2, function () { return 'Invalid argument types ' + exports.stringify(types) + ' supplied to union(types, [name]) combinator (expected an array of at least 2 types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to union(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || union.getDefaultName(types);
	  var identity = types.every(isIdentity);
	
	  function Union(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value;
	      }
	    }
	
	    var type = Union.dispatch(value);
	    if (!type && Union.is(value)) {
	      return value;
	    }
	
	    if (false) {
	      forbidNewOperator(this, Union);
	      path = path || [displayName];
	      assert(isType(type), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/') + ' (no constructor returned by dispatch)'; });
	      path[path.length - 1] += '(' + getTypeName(type) + ')';
	    }
	
	    return create(type, value, path);
	  }
	
	  Union.meta = {
	    kind: 'union',
	    types: types,
	    name: name,
	    identity: identity
	  };
	
	  Union.displayName = displayName;
	
	  Union.is = function (x) {
	    return types.some(function (type) {
	      return is(x, type);
	    });
	  };
	
	  Union.dispatch = function (x) { // default dispatch implementation
	    for (var i = 0, len = types.length; i < len; i++ ) {
	      var type = types[i];
	      if (isUnion(type)) { // handle union of unions
	        var t = type.dispatch(x);
	        if (!isNil(t)) {
	          return t;
	        }
	      }
	      else if (is(x, type)) {
	        return type;
	      }
	    }
	  };
	
	  Union.update = function (instance, spec) {
	    return Union(exports.update(instance, spec));
	  };
	
	  return Union;
	}
	
	union.getDefaultName = function (types) {
	  return types.map(getTypeName).join(' | ');
	};
	
	function intersection(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction) && types.length >= 2, function () { return 'Invalid argument types ' + exports.stringify(types) + ' supplied to intersection(types, [name]) combinator (expected an array of at least 2 types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to intersection(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || intersection.getDefaultName(types);
	
	  function Intersection(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Intersection);
	      path = path || [displayName];
	      assert(Intersection.is(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return value;
	  }
	
	  Intersection.meta = {
	    kind: 'intersection',
	    types: types,
	    name: name,
	    identity: true
	  };
	
	  Intersection.displayName = displayName;
	
	  Intersection.is = function (x) {
	    return types.every(function (type) {
	      return is(x, type);
	    });
	  };
	
	  Intersection.update = function (instance, spec) {
	    return Intersection(exports.update(instance, spec));
	  };
	
	  return Intersection;
	}
	
	intersection.getDefaultName = function (types) {
	  return types.map(getTypeName).join(' & ');
	};
	
	function maybe(type, name) {
	
	  if (isMaybe(type) || type === Any || type === Nil) { // makes the combinator idempotent and handle Any, Nil
	    return type;
	  }
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + exports.stringify(type) + ' supplied to maybe(type, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to maybe(type, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || maybe.getDefaultName(type);
	
	  function Maybe(value, path) {
	    if (false) {
	      forbidNewOperator(this, Maybe);
	    }
	    return isNil(value) ? null : create(type, value, path);
	  }
	
	  Maybe.meta = {
	    kind: 'maybe',
	    type: type,
	    name: name,
	    identity: isIdentity(type)
	  };
	
	  Maybe.displayName = displayName;
	
	  Maybe.is = function (x) {
	    return isNil(x) || is(x, type);
	  };
	
	  return Maybe;
	}
	
	maybe.getDefaultName = function (type) {
	  return '?' + getTypeName(type);
	};
	
	function enums(map, name) {
	
	  if (false) {
	    assert(isObject(map), function () { return 'Invalid argument map ' + exports.stringify(map) + ' supplied to enums(map, [name]) combinator (expected a dictionary of String -> String | Number)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to enums(map, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || enums.getDefaultName(map);
	
	  function Enums(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Enums);
	      path = path || [displayName];
	      assert(Enums.is(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/') + ' (expected one of ' + exports.stringify(Object.keys(map)) + ')'; });
	    }
	
	    return value;
	  }
	
	  Enums.meta = {
	    kind: 'enums',
	    map: map,
	    name: name,
	    identity: true
	  };
	
	  Enums.displayName = displayName;
	
	  Enums.is = function (x) {
	    return map.hasOwnProperty(x);
	  };
	
	  return Enums;
	}
	
	enums.getDefaultName = function (map) {
	  return Object.keys(map).map(function (k) { return exports.stringify(k); }).join(' | ');
	};
	
	enums.of = function (keys, name) {
	  keys = isString(keys) ? keys.split(' ') : keys;
	  var value = {};
	  keys.forEach(function (k) {
	    value[k] = k;
	  });
	  return enums(value, name);
	};
	
	function tuple(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction), function () { return 'Invalid argument types ' + exports.stringify(types) + ' supplied to tuple(types, [name]) combinator (expected an array of types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to tuple(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || tuple.getDefaultName(types);
	  var identity = types.every(isIdentity);
	
	  function Tuple(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value;
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isArray(value) && value.length === types.length, function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an array of length ' + types.length + ')'; });
	    }
	
	    var idempotent = true;
	    var ret = [];
	    for (var i = 0, len = types.length; i < len; i++) {
	      var expected = types[i];
	      var actual = value[i];
	      var instance = create(expected, actual, (  false ? path.concat(i + ': ' + getTypeName(expected)) : null ));
	      idempotent = idempotent && ( actual === instance );
	      ret.push(instance);
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  Tuple.meta = {
	    kind: 'tuple',
	    types: types,
	    name: name,
	    identity: identity
	  };
	
	  Tuple.displayName = displayName;
	
	  Tuple.is = function (x) {
	    return isArray(x) &&
	      x.length === types.length &&
	      types.every(function (type, i) {
	        return is(x[i], type);
	      });
	  };
	
	  Tuple.update = function (instance, spec) {
	    return Tuple(exports.update(instance, spec));
	  };
	
	  return Tuple;
	}
	
	tuple.getDefaultName = function (types) {
	  return '[' + types.map(getTypeName).join(', ') + ']';
	};
	
	function refinement(type, predicate, name) {
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + exports.stringify(type) + ' supplied to refinement(type, predicate, [name]) combinator (expected a type)'; });
	    assert(isFunction(predicate), function () { return 'Invalid argument predicate supplied to refinement(type, predicate, [name]) combinator (expected a function)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to refinement(type, predicate, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || refinement.getDefaultName(type, predicate);
	  var identity = isIdentity(type);
	
	  function Refinement(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Refinement);
	      path = path || [displayName];
	    }
	
	    var x = create(type, value, path);
	
	    if (false) {
	      assert(predicate(x), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return x;
	  }
	
	  Refinement.meta = {
	    kind: 'subtype',
	    type: type,
	    predicate: predicate,
	    name: name,
	    identity: identity
	  };
	
	  Refinement.displayName = displayName;
	
	  Refinement.is = function (x) {
	    return is(x, type) && predicate(x);
	  };
	
	  Refinement.update = function (instance, spec) {
	    return Refinement(exports.update(instance, spec));
	  };
	
	  return Refinement;
	}
	
	refinement.getDefaultName = function (type, predicate) {
	  return '{' + getTypeName(type) + ' | ' + getFunctionName(predicate) + '}';
	};
	
	function list(type, name) {
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + exports.stringify(type) + ' supplied to list(type, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to list(type, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || list.getDefaultName(type);
	  var typeNameCache = getTypeName(type);
	  var identity = isIdentity(type); // the list is identity iif type is identity
	
	  function List(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value; // just trust the input if elements must not be hydrated
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isArray(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an array of ' + typeNameCache + ')'; });
	    }
	
	    var idempotent = true; // will remain true if I can reutilise the input
	    var ret = []; // make a temporary copy, will be discarded if idempotent remains true
	    for (var i = 0, len = value.length; i < len; i++ ) {
	      var actual = value[i];
	      var instance = create(type, actual, (  false ? path.concat(i + ': ' + typeNameCache) : null ));
	      idempotent = idempotent && ( actual === instance );
	      ret.push(instance);
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  List.meta = {
	    kind: 'list',
	    type: type,
	    name: name,
	    identity: identity
	  };
	
	  List.displayName = displayName;
	
	  List.is = function (x) {
	    return isArray(x) && x.every(function (e) {
	      return is(e, type);
	    });
	  };
	
	  List.update = function (instance, spec) {
	    return List(exports.update(instance, spec));
	  };
	
	  return List;
	}
	
	list.getDefaultName = function (type) {
	  return 'Array<' + getTypeName(type) + '>';
	};
	
	function dict(domain, codomain, name) {
	
	  if (false) {
	    assert(isFunction(domain), function () { return 'Invalid argument domain ' + exports.stringify(domain) + ' supplied to dict(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isFunction(codomain), function () { return 'Invalid argument codomain ' + exports.stringify(codomain) + ' supplied to dict(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to dict(domain, codomain, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || dict.getDefaultName(domain, codomain);
	  var domainNameCache = getTypeName(domain);
	  var codomainNameCache = getTypeName(codomain);
	  var identity = isIdentity(domain) && isIdentity(codomain);
	
	  function Dict(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value; // just trust the input if elements must not be hydrated
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isObject(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    var idempotent = true; // will remain true if I can reutilise the input
	    var ret = {}; // make a temporary copy, will be discarded if idempotent remains true
	    for (var k in value) {
	      if (value.hasOwnProperty(k)) {
	        k = create(domain, k, (  false ? path.concat(domainNameCache) : null ));
	        var actual = value[k];
	        var instance = create(codomain, actual, (  false ? path.concat(k + ': ' + codomainNameCache) : null ));
	        idempotent = idempotent && ( actual === instance );
	        ret[k] = instance;
	      }
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  Dict.meta = {
	    kind: 'dict',
	    domain: domain,
	    codomain: codomain,
	    name: name,
	    identity: identity
	  };
	
	  Dict.displayName = displayName;
	
	  Dict.is = function (x) {
	    if (!isObject(x)) {
	      return false;
	    }
	    for (var k in x) {
	      if (x.hasOwnProperty(k)) {
	        if (!is(k, domain) || !is(x[k], codomain)) {
	          return false;
	        }
	      }
	    }
	    return true;
	  };
	
	  Dict.update = function (instance, spec) {
	    return Dict(exports.update(instance, spec));
	  };
	
	  return Dict;
	}
	
	dict.getDefaultName = function (domain, codomain) {
	  return '{[key: ' + getTypeName(domain) + ']: ' + getTypeName(codomain) + '}';
	};
	
	function isInstrumented(f) {
	  return isFunction(f) && isObject(f.instrumentation);
	}
	
	function func(domain, codomain, name) {
	
	  domain = isArray(domain) ? domain : [domain]; // handle handy syntax for unary functions
	
	  if (false) {
	    assert(list(Func).is(domain), function () { return 'Invalid argument domain ' + exports.stringify(domain) + ' supplied to func(domain, codomain, [name]) combinator (expected an array of types)'; });
	    assert(isFunction(codomain), function () { return 'Invalid argument codomain ' + exports.stringify(codomain) + ' supplied to func(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + exports.stringify(name) + ' supplied to func(domain, codomain, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || func.getDefaultName(domain, codomain);
	
	  function FuncType(value, curried) {
	
	    if (!isInstrumented(value)) { // automatically instrument the function
	      return FuncType.of(value, curried);
	    }
	
	    if (false) {
	      assert(FuncType.is(value), function () { return 'Invalid value ' + exports.stringify(value) + ' supplied to ' + displayName; });
	    }
	
	    return value;
	  }
	
	  FuncType.meta = {
	    kind: 'func',
	    domain: domain,
	    codomain: codomain,
	    name: name
	  };
	
	  FuncType.displayName = displayName;
	
	  FuncType.is = function (x) {
	    return isInstrumented(x) &&
	      x.instrumentation.domain.length === domain.length &&
	      x.instrumentation.domain.every(function (type, i) {
	        return type === domain[i];
	      }) &&
	      x.instrumentation.codomain === codomain;
	  };
	
	  FuncType.of = function (f, curried) {
	
	    if (false) {
	      assert(isFunction(f), function () { return 'Invalid argument f supplied to func.of ' + displayName + ' (expected a function)'; });
	      assert(isNil(curried) || isBoolean(curried), function () { return 'Invalid argument curried ' + exports.stringify(curried) + ' supplied to func.of ' + displayName + ' (expected a boolean)'; });
	    }
	
	    if (FuncType.is(f)) { // makes FuncType.of idempotent
	      return f;
	    }
	
	    function fn() {
	      var args = Array.prototype.slice.call(arguments);
	      var len = curried ?
	        args.length :
	        domain.length;
	      var argsType = tuple(domain.slice(0, len));
	
	      args = argsType(args); // type check arguments
	
	      if (len === domain.length) {
	        return create(codomain, f.apply(this, args));
	      }
	      else {
	        var g = Function.prototype.bind.apply(f, [this].concat(args));
	        var newdomain = func(domain.slice(len), codomain);
	        return newdomain.of(g, curried);
	      }
	    }
	
	    fn.instrumentation = {
	      domain: domain,
	      codomain: codomain,
	      f: f
	    };
	
	    fn.displayName = getFunctionName(f);
	
	    return fn;
	
	  };
	
	  return FuncType;
	
	}
	
	func.getDefaultName = function (domain, codomain) {
	  return '(' + domain.map(getTypeName).join(', ') + ') => ' + getTypeName(codomain);
	};
	
	function match(x) {
	  var type, guard, f, count;
	  for (var i = 1, len = arguments.length; i < len; ) {
	    type = arguments[i];
	    guard = arguments[i + 1];
	    f = arguments[i + 2];
	
	    if (isFunction(f) && !isType(f)) {
	      i = i + 3;
	    }
	    else {
	      f = guard;
	      guard = Any.is;
	      i = i + 2;
	    }
	
	    if (false) {
	      count = (count || 0) + 1;
	      assert(isType(type), function () { return 'Invalid type in clause #' + count; });
	      assert(isFunction(guard), function () { return 'Invalid guard in clause #' + count; });
	      assert(isFunction(f), function () { return 'Invalid block in clause #' + count; });
	    }
	
	    if (type.is(x) && guard(x)) {
	      return f(x);
	    }
	  }
	  exports.fail('Match error');
	}
	
	mixin(exports, {
	  is: is,
	  isType: isType,
	  getTypeName: getTypeName,
	  mixin: mixin,
	  update: update,
	  assert: assert,
	  Any: Any,
	  Nil: Nil,
	  Str: Str, // deprecated
	  String: Str,
	  Num: Num, // deprecated
	  Number: Num,
	  Bool: Bool, // deprecated
	  Boolean: Bool,
	  Arr: Arr, // deprecated
	  Array: Arr,
	  Obj: Obj, // deprecated
	  Object: Obj,
	  Func: Func, // deprecated
	  Function: Func,
	  Err: Err, // deprecated
	  Error: Err,
	  Re: Re, // deprecated
	  RegExp: Re,
	  Dat: Dat, // deprecated
	  Date: Dat,
	  irreducible: irreducible,
	  struct: struct,
	  enums: enums,
	  union: union,
	  maybe: maybe,
	  tuple: tuple,
	  subtype: refinement, // deprecated
	  refinement: refinement,
	  list: list,
	  dict: dict,
	  func: func,
	  intersection: intersection,
	  match: match
	});


/***/ },
/* 2 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = React;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = ReactDOM;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _endpoint = __webpack_require__(6);
	
	var Server = (function () {
	  function Server(api_url) {
	    _classCallCheck(this, Server);
	
	    _tcomb2['default'].assert(_tcomb2['default'].Str.is(api_url));
	    this.api_url = api_url;
	  }
	
	  _createClass(Server, [{
	    key: 'doLogin',
	    value: function doLogin(_ref, callback) {
	      var email = _ref.email;
	      var password = _ref.password;
	
	      (0, _endpoint.post)({
	        url: this.api_url + 'user/login',
	        payload: { emailAddress: email, password: password }
	      }, callback);
	    }
	  }, {
	    key: 'doLogout',
	    value: function doLogout(callback) {
	      (0, _endpoint.post)({
	        url: this.api_url + 'user/logout'
	      }, callback);
	    }
	  }, {
	    key: 'doResendPassword',
	    value: function doResendPassword(_ref2, callback) {
	      var email = _ref2.email;
	
	      (0, _endpoint.post)({
	        url: this.api_url + 'user/password/reset',
	        payload: { emailAddress: email }
	      }, callback);
	    }
	  }, {
	    key: 'doChangePassword',
	    value: function doChangePassword(_ref3, callback) {
	      var old_password = _ref3.old_password;
	      var new_password = _ref3.new_password;
	
	      (0, _endpoint.post)({
	        url: this.api_url + 'user/password',
	        payload: { oldPassword: old_password, newPassword: new_password }
	      }, callback);
	    }
	  }, {
	    key: 'doUpdateAccount',
	    value: function doUpdateAccount(_ref4, callback) {
	      var name = _ref4.name;
	      var surname = _ref4.surname;
	      var gender = _ref4.gender;
	      var birth_date = _ref4.birth_date;
	      var country = _ref4.country;
	      var district = _ref4.district;
	      var zip = _ref4.zip;
	      var com_locale = _ref4.com_locale;
	
	      (0, _endpoint.post)({
	        url: this.api_url + 'user',
	        payload: { name: name, surname: surname, gender: gender, birth_date: birth_date, country: country, district: district, zip: zip, com_locale: com_locale }
	      }, callback);
	    }
	  }, {
	    key: 'loadPurchases',
	    value: function loadPurchases(callback) {
	      (0, _endpoint.get)({ url: this.api_url + 'user/orders' }, callback);
	    }
	  }, {
	    key: 'loadPurchase',
	    value: function loadPurchase(_ref5, callback) {
	      var purchase_id = _ref5.purchase_id;
	      var target = _ref5.target;
	      var cancel_target = _ref5.cancel_target;
	
	      (0, _endpoint.get)({ url: this.api_url + 'order/' + purchase_id + '?target=' + target + '&cancel_target=' + cancel_target }, callback);
	    }
	  }, {
	    key: 'doSendGiftCardCode',
	    value: function doSendGiftCardCode(_ref6, callback) {
	      var purchase_id = _ref6.purchase_id;
	      var target = _ref6.target;
	      var cancel_target = _ref6.cancel_target;
	      var gift_card_code = _ref6.gift_card_code;
	
	      (0, _endpoint.post)({
	        url: this.api_url + 'order/' + purchase_id + '/giftcard',
	        payload: { gift_card_code: gift_card_code, target: target, cancel_target: cancel_target }
	      }, callback);
	    }
	  }, {
	    key: 'loadFacebook',
	    value: function loadFacebook(_ref7, callback) {
	      var target = _ref7.target;
	      var locale = _ref7.locale;
	
	      (0, _endpoint.post)({
	        url: this.api_url + 'user/login/facebook',
	        payload: { target: target, com_locale: locale }
	      }, callback);
	    }
	  }, {
	    key: 'loadGoogle',
	    value: function loadGoogle(_ref8, callback) {
	      var target = _ref8.target;
	      var locale = _ref8.locale;
	
	      (0, _endpoint.post)({
	        url: this.api_url + 'user/login/google',
	        payload: { target: target, com_locale: locale }
	      }, callback);
	    }
	  }, {
	    key: 'loadTwitter',
	    value: function loadTwitter(_ref9, callback) {
	      var target = _ref9.target;
	      var locale = _ref9.locale;
	
	      (0, _endpoint.post)({
	        url: this.api_url + 'user/login/twitter',
	        payload: { target: target, com_locale: locale }
	      }, callback);
	    }
	  }, {
	    key: 'loadMicrosoft',
	    value: function loadMicrosoft(_ref10, callback) {
	      var target = _ref10.target;
	      var locale = _ref10.locale;
	
	      (0, _endpoint.post)({
	        url: this.api_url + 'user/login/microsoft',
	        payload: { target: target, com_locale: locale }
	      }, callback);
	    }
	  }]);
	
	  return Server;
	})();
	
	exports['default'] = Server;
	module.exports = exports['default'];

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.post = post;
	exports.get = get;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _superagent = __webpack_require__(7);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	/*
	
	  the madai convention in order to handle a server error is to return a 500 HTTP error and a JSON
	  payload with the following format
	
	  {
	    "error": "<error code>"
	  }
	
	*/
	
	function createError(res) {
	  if (!res.body) {
	    return new Error(res.statusText);
	  }
	  return new Error(res.body.error);
	}
	
	function createSuperagentEndCallback(nodeStyleCallback) {
	  return function (_, res) {
	    if (res.ok) {
	      nodeStyleCallback(null, res.body);
	    } else {
	      nodeStyleCallback(createError(res));
	    }
	  };
	}
	
	var noobj = {};
	
	function post(_ref, callback) {
	  var url = _ref.url;
	  var _ref$query = _ref.query;
	  var query = _ref$query === undefined ? noobj : _ref$query;
	  var _ref$payload = _ref.payload;
	  var payload = _ref$payload === undefined ? noobj : _ref$payload;
	  var _ref$type = _ref.type;
	  var type = _ref$type === undefined ? 'form' : _ref$type;
	
	  _superagent2['default'].post(url).accept('json').type(type).query(query).send(payload).end(createSuperagentEndCallback(callback));
	}
	
	function get(_ref2, callback) {
	  var url = _ref2.url;
	  var _ref2$query = _ref2.query;
	  var query = _ref2$query === undefined ? noobj : _ref2$query;
	
	  _superagent2['default'].get(url).accept('json').type('json').query(query).end(createSuperagentEndCallback(callback));
	}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(8);
	var reduce = __webpack_require__(9);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  root = this;
	}
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return obj === Object(obj);
	}
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(obj[key]));
	    }
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Force given parser
	 * 
	 * Sets the body parser no matter type.
	 * 
	 * @param {Function}
	 * @api public
	 */
	
	Response.prototype.parse = function(fn){
	  this.parser = fn;
	  return this;
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = this.parser || request.parse[this.type];
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  Emitter.call(this);
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {};
	  this._header = {};
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Allow for extension
	 */
	
	Request.prototype.use = function(fn) {
	  fn(this);
	  return this;
	}
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.timeout = function(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.clearTimeout = function(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 */
	
	Request.prototype.getHeader = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass){
	  var str = btoa(user + ':' + pass);
	  this.set('Authorization', 'Basic ' + str);
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.field = function(name, val){
	  if (!this._formData) this._formData = new root.FormData();
	  this._formData.append(name, val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  if (!this._formData) this._formData = new root.FormData();
	  this._formData.append(field, file, filename);
	  return this;
	};
	
	/**
	 * Send `data`, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // querystring
	 *       request.get('/search')
	 *         .end(callback)
	 *
	 *       // multiple data "writes"
	 *       request.get('/search')
	 *         .send({ search: 'query' })
	 *         .send({ range: '1..5' })
	 *         .send({ order: 'desc' })
	 *         .end(callback)
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"})
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this.getHeader('Content-Type');
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this.getHeader('Content-Type');
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Origin is not allowed by Access-Control-Allow-Origin');
	  err.crossDomain = true;
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  xhr.open(this.method, this.url, true);
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var contentType = this.getHeader('Content-Type');
	    var serialize = request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  // send stuff
	  this.emit('request', this);
	  xhr.send(data);
	  return this;
	};
	
	/**
	 * Faux promise support
	 *
	 * @param {Function} fulfill
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	Request.prototype.then = function (fulfill, reject) {
	  return this.end(function(err, res) {
	    err ? reject(err) : fulfill(res);
	  });
	}
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new Request('GET', method);
	  }
	
	  return new Request(method, url);
	}
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.del = function(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * Expose `request`.
	 */
	
	module.exports = request;


/***/ },
/* 8 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 9 */
/***/ function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = buildHeightNotifier;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _querystring = __webpack_require__(11);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _isModal = __webpack_require__(14);
	
	var _isModal2 = _interopRequireDefault(_isModal);
	
	var _isPostMessageSupported = __webpack_require__(15);
	
	var _isPostMessageSupported2 = _interopRequireDefault(_isPostMessageSupported);
	
	var _lodashUtilityNoop = __webpack_require__(16);
	
	var _lodashUtilityNoop2 = _interopRequireDefault(_lodashUtilityNoop);
	
	// comunica con il container quando l'applicazione è ospitata in una modale
	// e se il container supporta l'api postMessage()
	
	function buildHeightNotifier(app) {
	
	  var do_post = (0, _isPostMessageSupported2['default'])() && (0, _isModal2['default'])();
	
	  if (!do_post) {
	    return _lodashUtilityNoop2['default'];
	  }
	
	  var height = undefined;
	
	  return function () {
	
	    // controllo se c'è una modale aperta
	    var modalContainer = document.getElementById('modal-container');
	
	    var do_scroll = document.getElementById('modal-container') && modalContainer.getAttribute("scroll") !== "sent";
	
	    if (document.getElementById('modal-container')) {
	      modalContainer.setAttribute("scroll", "sent");
	    }
	
	    var new_height = document.body.clientHeight;
	    if (new_height !== height) {
	      var message = _querystring2['default'].stringify({
	        current_module: app.route.name,
	        height: new_height,
	        do_scroll: do_scroll
	      });
	      window.top.postMessage(message, '*');
	      height = new_height;
	    }
	  };
	}

	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(12);
	exports.encode = exports.stringify = __webpack_require__(13);


/***/ },
/* 12 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};


/***/ },
/* 13 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return map(objectKeys(obj), function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (isArray(obj[k])) {
	        return map(obj[k], function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	function map (xs, f) {
	  if (xs.map) return xs.map(f);
	  var res = [];
	  for (var i = 0; i < xs.length; i++) {
	    res.push(f(xs[i], i));
	  }
	  return res;
	}
	
	var objectKeys = Object.keys || function (obj) {
	  var res = [];
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	  }
	  return res;
	};


/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isModal;
	
	function isModal() {
	  return window !== window.top;
	}

	module.exports = exports["default"];

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = isPostMessageSupported;
	
	function isPostMessageSupported() {
	  return typeof window.top.postMessage !== 'undefined';
	}

	module.exports = exports['default'];

/***/ },
/* 16 */
/***/ function(module, exports) {

	/**
	 * A no-operation function that returns `undefined` regardless of the
	 * arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.noop(object) === undefined;
	 * // => true
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Natural = __webpack_require__(18);
	
	var _Natural2 = _interopRequireDefault(_Natural);
	
	var _Locale_Iso = __webpack_require__(20);
	
	var _Locale_Iso2 = _interopRequireDefault(_Locale_Iso);
	
	var _Language = __webpack_require__(21);
	
	var _Language2 = _interopRequireDefault(_Language);
	
	var _Country = __webpack_require__(22);
	
	var _Country2 = _interopRequireDefault(_Country);
	
	var _Datetime = __webpack_require__(23);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _utilFormatNumber = __webpack_require__(58);
	
	var _utilFormatNumber2 = _interopRequireDefault(_utilFormatNumber);
	
	var _Number_Format = __webpack_require__(59);
	
	var _Number_Format2 = _interopRequireDefault(_Number_Format);
	
	var Locale = _tcomb2['default'].struct({
	  language: _Language2['default'],
	  country: _Country2['default']
	}, 'Locale');
	
	Locale.of = function (iso) {
	  iso = (0, _Locale_Iso2['default'])(iso);
	
	  var _iso$split = iso.split('_');
	
	  var _iso$split2 = _slicedToArray(_iso$split, 2);
	
	  var language = _iso$split2[0];
	  var country = _iso$split2[1];
	
	  return Locale({ language: language, country: country });
	};
	
	Locale.prototype.toJSON = Locale.prototype.toString = function () {
	  return this.language + '_' + this.country;
	};
	
	// il bundle di localizzazione serve per formattare numeri, date e valute
	Locale.prototype.locale_bundle = function () {
	  var ret = function () {
	    return window.require('io/' + this);
	  }.call(this);
	
	  return _tcomb2['default'].Object(ret);
	};
	
	// il bundle di internazionalizzazione
	// Serve per tradurre le regole di validazione di una form, tradurre i paesi
	// e le lingue
	Locale.prototype.language_bundle = function () {
	  var ret = function () {
	    return window.require('io/' + this.language);
	  }.call(this);
	
	  return _tcomb2['default'].Object(ret);
	};
	
	Locale.prototype.display_country = function (country) {
	  country = (0, _Country2['default'])(country);
	
	  var ret = function (country) {
	    return this.language_bundle().country[country];
	  }.call(this, country);
	
	  return _tcomb2['default'].String(ret);
	};
	
	Locale.prototype.display_language = function (language) {
	  language = (0, _Language2['default'])(language);
	
	  var ret = function (language) {
	    return this.language_bundle().language[language];
	  }.call(this, language);
	
	  return _tcomb2['default'].String(ret);
	};
	
	Locale.prototype.to_number_format = function (opt_digits) {
	  opt_digits = _tcomb2['default'].maybe(_Natural2['default'])(opt_digits);
	
	  var bundle = this.locale_bundle().number;
	  return new _Number_Format2['default']({
	    decimal_symbol: bundle.decimal_symbol,
	    digits: _tcomb2['default'].Nil.is(opt_digits) ? bundle.digits : opt_digits,
	    grouping_symbol: bundle.grouping_symbol,
	    infinity: bundle.infinity,
	    negative_suffix: bundle.negative_suffix,
	    positive_suffix: bundle.positive_suffix
	  });
	};
	
	Locale.prototype.format_date = function (millis, is_accurate) {
	  is_accurate = _tcomb2['default'].maybe(_tcomb2['default'].Boolean)(is_accurate);
	
	  var bundle = this.locale_bundle().date;
	  var pattern = is_accurate ? bundle.accurate : bundle['short'];
	  return _Datetime2['default'].format(millis, pattern);
	};
	
	Locale.prototype.format_number = function (n, digits) {
	  n = _tcomb2['default'].Number(n);
	  digits = _tcomb2['default'].maybe(_Natural2['default'])(digits);
	
	  return (0, _utilFormatNumber2['default'])(n, this.to_number_format(digits));
	};
	
	Locale.prototype.format_integer = function (n) {
	  n = _tcomb2['default'].Number(n);
	
	  return this.format_number(n, 0);
	};
	
	Locale.prototype.parse_number = function (n) {
	  n = _tcomb2['default'].Number(n);
	
	  return this.to_number_format().parse_number(n);
	};
	
	Locale.prototype.getTcombFormDateOrder = function () {
	  return this.locale_bundle().date.order.map(function (part) {
	    if (part === 'DD') {
	      return 'D';
	    }
	    if (part === 'MM') {
	      return 'M';
	    }
	    return part;
	  });
	};
	
	module.exports = Locale;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Int = __webpack_require__(19);
	
	var _Int2 = _interopRequireDefault(_Int);
	
	var Natural = _tcomb2['default'].refinement(_Int2['default'], function (n) {
	  return n >= 0;
	});
	
	exports['default'] = Natural;
	module.exports = exports['default'];

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function is_integer(n) {
	  return n === parseInt(n, 10);
	}
	
	var Int = _tcomb2['default'].subtype(_tcomb2['default'].Num, is_integer);
	
	module.exports = Int;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Language = __webpack_require__(21);
	
	var _Language2 = _interopRequireDefault(_Language);
	
	var _Country = __webpack_require__(22);
	
	var _Country2 = _interopRequireDefault(_Country);
	
	var Locale_Iso = _tcomb2['default'].subtype(_tcomb2['default'].Str, function (x) {
	  var parts = x.split('_');
	  return _Language2['default'].is(parts[0]) && _Country2['default'].is(parts[1]);
	});
	
	module.exports = Locale_Iso;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Language = _tcomb2['default'].enums.of(['it', 'en', 'fr', 'es', 'de', 'pt']);
	
	module.exports = Language;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Country = _tcomb2['default'].enums.of(['AT', 'AU', 'BE', 'BR', 'CA', 'CH', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'IE', 'IT', 'LU', 'MC', 'NL', 'NO', 'PL', 'PT', 'SE', 'TR', 'US', 'ZA']);
	
	module.exports = Country;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Int = __webpack_require__(19);
	
	var _Int2 = _interopRequireDefault(_Int);
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _simpleFormatDate = __webpack_require__(24);
	
	var _simpleFormatDate2 = _interopRequireDefault(_simpleFormatDate);
	
	var Datetime = _tcomb2['default'].refinement(_Int2['default'], function () {
	  return true;
	}, 'Datetime');
	
	Datetime.format = function (millis, template) {
	  millis = Datetime(millis);
	  template = _tcomb2['default'].String(template);
	
	  return (0, _simpleFormatDate2['default'])(new Date(millis), { template: template });
	};
	
	exports['default'] = Datetime;
	module.exports = exports['default'];

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var template = __webpack_require__(25);
	
	var templates = {};
	
	function padLeft(x, len) {
	  var s = x + '';
	  var times = len - s.length;
	  for (var i = 0 ; i < times ; i++ ) {
	    s = '0' + s;
	  }
	  return s;
	}
	
	function splitDate(date) {
	  var YY = date.getFullYear();
	  var M = date.getMonth() + 1;
	  var D = date.getDate();
	  var h = date.getHours();
	  var m = date.getMinutes();
	  return {
	    Y: String(YY).substr(-2),   // short year (15 for 2015)
	    YY: YY,                     // numeric long year
	    M: M,                       // numeric month (9 for September)
	    MM: padLeft(M, 2),          // padded month ('09' for September)
	    D: D,                       // numeric day
	    DD: padLeft(D, 2),          // padded day
	    h: h,                       // numeric hours
	    hh: padLeft(h, 2),          // padded hours
	    m: m,                       // numeric minutes
	    mm: padLeft(m, 2)           // padded minutes
	  };
	}
	
	function shallowCopy(a, b) {
	  if (b) {
	    for (var k in b) {
	      if (b.hasOwnProperty(k)) {
	        a[k] = b[k];
	      }
	    }
	  }
	  return a;
	}
	
	function getOptions(options) {
	  var defaults = {
	    template: '<%= MM %>/<%= DD %>/<%= YY %>'
	  };
	  return shallowCopy(defaults, options);
	}
	
	function formatDate(d, options) {
	  options = getOptions(options);
	  var formatter = options.template;
	  if (typeof formatter === 'string') {
	    // compile the template just once
	    formatter = ( templates[formatter] = templates[formatter] || template(formatter) );
	  }
	  return formatter(splitDate(d));
	}
	
	module.exports = formatDate;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var assignOwnDefaults = __webpack_require__(26),
	    assignWith = __webpack_require__(27),
	    attempt = __webpack_require__(43),
	    baseAssign = __webpack_require__(46),
	    baseToString = __webpack_require__(48),
	    baseValues = __webpack_require__(49),
	    escapeStringChar = __webpack_require__(50),
	    isError = __webpack_require__(44),
	    isIterateeCall = __webpack_require__(51),
	    keys = __webpack_require__(28),
	    reInterpolate = __webpack_require__(52),
	    templateSettings = __webpack_require__(53);
	
	/** Used to match empty string literals in compiled template source. */
	var reEmptyStringLeading = /\b__p \+= '';/g,
	    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	/** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	/** Used to ensure capturing order of template delimiters. */
	var reNoMatch = /($^)/;
	
	/** Used to match unescaped characters in compiled string literals. */
	var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	/**
	 * Creates a compiled template function that can interpolate data properties
	 * in "interpolate" delimiters, HTML-escape interpolated data properties in
	 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	 * properties may be accessed as free variables in the template. If a setting
	 * object is provided it takes precedence over `_.templateSettings` values.
	 *
	 * **Note:** In the development build `_.template` utilizes
	 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	 * for easier debugging.
	 *
	 * For more information on precompiling templates see
	 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	 *
	 * For more information on Chrome extension sandboxes see
	 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The template string.
	 * @param {Object} [options] The options object.
	 * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	 * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	 * @param {Object} [options.imports] An object to import into the template as free variables.
	 * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	 * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	 * @param {string} [options.variable] The data object variable name.
	 * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	 * @returns {Function} Returns the compiled template function.
	 * @example
	 *
	 * // using the "interpolate" delimiter to create a compiled template
	 * var compiled = _.template('hello <%= user %>!');
	 * compiled({ 'user': 'fred' });
	 * // => 'hello fred!'
	 *
	 * // using the HTML "escape" delimiter to escape data property values
	 * var compiled = _.template('<b><%- value %></b>');
	 * compiled({ 'value': '<script>' });
	 * // => '<b>&lt;script&gt;</b>'
	 *
	 * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	 * compiled({ 'users': ['fred', 'barney'] });
	 * // => '<li>fred</li><li>barney</li>'
	 *
	 * // using the internal `print` function in "evaluate" delimiters
	 * var compiled = _.template('<% print("hello " + user); %>!');
	 * compiled({ 'user': 'barney' });
	 * // => 'hello barney!'
	 *
	 * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	 * var compiled = _.template('hello ${ user }!');
	 * compiled({ 'user': 'pebbles' });
	 * // => 'hello pebbles!'
	 *
	 * // using custom template delimiters
	 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	 * var compiled = _.template('hello {{ user }}!');
	 * compiled({ 'user': 'mustache' });
	 * // => 'hello mustache!'
	 *
	 * // using backslashes to treat delimiters as plain text
	 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	 * compiled({ 'value': 'ignored' });
	 * // => '<%- value %>'
	 *
	 * // using the `imports` option to import `jQuery` as `jq`
	 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	 * compiled({ 'users': ['fred', 'barney'] });
	 * // => '<li>fred</li><li>barney</li>'
	 *
	 * // using the `sourceURL` option to specify a custom sourceURL for the template
	 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	 * compiled(data);
	 * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	 *
	 * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	 * compiled.source;
	 * // => function(data) {
	 * //   var __t, __p = '';
	 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	 * //   return __p;
	 * // }
	 *
	 * // using the `source` property to inline compiled templates for meaningful
	 * // line numbers in error messages and a stack trace
	 * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	 *   var JST = {\
	 *     "main": ' + _.template(mainText).source + '\
	 *   };\
	 * ');
	 */
	function template(string, options, otherOptions) {
	  // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	  var settings = templateSettings.imports._.templateSettings || templateSettings;
	
	  if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	    options = otherOptions = undefined;
	  }
	  string = baseToString(string);
	  options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	  var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	      importsKeys = keys(imports),
	      importsValues = baseValues(imports, importsKeys);
	
	  var isEscaping,
	      isEvaluating,
	      index = 0,
	      interpolate = options.interpolate || reNoMatch,
	      source = "__p += '";
	
	  // Compile the regexp to match each delimiter.
	  var reDelimiters = RegExp(
	    (options.escape || reNoMatch).source + '|' +
	    interpolate.source + '|' +
	    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	    (options.evaluate || reNoMatch).source + '|$'
	  , 'g');
	
	  // Use a sourceURL for easier debugging.
	  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';
	
	  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	    interpolateValue || (interpolateValue = esTemplateValue);
	
	    // Escape characters that can't be included in string literals.
	    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	    // Replace delimiters with snippets.
	    if (escapeValue) {
	      isEscaping = true;
	      source += "' +\n__e(" + escapeValue + ") +\n'";
	    }
	    if (evaluateValue) {
	      isEvaluating = true;
	      source += "';\n" + evaluateValue + ";\n__p += '";
	    }
	    if (interpolateValue) {
	      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	    }
	    index = offset + match.length;
	
	    // The JS engine embedded in Adobe products requires returning the `match`
	    // string in order to produce the correct `offset` value.
	    return match;
	  });
	
	  source += "';\n";
	
	  // If `variable` is not specified wrap a with-statement around the generated
	  // code to add the data object to the top of the scope chain.
	  var variable = options.variable;
	  if (!variable) {
	    source = 'with (obj) {\n' + source + '\n}\n';
	  }
	  // Cleanup code by stripping empty strings.
	  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	    .replace(reEmptyStringMiddle, '$1')
	    .replace(reEmptyStringTrailing, '$1;');
	
	  // Frame code as the function body.
	  source = 'function(' + (variable || 'obj') + ') {\n' +
	    (variable
	      ? ''
	      : 'obj || (obj = {});\n'
	    ) +
	    "var __t, __p = ''" +
	    (isEscaping
	       ? ', __e = _.escape'
	       : ''
	    ) +
	    (isEvaluating
	      ? ', __j = Array.prototype.join;\n' +
	        "function print() { __p += __j.call(arguments, '') }\n"
	      : ';\n'
	    ) +
	    source +
	    'return __p\n}';
	
	  var result = attempt(function() {
	    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	  });
	
	  // Provide the compiled function's source by its `toString` method or
	  // the `source` property as a convenience for inlining compiled templates.
	  result.source = source;
	  if (isError(result)) {
	    throw result;
	  }
	  return result;
	}
	
	module.exports = template;


/***/ },
/* 26 */
/***/ function(module, exports) {

	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.template` to customize its `_.assign` use.
	 *
	 * **Note:** This function is like `assignDefaults` except that it ignores
	 * inherited property values when checking if a property is `undefined`.
	 *
	 * @private
	 * @param {*} objectValue The destination object property value.
	 * @param {*} sourceValue The source object property value.
	 * @param {string} key The key associated with the object and source values.
	 * @param {Object} object The destination object.
	 * @returns {*} Returns the value to assign to the destination object.
	 */
	function assignOwnDefaults(objectValue, sourceValue, key, object) {
	  return (objectValue === undefined || !hasOwnProperty.call(object, key))
	    ? sourceValue
	    : objectValue;
	}
	
	module.exports = assignOwnDefaults;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(28);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	module.exports = assignWith;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(29),
	    isArrayLike = __webpack_require__(34),
	    isObject = __webpack_require__(32),
	    shimKeys = __webpack_require__(38);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(30);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(31),
	    isObjectLike = __webpack_require__(33);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 32 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 33 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(35),
	    isLength = __webpack_require__(37);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(36);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(39),
	    isArray = __webpack_require__(40),
	    isIndex = __webpack_require__(41),
	    isLength = __webpack_require__(37),
	    keysIn = __webpack_require__(42);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(34),
	    isObjectLike = __webpack_require__(33);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(29),
	    isLength = __webpack_require__(37),
	    isObjectLike = __webpack_require__(33);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 41 */
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(39),
	    isArray = __webpack_require__(40),
	    isIndex = __webpack_require__(41),
	    isLength = __webpack_require__(37),
	    isObject = __webpack_require__(32);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var isError = __webpack_require__(44),
	    restParam = __webpack_require__(45);
	
	/**
	 * Attempts to invoke `func`, returning either the result or the caught error
	 * object. Any additional arguments are provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Function} func The function to attempt.
	 * @returns {*} Returns the `func` result or error object.
	 * @example
	 *
	 * // avoid throwing errors for invalid selectors
	 * var elements = _.attempt(function(selector) {
	 *   return document.querySelectorAll(selector);
	 * }, '>_>');
	 *
	 * if (_.isError(elements)) {
	 *   elements = [];
	 * }
	 */
	var attempt = restParam(function(func, args) {
	  try {
	    return func.apply(undefined, args);
	  } catch(e) {
	    return isError(e) ? e : new Error(e);
	  }
	});
	
	module.exports = attempt;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(33);
	
	/** `Object#toString` result references. */
	var errorTag = '[object Error]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	}
	
	module.exports = isError;


/***/ },
/* 45 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(47),
	    keys = __webpack_require__(28);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 48 */
/***/ function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ },
/* 49 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  var index = -1,
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = object[props[index]];
	  }
	  return result;
	}
	
	module.exports = baseValues;


/***/ },
/* 50 */
/***/ function(module, exports) {

	/** Used to escape characters for inclusion in compiled string literals. */
	var stringEscapes = {
	  '\\': '\\',
	  "'": "'",
	  '\n': 'n',
	  '\r': 'r',
	  '\u2028': 'u2028',
	  '\u2029': 'u2029'
	};
	
	/**
	 * Used by `_.template` to escape characters for inclusion in compiled string literals.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	function escapeStringChar(chr) {
	  return '\\' + stringEscapes[chr];
	}
	
	module.exports = escapeStringChar;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(34),
	    isIndex = __webpack_require__(41),
	    isObject = __webpack_require__(32);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 52 */
/***/ function(module, exports) {

	/** Used to match template delimiters. */
	var reInterpolate = /<%=([\s\S]+?)%>/g;
	
	module.exports = reInterpolate;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(54),
	    reEscape = __webpack_require__(56),
	    reEvaluate = __webpack_require__(57),
	    reInterpolate = __webpack_require__(52);
	
	/**
	 * By default, the template delimiters used by lodash are like those in
	 * embedded Ruby (ERB). Change the following template settings to use
	 * alternative delimiters.
	 *
	 * @static
	 * @memberOf _
	 * @type Object
	 */
	var templateSettings = {
	
	  /**
	   * Used to detect `data` property values to be HTML-escaped.
	   *
	   * @memberOf _.templateSettings
	   * @type RegExp
	   */
	  'escape': reEscape,
	
	  /**
	   * Used to detect code to be evaluated.
	   *
	   * @memberOf _.templateSettings
	   * @type RegExp
	   */
	  'evaluate': reEvaluate,
	
	  /**
	   * Used to detect `data` property values to inject.
	   *
	   * @memberOf _.templateSettings
	   * @type RegExp
	   */
	  'interpolate': reInterpolate,
	
	  /**
	   * Used to reference the data object in the template text.
	   *
	   * @memberOf _.templateSettings
	   * @type string
	   */
	  'variable': '',
	
	  /**
	   * Used to import variables into the compiled template.
	   *
	   * @memberOf _.templateSettings
	   * @type Object
	   */
	  'imports': {
	
	    /**
	     * A reference to the `lodash` function.
	     *
	     * @memberOf _.templateSettings.imports
	     * @type Function
	     */
	    '_': { 'escape': escape }
	  }
	};
	
	module.exports = templateSettings;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(48),
	    escapeHtmlChar = __webpack_require__(55);
	
	/** Used to match HTML entities and HTML characters. */
	var reUnescapedHtml = /[&<>"'`]/g,
	    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	/**
	 * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	 * their corresponding HTML entities.
	 *
	 * **Note:** No other characters are escaped. To escape additional characters
	 * use a third-party library like [_he_](https://mths.be/he).
	 *
	 * Though the ">" character is escaped for symmetry, characters like
	 * ">" and "/" don't need escaping in HTML and have no special meaning
	 * unless they're part of a tag or unquoted attribute value.
	 * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	 * (under "semi-related fun fact") for more details.
	 *
	 * Backticks are escaped because in Internet Explorer < 9, they can break out
	 * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	 * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	 * for more details.
	 *
	 * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	 * to reduce XSS vectors.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escape('fred, barney, & pebbles');
	 * // => 'fred, barney, &amp; pebbles'
	 */
	function escape(string) {
	  // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	  string = baseToString(string);
	  return (string && reHasUnescapedHtml.test(string))
	    ? string.replace(reUnescapedHtml, escapeHtmlChar)
	    : string;
	}
	
	module.exports = escape;


/***/ },
/* 55 */
/***/ function(module, exports) {

	/** Used to map characters to HTML entities. */
	var htmlEscapes = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;',
	  '`': '&#96;'
	};
	
	/**
	 * Used by `_.escape` to convert characters to HTML entities.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	function escapeHtmlChar(chr) {
	  return htmlEscapes[chr];
	}
	
	module.exports = escapeHtmlChar;


/***/ },
/* 56 */
/***/ function(module, exports) {

	/** Used to match template delimiters. */
	var reEscape = /<%-([\s\S]+?)%>/g;
	
	module.exports = reEscape;


/***/ },
/* 57 */
/***/ function(module, exports) {

	/** Used to match template delimiters. */
	var reEvaluate = /<%([\s\S]+?)%>/g;
	
	module.exports = reEvaluate;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = formatNumber;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _domainNumber_Format = __webpack_require__(59);
	
	var _domainNumber_Format2 = _interopRequireDefault(_domainNumber_Format);
	
	var _simpleFormatNumber = __webpack_require__(60);
	
	var _simpleFormatNumber2 = _interopRequireDefault(_simpleFormatNumber);
	
	function formatNumber(n, numberFormat) {
	  n = _tcomb2['default'].Number(n);
	  numberFormat = (0, _domainNumber_Format2['default'])(numberFormat);
	
	  var ret = function (n, numberFormat) {
	    return (0, _simpleFormatNumber2['default'])(n, {
	      fractionDigits: numberFormat.digits,
	      symbols: {
	        decimal: numberFormat.decimal_symbol,
	        grouping: numberFormat.grouping_symbol
	      }
	    });
	  }.call(this, n, numberFormat);
	
	  return _tcomb2['default'].String(ret);
	}

	module.exports = exports['default'];

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Natural = __webpack_require__(18);
	
	var _Natural2 = _interopRequireDefault(_Natural);
	
	var Number_Format = _tcomb2['default'].struct({
	  decimal_symbol: _tcomb2['default'].Str,
	  digits: _Natural2['default'],
	  grouping_symbol: _tcomb2['default'].Str,
	  infinity: _tcomb2['default'].Str,
	  negative_suffix: _tcomb2['default'].Str,
	  positive_suffix: _tcomb2['default'].Str
	}, 'Number_Format');
	
	// true se s è la rappresentazione in stringa di un numero JavaScript
	var is_numeric_regexp = /^-{0,1}\d*\.{0,1}\d+$/;
	
	var is_numeric = function is_numeric(s) {
	  return is_numeric_regexp.test(s);
	};
	// se s è parsabile un numero altrimenti null
	Number_Format.prototype.parse_number = function (s) {
	  s = _tcomb2['default'].String(s);
	
	  var escape_regexp = function escape_regexp(s) {
	    return s.replace(/([.*+?^${}()|[\]\/\\])/g, '\\$1');
	  };
	
	  // elimina i simboli di raggruppamento delle migliaia
	  // e il simbolo della virgola con la virgola JavaScript
	  var make_parseable = function make_parseable(fmt, s) {
	    var grouping_symbol_re = new RegExp(escape_regexp(fmt.grouping_symbol), 'gm');
	    var decimal_symbol_re = new RegExp(escape_regexp(fmt.decimal_symbol), 'gm');
	    var without_grouping = s.replace(grouping_symbol_re, "");
	    return without_grouping.replace(decimal_symbol_re, ".");
	  };
	
	  var parseable = make_parseable(this, s);
	  return is_numeric(parseable) ? parseFloat(parseable) : parseable === this.infinity ? Infinity : parseable === this.negative_suffix + this.infinity ? -Infinity : null;
	};
	
	exports['default'] = Number_Format;
	module.exports = exports['default'];

/***/ },
/* 60 */
/***/ function(module, exports) {

	function shallowCopy(a, b) {
	  if (b) {
	    for (var k in b) {
	      if (b.hasOwnProperty(k)) {
	        a[k] = b[k];
	      }
	    }
	  }
	  return a;
	}
	
	function getOptions(options) {
	  var defaults = {
	    fractionDigits: 2,
	    useGrouping: true // turn off when you want to display a number in a textbox
	  };
	  var symbols = { // US formats as default
	    grouping: ',',
	    decimal: '.'
	  };
	  options = shallowCopy(defaults, options);
	  options.symbols = shallowCopy(symbols, options.symbols);
	  return options;
	}
	
	var insertGroupingRegexp = /(\d+)(\d{3})/;
	
	function insertGrouping(s, grouping) {
	  var times = Math.floor(s.length / 3);
	  for (var i = 0; i < times; i++) {
	    s = s.replace(insertGroupingRegexp, '$1' + grouping + '$2');
	  }
	  return s;
	}
	
	function formatNumber(n, options) {
	  options = getOptions(options);
	  var parts = n.toFixed(options.fractionDigits).split('.');
	  var integerPart = parts[0];
	  var decimalPart = parts[1];
	  if (options.useGrouping) {
	    integerPart = insertGrouping(integerPart, options.symbols.grouping);
	  }
	  return integerPart + (options.fractionDigits > 0 ? options.symbols.decimal + decimalPart : '');
	}
	
	module.exports = formatNumber;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var is_uuid_regexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
	
	var UUID = _tcomb2['default'].refinement(_tcomb2['default'].String, function (s) {
	  return is_uuid_regexp.test(s);
	});
	
	exports['default'] = UUID;
	module.exports = exports['default'];

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = load_districts;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Register_Country = __webpack_require__(63);
	
	var _Register_Country2 = _interopRequireDefault(_Register_Country);
	
	var _loadScript = __webpack_require__(64);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var districts = {};
	
	function load_districts(lib_url, country, callback) {
	  lib_url = _tcomb2['default'].String(lib_url);
	  callback = _tcomb2['default'].Function(callback);
	
	  _tcomb2['default'].assert(_tcomb2['default'].maybe(_Register_Country2['default']).is(country));
	
	  if (!country) {
	    return callback(null);
	  }
	
	  if (districts[country]) {
	    return callback(districts[country]);
	  }
	
	  var scriptURL = lib_url + 'district/' + country + '.js';
	  (0, _loadScript2['default'])(scriptURL, function () {
	    districts[country] = window.require('district/' + country);
	    callback(districts[country]);
	  });
	}

	module.exports = exports['default'];

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Register_Country = _tcomb2['default'].enums.of(['AT', 'BR', 'CA', 'CH', 'DE', 'ES', 'FR', 'GB', 'IT', 'US', 'ZA']);
	
	module.exports = Register_Country;

/***/ },
/* 64 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = target;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isModal = __webpack_require__(14);
	
	var _isModal2 = _interopRequireDefault(_isModal);
	
	var _toUrl = __webpack_require__(66);
	
	var _toUrl2 = _interopRequireDefault(_toUrl);
	
	var _cookiesJs = __webpack_require__(67);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	function target(app, purchase_id) {
	  var url = location.href;
	  var purl = _cookiesJs2['default'].get('purl');
	
	  /*if (isModal() && purl) {
	    if (Cookies.get('purl_only') === "1") {
	      url = purl;
	    } else {
	      var params = {
	        // se c'è il product_id devo aprire l'applicativo product
	        product_id: app.product ? app.product.id : null,
	        // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
	        user: !app.product ? true : null
	      };
	      url = toUrl(purl, params);
	    }
	  }*/
	
	  var params = {
	    // se c'è il product_id devo aprire l'applicativo product
	    product_id: app.product ? app.product.id : null,
	    // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
	    user: !app.product ? true : null
	  };
	
	  if (purl) {
	    url = (0, _toUrl2['default'])(purl, params);
	  }
	
	  // fix paypal redirect
	  /*if (url.indexOf('#') !== -1) {
	    url = url.substring(0, url.indexOf('#'));
	  }*/
	  var url_replaced = url;
	  //redirect sulla thankyou page, la pagina di ritorno non è mai in modale, e se parto dallo user vado sulla prodotto
	  var lattice_id = app.lattice ? app.lattice.id : null;
	  var lattice_params = lattice_id ? "lattice=" + lattice_id : null;
	  if ((0, _isModal2['default'])()) {
	    var value =  true ? 'promo' : 'test';
	
	    url_replaced = "https://" + value + ".madai.com/wa/ui/thankyou/" + purchase_id + '?' + lattice_params;
	  } else if (url.indexOf("/campaign") !== -1) {
	    if (url.indexOf("?") == -1) {
	      url_replaced = url.substr(0, url.indexOf("/campaign")).concat("/thankyou/" + purchase_id + '?' + lattice_params);
	    } else {
	      url_replaced = url.substr(0, url.indexOf("/campaign")).concat("/thankyou/" + purchase_id).concat(url.substr(url.indexOf("?"), url.length).concat("&" + lattice_params));
	    }
	  } else if (url.indexOf("/product") !== -1) {
	    if (url.indexOf("?") == -1) {
	      url_replaced = url.substr(0, url.indexOf("/product")).concat("/thankyou/" + purchase_id + '?' + lattice_params);
	    } else {
	      url_replaced = url.substr(0, url.indexOf("/product")).concat("/thankyou/" + purchase_id).concat(url.substr(url.indexOf("?"), url.length).concat("&" + lattice_params));
	    }
	  } else if (url.indexOf("/user") !== -1) {
	    if (url.indexOf("?") == -1) {
	      url_replaced = url.substr(0, url.indexOf("/user")).concat("/thankyou/" + purchase_id + '?' + lattice_params);
	    } else {
	      url_replaced = url.substr(0, url.indexOf("/user")).concat("/thankyou/" + purchase_id).concat(url.substr(url.indexOf("?"), url.length).concat("&" + lattice_params));
	    }
	  }
	  return url_replaced;
	}

	module.exports = exports['default'];

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = to_url;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _querystring = __webpack_require__(11);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var QueryString = _tcomb2['default'].union([_tcomb2['default'].String, _tcomb2['default'].Object], 'QueryString');
	
	function to_url(url, qs) {
	  url = _tcomb2['default'].String(url);
	  qs = _tcomb2['default'].maybe(QueryString)(qs);
	
	  var ret = function (url, qs) {
	
	    qs = _tcomb2['default'].Obj.is(qs) ? _querystring2['default'].stringify(qs) : qs || '';
	
	    if (qs) {
	      // è già presente il ?
	      if (url.indexOf('?') !== -1) {
	        url += '&' + qs;
	      } else {
	        // è presente un hash?
	        var hashIndex = url.indexOf('#');
	        if (hashIndex !== -1) {
	          var hash = url.substring(hashIndex);
	          url = url.substring(0, hashIndex) + '?' + qs + hash;
	        } else {
	          url += '?' + qs;
	        }
	      }
	    }
	
	    return url;
	  }.call(this, url, qs);
	
	  return _tcomb2['default'].String(ret);
	}

	module.exports = exports['default'];

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Cookies.js - 1.2.2
	 * https://github.com/ScottHamper/Cookies
	 *
	 * This is free and unencumbered software released into the public domain.
	 */
	(function (global, undefined) {
	    'use strict';
	
	    var factory = function (window) {
	        if (typeof window.document !== 'object') {
	            throw new Error('Cookies.js requires a `window` with a `document` object');
	        }
	
	        var Cookies = function (key, value, options) {
	            return arguments.length === 1 ?
	                Cookies.get(key) : Cookies.set(key, value, options);
	        };
	
	        // Allows for setter injection in unit tests
	        Cookies._document = window.document;
	
	        // Used to ensure cookie keys do not collide with
	        // built-in `Object` properties
	        Cookies._cacheKeyPrefix = 'cookey.'; // Hurr hurr, :)
	        
	        Cookies._maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');
	
	        Cookies.defaults = {
	            path: '/',
	            secure: false
	        };
	
	        Cookies.get = function (key) {
	            if (Cookies._cachedDocumentCookie !== Cookies._document.cookie) {
	                Cookies._renewCache();
	            }
	            
	            var value = Cookies._cache[Cookies._cacheKeyPrefix + key];
	
	            return value === undefined ? undefined : decodeURIComponent(value);
	        };
	
	        Cookies.set = function (key, value, options) {
	            options = Cookies._getExtendedOptions(options);
	            options.expires = Cookies._getExpiresDate(value === undefined ? -1 : options.expires);
	
	            Cookies._document.cookie = Cookies._generateCookieString(key, value, options);
	
	            return Cookies;
	        };
	
	        Cookies.expire = function (key, options) {
	            return Cookies.set(key, undefined, options);
	        };
	
	        Cookies._getExtendedOptions = function (options) {
	            return {
	                path: options && options.path || Cookies.defaults.path,
	                domain: options && options.domain || Cookies.defaults.domain,
	                expires: options && options.expires || Cookies.defaults.expires,
	                secure: options && options.secure !== undefined ?  options.secure : Cookies.defaults.secure
	            };
	        };
	
	        Cookies._isValidDate = function (date) {
	            return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
	        };
	
	        Cookies._getExpiresDate = function (expires, now) {
	            now = now || new Date();
	
	            if (typeof expires === 'number') {
	                expires = expires === Infinity ?
	                    Cookies._maxExpireDate : new Date(now.getTime() + expires * 1000);
	            } else if (typeof expires === 'string') {
	                expires = new Date(expires);
	            }
	
	            if (expires && !Cookies._isValidDate(expires)) {
	                throw new Error('`expires` parameter cannot be converted to a valid Date instance');
	            }
	
	            return expires;
	        };
	
	        Cookies._generateCookieString = function (key, value, options) {
	            key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
	            key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
	            value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
	            options = options || {};
	
	            var cookieString = key + '=' + value;
	            cookieString += options.path ? ';path=' + options.path : '';
	            cookieString += options.domain ? ';domain=' + options.domain : '';
	            cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
	            cookieString += options.secure ? ';secure' : '';
	
	            return cookieString;
	        };
	
	        Cookies._getCacheFromString = function (documentCookie) {
	            var cookieCache = {};
	            var cookiesArray = documentCookie ? documentCookie.split('; ') : [];
	
	            for (var i = 0; i < cookiesArray.length; i++) {
	                var cookieKvp = Cookies._getKeyValuePairFromCookieString(cookiesArray[i]);
	
	                if (cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] === undefined) {
	                    cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] = cookieKvp.value;
	                }
	            }
	
	            return cookieCache;
	        };
	
	        Cookies._getKeyValuePairFromCookieString = function (cookieString) {
	            // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
	            var separatorIndex = cookieString.indexOf('=');
	
	            // IE omits the "=" when the cookie value is an empty string
	            separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;
	
	            var key = cookieString.substr(0, separatorIndex);
	            var decodedKey;
	            try {
	                decodedKey = decodeURIComponent(key);
	            } catch (e) {
	                if (console && typeof console.error === 'function') {
	                    console.error('Could not decode cookie with key "' + key + '"', e);
	                }
	            }
	            
	            return {
	                key: decodedKey,
	                value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
	            };
	        };
	
	        Cookies._renewCache = function () {
	            Cookies._cache = Cookies._getCacheFromString(Cookies._document.cookie);
	            Cookies._cachedDocumentCookie = Cookies._document.cookie;
	        };
	
	        Cookies._areEnabled = function () {
	            var testKey = 'cookies.js';
	            var areEnabled = Cookies.set(testKey, 1).get(testKey) === '1';
	            Cookies.expire(testKey);
	            return areEnabled;
	        };
	
	        Cookies.enabled = Cookies._areEnabled();
	
	        return Cookies;
	    };
	
	    var cookiesExport = typeof global.document === 'object' ? factory(global) : factory;
	
	    // AMD support
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return cookiesExport; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    // CommonJS/Node.js support
	    } else if (typeof exports === 'object') {
	        // Support Node.js specific `module.exports` (which can be a function)
	        if (typeof module === 'object' && typeof module.exports === 'object') {
	            exports = module.exports = cookiesExport;
	        }
	        // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
	        exports.Cookies = cookiesExport;
	    } else {
	        global.Cookies = cookiesExport;
	    }
	})(typeof window === 'undefined' ? this : window);

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = social_target;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isModal = __webpack_require__(14);
	
	var _isModal2 = _interopRequireDefault(_isModal);
	
	var _toUrl = __webpack_require__(66);
	
	var _toUrl2 = _interopRequireDefault(_toUrl);
	
	var _cookiesJs = __webpack_require__(67);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	function social_target(app) {
	  var url = location.href;
	  var purl = _cookiesJs2['default'].get('purl');
	
	  if ((0, _isModal2['default'])() && purl) {
	    if (_cookiesJs2['default'].get('purl_only') === "1") {
	      url = purl;
	    } else {
	      var params = {
	        // se c'è il product_id devo aprire l'applicativo product
	        product_id: app.product ? app.product.id : null,
	        // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
	        user: !app.product ? true : null
	      };
	      url = (0, _toUrl2['default'])(purl, params);
	    }
	  }
	
	  // fix paypal redirect
	  if (url.indexOf('#') !== -1) {
	    url = url.substring(0, url.indexOf('#'));
	  }
	
	  return url;
	}

	module.exports = exports['default'];

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = setPurlCookies;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isModal = __webpack_require__(14);
	
	var _isModal2 = _interopRequireDefault(_isModal);
	
	var _cookiesJs = __webpack_require__(67);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	var _parseQuerystring = __webpack_require__(70);
	
	var _parseQuerystring2 = _interopRequireDefault(_parseQuerystring);
	
	function setPurlCookies() {
	  var params = (0, _parseQuerystring2['default'])(location.search);
	  var purl = params.purl;
	  var purl_only = params.purl_only;
	
	  if ((0, _isModal2['default'])() && purl) {
	    _cookiesJs2['default'].set('purl', purl, {
	      path: '/'
	    });
	    _cookiesJs2['default'].set('purl_only', purl_only === "1" ? "1" : "0", {
	      path: '/'
	    });
	  }
	}

	module.exports = exports['default'];

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = parseQuerystring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _querystring = __webpack_require__(11);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var adaptQueryString = function adaptQueryString() {
	  return location.search ? location.search.substring(1, location.search.length) : null;
	};
	
	function parseQuerystring() {
	  return _querystring2['default'].parse(adaptQueryString());
	}

	module.exports = exports['default'];

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = cancel_target;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isModal = __webpack_require__(14);
	
	var _isModal2 = _interopRequireDefault(_isModal);
	
	var _toUrl = __webpack_require__(66);
	
	var _toUrl2 = _interopRequireDefault(_toUrl);
	
	var _cookiesJs = __webpack_require__(67);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	function cancel_target(app) {
	  var url = location.href;
	  var purl = _cookiesJs2['default'].get('purl');
	
	  if ((0, _isModal2['default'])() && purl) {
	    if (_cookiesJs2['default'].get('purl_only') === "1") {
	      url = purl;
	    } else {
	      var params = {
	        // se c'è il product_id devo aprire l'applicativo product
	        product_id: app.product ? app.product.id : null,
	        // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
	        user: !app.product ? true : null
	      };
	      url = (0, _toUrl2['default'])(purl, params);
	    }
	  }
	
	  // fix paypal redirect
	  if (url.indexOf('#') !== -1) {
	    url = url.substring(0, url.indexOf('#'));
	  }
	
	  return url;
	}

	module.exports = exports['default'];

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _countries = __webpack_require__(73);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _get_bundle = __webpack_require__(111);
	
	var _get_bundle2 = _interopRequireDefault(_get_bundle);
	
	var _componentsSharePurchase = __webpack_require__(112);
	
	var _componentsSharePurchase2 = _interopRequireDefault(_componentsSharePurchase);
	
	var _template = __webpack_require__(115);
	
	var Share_Purchase = {
	  current: null,
	  create: function create(share_purchase_url, locale, purchase, do_share) {
	    var formatted_currency = locale.locale_bundle().currency[purchase.currency];
	    var format_currency = function format_currency(n) {
	      return formatted_currency + ' ' + locale.format_number(n, 2);
	    };
	    var bonus = format_currency(_countries2['default'].data[locale.country].bonus);
	    var discount = format_currency(purchase.discount);
	    var bundle = (0, _get_bundle2['default'])(locale).share_purchase;
	    var _share_purchase_url = share_purchase_url + '?productId=' + purchase.productId;
	    Share_Purchase.current = {
	      bonus: bonus,
	      html: function html() {
	        return _react2['default'].createElement(_componentsSharePurchase2['default'], { share_purchase_url: _share_purchase_url, bundle: bundle });
	      },
	      data: function data() {
	        return {
	          locale: String(locale),
	          language: locale.language,
	          target: 'http://madai.com',
	          name: purchase.product,
	          caption: 'madai',
	          picture: purchase.image,
	          description: (0, _template.template)(bundle.description)({
	            product: purchase.product,
	            discount: discount
	          })
	        };
	      },
	      do_share: do_share
	    };
	  }
	};
	
	exports['default'] = Share_Purchase;
	module.exports = exports['default'];

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _lodashCollectionEvery = __webpack_require__(74);
	
	var _lodashCollectionEvery2 = _interopRequireDefault(_lodashCollectionEvery);
	
	var _lodashCollectionSortBy = __webpack_require__(106);
	
	var _lodashCollectionSortBy2 = _interopRequireDefault(_lodashCollectionSortBy);
	
	var _Register_Country = __webpack_require__(63);
	
	var _Register_Country2 = _interopRequireDefault(_Register_Country);
	
	// # Tabella dei paesi
	// Contiene i valori per l'area, la valuta e il bonus per ogni paese
	// più alcune funzioni utili di formattazione
	var countries = {
	  data: {
	    AT: {
	      area: '43',
	      currency: 'EUR',
	      bonus: 0
	    },
	    BR: {
	      area: '55',
	      currency: 'BRL',
	      bonus: 0
	    },
	    FR: {
	      area: '33',
	      currency: 'EUR',
	      bonus: 0
	    },
	    DE: {
	      area: '49',
	      currency: 'EUR',
	      bonus: 0
	    },
	    GB: {
	      area: '44',
	      currency: 'GBP',
	      bonus: 0
	    },
	    IT: {
	      area: '39',
	      currency: 'EUR',
	      bonus: 0
	    },
	    ES: {
	      area: '34',
	      currency: 'EUR',
	      bonus: 0
	    },
	    US: {
	      area: '1',
	      currency: 'USD',
	      bonus: 0
	    },
	    CA: {
	      area: '1',
	      currency: 'CAD',
	      bonus: 0
	    },
	    ZA: {
	      area: '27',
	      currency: 'ZAR',
	      bonus: 0
	    },
	    CH: {
	      area: '41',
	      currency: 'CHF',
	      bonus: 0
	    }
	  },
	
	  currency: function currency(country) {
	    return countries.data[country].currency;
	  },
	
	  area: function area(country) {
	    return countries.data[country].area;
	  },
	
	  bonus: function bonus(country) {
	    return countries.data[country].bonus;
	  },
	
	  format_area: function format_area(locale, country) {
	    return locale.display_country(country) + ' (+' + countries.area(country) + ') ';
	  },
	
	  format_mobile: function format_mobile(country, mobile) {
	    return '(+' + countries.area(country) + ') ' + mobile;
	  },
	
	  to_options: function to_options(locale) {
	    return (0, _lodashCollectionSortBy2['default'])(Object.keys(countries.data).map(function (k) {
	      return [k, locale.display_country(k)];
	    }), '1');
	  }
	};
	
	// mi assicuro che ogni country abbia i suoi dati
	_tcomb2['default'].assert((0, _lodashCollectionEvery2['default'])(_Register_Country2['default'].meta.map, function (country) {
	  return countries.data.hasOwnProperty(country);
	}));
	
	module.exports = countries;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(75),
	    baseCallback = __webpack_require__(76),
	    baseEvery = __webpack_require__(100),
	    isArray = __webpack_require__(40),
	    isIterateeCall = __webpack_require__(51);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * The predicate is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias all
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': false },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // using the `_.matches` callback shorthand
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.every(users, 'active', false);
	 * // => true
	 *
	 * // using the `_.property` callback shorthand
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, thisArg) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	    predicate = undefined;
	  }
	  if (typeof predicate != 'function' || thisArg !== undefined) {
	    predicate = baseCallback(predicate, thisArg, 3);
	  }
	  return func(collection, predicate);
	}
	
	module.exports = every;


/***/ },
/* 75 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(77),
	    baseMatchesProperty = __webpack_require__(90),
	    bindCallback = __webpack_require__(96),
	    identity = __webpack_require__(97),
	    property = __webpack_require__(98);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(78),
	    getMatchData = __webpack_require__(87),
	    toObject = __webpack_require__(86);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(79),
	    toObject = __webpack_require__(86);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(80),
	    isObject = __webpack_require__(32),
	    isObjectLike = __webpack_require__(33);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(81),
	    equalByTag = __webpack_require__(83),
	    equalObjects = __webpack_require__(84),
	    isArray = __webpack_require__(40),
	    isTypedArray = __webpack_require__(85);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(82);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 83 */
/***/ function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(28);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(37),
	    isObjectLike = __webpack_require__(33);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(88),
	    pairs = __webpack_require__(89);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(28),
	    toObject = __webpack_require__(86);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(91),
	    baseIsEqual = __webpack_require__(79),
	    baseSlice = __webpack_require__(92),
	    isArray = __webpack_require__(40),
	    isKey = __webpack_require__(93),
	    isStrictComparable = __webpack_require__(88),
	    last = __webpack_require__(94),
	    toObject = __webpack_require__(86),
	    toPath = __webpack_require__(95);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(86);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 92 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(40),
	    toObject = __webpack_require__(86);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ },
/* 94 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(48),
	    isArray = __webpack_require__(40);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(97);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(36),
	    basePropertyDeep = __webpack_require__(99),
	    isKey = __webpack_require__(93);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(91),
	    toPath = __webpack_require__(95);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(101);
	
	/**
	 * The base implementation of `_.every` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(102),
	    createBaseEach = __webpack_require__(105);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(103),
	    keys = __webpack_require__(28);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(104);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(86);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(35),
	    isLength = __webpack_require__(37),
	    toObject = __webpack_require__(86);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(76),
	    baseMap = __webpack_require__(107),
	    baseSortBy = __webpack_require__(108),
	    compareAscending = __webpack_require__(109),
	    isIterateeCall = __webpack_require__(51);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection through `iteratee`. This method performs
	 * a stable sort, that is, it preserves the original sort order of equal elements.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * _.sortBy([1, 2, 3], function(n) {
	 *   return Math.sin(n);
	 * });
	 * // => [3, 1, 2]
	 *
	 * _.sortBy([1, 2, 3], function(n) {
	 *   return this.sin(n);
	 * }, Math);
	 * // => [3, 1, 2]
	 *
	 * var users = [
	 *   { 'user': 'fred' },
	 *   { 'user': 'pebbles' },
	 *   { 'user': 'barney' }
	 * ];
	 *
	 * // using the `_.property` callback shorthand
	 * _.pluck(_.sortBy(users, 'user'), 'user');
	 * // => ['barney', 'fred', 'pebbles']
	 */
	function sortBy(collection, iteratee, thisArg) {
	  if (collection == null) {
	    return [];
	  }
	  if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	    iteratee = undefined;
	  }
	  var index = -1;
	  iteratee = baseCallback(iteratee, thisArg, 3);
	
	  var result = baseMap(collection, function(value, key, collection) {
	    return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	  });
	  return baseSortBy(result, compareAscending);
	}
	
	module.exports = sortBy;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(101),
	    isArrayLike = __webpack_require__(34);
	
	/**
	 * The base implementation of `_.map` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define
	 * the sort order of `array` and replaces criteria objects with their
	 * corresponding values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var baseCompareAscending = __webpack_require__(110);
	
	/**
	 * Used by `_.sortBy` to compare transformed elements of a collection and stable
	 * sort them in ascending order.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareAscending(object, other) {
	  return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	}
	
	module.exports = compareAscending;


/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `compareAscending` which compares values and
	 * sorts them in ascending order without guaranteeing a stable sort.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function baseCompareAscending(value, other) {
	  if (value !== other) {
	    var valIsNull = value === null,
	        valIsUndef = value === undefined,
	        valIsReflexive = value === value;
	
	    var othIsNull = other === null,
	        othIsUndef = other === undefined,
	        othIsReflexive = other === other;
	
	    if ((value > other && !othIsNull) || !valIsReflexive ||
	        (valIsNull && !othIsUndef && othIsReflexive) ||
	        (valIsUndef && othIsReflexive)) {
	      return 1;
	    }
	    if ((value < other && !valIsNull) || !othIsReflexive ||
	        (othIsNull && !valIsUndef && valIsReflexive) ||
	        (othIsUndef && valIsReflexive)) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = baseCompareAscending;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = get_bundle;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function get_bundle(locale) {
	  var ret = function (locale) {
	    return window.require('web/io/' + locale.language);
	  }.call(this, locale);
	
	  return _tcomb2['default'].Object(ret);
	}

	module.exports = exports['default'];

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(113);
	
	var SharePurchase = (function (_React$Component) {
	  _inherits(SharePurchase, _React$Component);
	
	  function SharePurchase() {
	    _classCallCheck(this, _SharePurchase);
	
	    _get(Object.getPrototypeOf(_SharePurchase.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SharePurchase, [{
	    key: 'render',
	    value: function render() {
	      var style = {
	        'width': '100%',
	        'height': '62px'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { className: 'alert info' },
	        _react2['default'].createElement(
	          'strong',
	          null,
	          this.props.bundle.title
	        ),
	        _react2['default'].createElement('iframe', { scrolling: 'no', frameBorder: '0', src: this.props.share_purchase_url, style: style })
	      );
	    }
	  }]);
	
	  var _SharePurchase = SharePurchase;
	  SharePurchase = (0, _tcombReact.props)({
	    bundle: _tcombReact.t.Obj,
	    share_purchase_url: _tcombReact.t.Str
	  })(SharePurchase) || SharePurchase;
	  return SharePurchase;
	})(_react2['default'].Component);
	
	exports['default'] = SharePurchase;
	module.exports = exports['default'];

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(3);
	var t = __webpack_require__(114);
	
	//
	// helpers
	//
	
	// use t.stringify if defined, otherwise fallback to a verbose but possibly slow implementation
	var stringify = t.stringify || function stringify(x) {
	  try { // handle "Converting circular structure to JSON" error
	    return JSON.stringify(x);
	  }
	  catch (e) {
	    return String(x);
	  }
	};
	
	// returns true id type is a struct
	function isStruct(type) {
	  return ( type.meta.kind === 'struct' );
	}
	
	// returns true id type is a subtype
	function isSubtype(type) {
	  return ( type.meta.kind === 'subtype' );
	}
	
	//
	// main function
	//
	
	function getPropTypes(type, options) {
	
	  //
	  // let's type check the input...
	  //
	
	  // getPropTypes can also accept a dictionary prop -> type
	  if (t.Obj.is(type)) {
	    type = t.struct(type);
	  }
	
	  // here type should be a struct or a subtype of a struct
	  if (false) {
	    t.assert(
	      t.isType(type) && ( isStruct(type) || ( isSubtype(type) && isStruct(type.meta.type) ) ),
	      '[tcomb-react] Invalid argument type supplied to propTypes(), must be a struct, a subtype of a struct or a dictionary prop -> type'
	    );
	  }
	
	  var propTypes = {};
	  var subtype = isSubtype(type);
	  var innerStruct = subtype ? type.meta.type : type;
	  var props = innerStruct.meta.props;
	
	  Object.keys(props).forEach(function (k) {
	
	    var propType = props[k];
	    var propTypeName = t.getTypeName(propType);
	    var checkPropType = function () {};
	
	    if (false) {
	
	      // React custom prop validators
	      // see http://facebook.github.io/react/docs/reusable-components.html
	      checkPropType = function (values, prop, displayName) {
	
	        var value = values[prop];
	        var validationResult = t.validate(value, props[prop]);
	
	        if (!validationResult.isValid()) {
	
	          var message = [
	            'Invalid prop ' + stringify(prop) + ' supplied to ' + displayName + ', should be a ' + propTypeName + '.\n',
	            'Detected errors (' + validationResult.errors.length + '):\n'
	          ].concat(validationResult.errors.map(function (e, i) {
	            return ' ' + (i + 1) + '. ' + e.message;
	          })).join('\n') + '\n\n';
	
	          // add a readable entry in the call stack
	          // when "Pause on exceptions" and "Pause on Caught Exceptions"
	          // are enabled in Chrome DevTools
	          checkPropType.displayName = message;
	
	          t.fail(message);
	        }
	      };
	    }
	
	    // attach the original tcomb definition, so other components can read it
	    // via `propTypes.whatever.tcomb`
	    checkPropType.tcomb = propType;
	
	    propTypes[k] = checkPropType;
	  });
	
	  if (false) {
	
	    options = options || {};
	
	    // allows to opt-out additional props check
	    if (options.strict !== false) {
	      propTypes.__strict__ = function (values, prop, displayName) {
	        var extra = [];
	        for (var k in values) {
	          // __strict__ and __subtype__ keys are excluded in order to support the React context feature
	          if (k !== '__strict__' && k !== '__subtype__' && values.hasOwnProperty(k) && !props.hasOwnProperty(k)) {
	            extra.push(k);
	          }
	        }
	        if (extra.length > 0) {
	          t.fail('Invalid additional prop(s):\n\n' + stringify(extra) + '\n\nsupplied to ' + displayName + '.');
	        }
	      };
	    }
	
	    if (subtype) {
	      propTypes.__subtype__ = function (values, prop, displayName) {
	        if (!type.meta.predicate(values)) {
	          t.fail('Invalid props:\n\n' + stringify(values) + '\n\nsupplied to ' + displayName + ', should be a ' + t.getTypeName(type) + ' subtype.');
	        }
	      };
	    }
	  }
	
	  return propTypes;
	}
	
	//
	// ES7 decorator
	//
	
	function es7PropsDecorator(type, options) {
	  return function (Component) {
	    Component.propTypes = getPropTypes(type, options);
	  };
	}
	
	var ReactElement = t.irreducible('ReactElement', React.isValidElement);
	var ReactNode = t.irreducible('ReactNode', function (x) {
	  return t.Str.is(x) || t.Num.is(x) || ReactElement.is(x) || t.list(ReactNode).is(x);
	});
	
	t.ReactElement = ReactElement;
	t.ReactNode = ReactNode;
	
	module.exports = {
	  t: t,
	  propTypes: getPropTypes,
	  props: es7PropsDecorator,
	  ReactElement: ReactElement, // deprecated
	  ReactNode: ReactNode  // deprecated
	};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var t = __webpack_require__(1);
	var stringify = t.stringify;
	
	var ValidationError = t.struct({
	  message: t.Str,
	  actual: t.Any,
	  expected: t.Any,
	  path: t.list(t.union([t.Str, t.Num]))
	}, 'ValidationError');
	
	function getDefaultValidationErrorMessage(actual, expected, path) {
	  var expectedName = t.getTypeName(expected);
	  var to = path.length ? '/' + path.join('/') + ': ' + expectedName : expectedName;
	  return 'Invalid value ' + stringify(actual) + ' supplied to ' + to;
	}
	
	function getValidationErrorMessage(actual, expected, path, context) {
	  if (t.Function.is(expected.getValidationErrorMessage)) {
	    return expected.getValidationErrorMessage(actual, path, context);
	  }
	  else {
	    return getDefaultValidationErrorMessage(actual, expected, path);
	  }
	}
	
	ValidationError.of = function (actual, expected, path, context) {
	  return new ValidationError({
	    message: getValidationErrorMessage(actual, expected, path, context),
	    actual: actual,
	    expected: expected,
	    path: path
	  });
	};
	
	var ValidationResult = t.struct({
	  errors: t.list(ValidationError),
	  value: t.Any
	}, 'ValidationResult');
	
	ValidationResult.prototype.isValid = function () {
	  return !(this.errors.length);
	};
	
	ValidationResult.prototype.firstError = function () {
	  return this.isValid() ? null : this.errors[0];
	};
	
	ValidationResult.prototype.toString = function () {
	  if (this.isValid()) {
	    return '[ValidationResult, true, ' + stringify(this.value) + ']';
	  }
	  else {
	    return '[ValidationResult, false, (' + this.errors.map(function (err) {
	      return err.message;
	    }).join(', ') + ')]';
	  }
	};
	
	function validate(x, type, options) {
	  options = options || {};
	  var path = t.Array.is(options) ? options : options.path || [];
	  return new ValidationResult(recurse(x, type, path, options.context));
	}
	
	function recurse(x, type, path, context) {
	  if (t.isType(type)) {
	    return validators[type.meta.kind](x, type, path, context);
	  }
	  else {
	    return validators.es6classes(x, type, path, context);
	  }
	}
	
	var validators = validate.validators = {};
	
	validators.es6classes = function validateES6Classes(x, type, path, context) {
	  return {
	    value: x,
	    errors: x instanceof type ? [] : [ValidationError.of(x, type, path, context)]
	  };
	};
	
	// irreducibles and enums
	validators.irreducible =
	validators.enums = function validateIrreducible(x, type, path, context) {
	  return {
	    value: x,
	    errors: type.is(x) ? [] : [ValidationError.of(x, type, path, context)]
	  };
	};
	
	validators.list = function validateList(x, type, path, context) {
	
	  // x should be an array
	  if (!t.Arr.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, context)]};
	  }
	
	  var ret = {value: [], errors: []};
	  // every item should be of type `type.meta.type`
	  for (var i = 0, len = x.length; i < len; i++ ) {
	    var item = recurse(x[i], type.meta.type, path.concat(i), context);
	    ret.value[i] = item.value;
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	validators.subtype = function validateSubtype(x, type, path, context) {
	
	  // x should be a valid inner type
	  var ret = recurse(x, type.meta.type, path, context);
	  if (ret.errors.length) {
	    return ret;
	  }
	
	  // x should satisfy the predicate
	  if (!type.meta.predicate(ret.value)) {
	    ret.errors = [ValidationError.of(x, type, path, context)];
	  }
	
	  return ret;
	
	};
	
	validators.maybe = function validateMaybe(x, type, path, context) {
	  return t.Nil.is(x) ?
	    {value: null, errors: []} :
	    recurse(x, type.meta.type, path, context);
	};
	
	validators.struct = function validateStruct(x, type, path, context) {
	
	  // x should be an object
	  if (!t.Obj.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, context)]};
	  }
	
	  // [optimization]
	  if (type.is(x)) {
	    return {value: x, errors: []};
	  }
	
	  var ret = {value: {}, errors: []};
	  var props = type.meta.props;
	  // every item should be of type `props[name]`
	  for (var name in props) {
	    if (props.hasOwnProperty(name)) {
	      var prop = recurse(x[name], props[name], path.concat(name), context);
	      ret.value[name] = prop.value;
	      ret.errors = ret.errors.concat(prop.errors);
	    }
	  }
	  if (!ret.errors.length) {
	    ret.value = new type(ret.value);
	  }
	  return ret;
	};
	
	validators.tuple = function validateTuple(x, type, path, context) {
	
	  var types = type.meta.types;
	  var len = types.length;
	
	  // x should be an array of at most `len` items
	  if (!t.Arr.is(x) || x.length > len) {
	    return {value: x, errors: [ValidationError.of(x, type, path, context)]};
	  }
	
	  var ret = {value: [], errors: []};
	  // every item should be of type `types[i]`
	  for (var i = 0; i < len; i++) {
	    var item = recurse(x[i], types[i], path.concat(i), context);
	    ret.value[i] = item.value;
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	validators.dict = function validateDict(x, type, path, context) {
	
	  // x should be an object
	  if (!t.Obj.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, context)]};
	  }
	
	  var ret = {value: {}, errors: []};
	  // every key should be of type `domain`
	  // every value should be of type `codomain`
	  for (var k in x) {
	    if (x.hasOwnProperty(k)) {
	      var subpath = path.concat(k);
	      var key = recurse(k, type.meta.domain, subpath, context);
	      var item = recurse(x[k], type.meta.codomain, subpath, context);
	      ret.value[k] = item.value;
	      ret.errors = ret.errors.concat(key.errors, item.errors);
	    }
	  }
	  return ret;
	};
	
	validators.union = function validateUnion(x, type, path, context) {
	  var ctor = type.dispatch(x);
	  return t.Func.is(ctor) ?
	    recurse(x, ctor, path.concat(type.meta.types.indexOf(ctor)), context) :
	    {value: x, errors: [ValidationError.of(x, type, path, context)]};
	};
	
	validators.intersection = function validateIntersection(x, type, path, context) {
	
	  var types = type.meta.types;
	  var len = types.length;
	
	  var ret = {value: x, errors: []};
	  // x should be of type `types[i]` for all i
	  for (var i = 0; i < len; i++) {
	    var item = recurse(x, types[i], path, context);
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	t.mixin(t, {
	  ValidationError: ValidationError,
	  ValidationResult: ValidationResult,
	  validate: validate
	});
	
	module.exports = t;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.template = template;
	exports.mustache = mustache;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function template(src, opt_settings) {
	  src = _tcomb2['default'].String(src);
	  opt_settings = _tcomb2['default'].maybe(_tcomb2['default'].Object)(opt_settings);
	
	  opt_settings = opt_settings || template.jsp;
	
	  var tmpl = 'var __p=[],print=function(){__p.push.apply(__p,arguments);};' + 'with(obj||{}){__p.push(\'' + src.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(opt_settings.interpolate, function (match, code) {
	    return "'," + code.replace(/\\'/g, "'") + ",'";
	  }).replace(opt_settings.evaluate || null, function (match, code) {
	    return "');" + code.replace(/\\'/g, "'").replace(/[\r\n\t]/g, ' ') + "__p.push('";
	  }).replace(/\r/g, '\\r').replace(/\n/g, '\\n').replace(/\t/g, '\\t') + "');}return __p.join('');";
	
	  return new Function('obj', tmpl); // eslint-disable-line no-new-func
	}
	
	template.jsp = {
	  evaluate: /<%([\s\S]+?)%>/g,
	  interpolate: /<%=([\s\S]+?)%>/g
	};
	
	template.mustache = {
	  evaluate: /{{([\s\S]+?)}}/g,
	  interpolate: /{{=([\s\S]+?)}}/g
	};
	
	var template_cache = {};
	
	template.store = function (id, t) {
	  template_cache[id] = t;
	  return t;
	};
	
	template.of = function (id) {
	  return template_cache[id];
	};
	
	// Da usare quando il sorgente del template non può contenere <, >
	
	function mustache(src) {
	  return template(src, template.mustache);
	}

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/* global ga */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Google_Analytics;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function Google_Analytics() {}
	
	Google_Analytics.prototype.track_pageview = function (name) {
	  name = _tcomb2['default'].String(name);
	
	  if (typeof ga !== 'undefined') {
	    ga('send', 'pageview', name);
	  }
	};
	
	Google_Analytics.prototype.track_event = function (category, action, label) {
	  category = _tcomb2['default'].String(category);
	  action = _tcomb2['default'].String(action);
	  label = _tcomb2['default'].String(label);
	
	  if (typeof ga !== 'undefined') {
	    ga('send', 'event', category, action, label, 0);
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Locale = __webpack_require__(17);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Anonymous = __webpack_require__(118);
	
	var _Anonymous2 = _interopRequireDefault(_Anonymous);
	
	var _Registered = __webpack_require__(119);
	
	var _Registered2 = _interopRequireDefault(_Registered);
	
	var _Verified = __webpack_require__(150);
	
	var _Verified2 = _interopRequireDefault(_Verified);
	
	var _get_bundle = __webpack_require__(111);
	
	var _get_bundle2 = _interopRequireDefault(_get_bundle);
	
	var _Field = __webpack_require__(153);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _lodashCollectionFind = __webpack_require__(154);
	
	var _lodashCollectionFind2 = _interopRequireDefault(_lodashCollectionFind);
	
	var User = _tcomb2['default'].union([_Anonymous2['default'], _Registered2['default'], _Verified2['default']], 'User');
	
	User.dispatch = function (obj) {
	  switch (obj.profile) {
	    case 'anonymous':
	      return _Anonymous2['default'];
	    case 'registered':
	      return _Registered2['default'];
	    case 'verified':
	      return _Verified2['default'];
	  }
	  return obj.constructor;
	};
	
	User.to_fields = function (user, locale) {
	  var bundle = (0, _get_bundle2['default'])(locale).user;
	  var ret = {};
	
	  var _loop = function (field) {
	    if (user.hasOwnProperty(field)) {
	      switch (field) {
	        case 'gender':
	          ret[field] = (0, _lodashCollectionFind2['default'])(bundle.gender_options, function (option) {
	            return option[0] === user[field];
	          })[1];
	          break;
	        case 'district':
	          var districts = window.require('district/' + user.country);
	          ret[field] = (0, _lodashCollectionFind2['default'])(districts, function (option) {
	            return option[0] === user[field];
	          })[1];
	          break;
	        case 'birth_date':
	          ret[field] = locale.format_date(user[field]);
	          break;
	        case 'country':
	          ret[field] = locale.display_country(user[field]);
	          break;
	        default:
	          ret[field] = user[field];
	      }
	    }
	  };
	
	  for (var field in _Field2['default'].meta.map) {
	    _loop(field);
	  }
	  return ret;
	};
	
	User.of = function (user) {
	  if (['registered', 'verified'].indexOf(user.profile) !== -1) {
	    user.com_locale = _Locale2['default'].of(user.com_locale);
	  }
	  return User(user);
	};
	
	exports['default'] = User;
	module.exports = exports['default'];

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Anonymous = _tcomb2['default'].struct({}, 'Anonymous');
	
	module.exports = Anonymous;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Locale = __webpack_require__(17);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Email = __webpack_require__(120);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Registered = _tcomb2['default'].struct({
	  email: _Email2['default'],
	  com_locale: _Locale2['default'],
	  rcs_privacy_needed: _tcomb2['default'].Bool
	}, 'Registered');
	
	module.exports = Registered;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var emailRegexp = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
	
	var Email = _tcombForm2['default'].refinement(_tcombForm2['default'].String, function (s) {
	  return emailRegexp.test(s);
	});
	
	module.exports = Email;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/*! @preserve
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2014-2015 Giulio Canti
	 *
	 */
	var t = __webpack_require__(122);
	var templates = __webpack_require__(127);
	var i18n = __webpack_require__(149);
	
	t.form.Form.templates = templates;
	t.form.Form.i18n = i18n;
	
	module.exports = t;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcombValidation = __webpack_require__(114);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	var _components = __webpack_require__(123);
	
	var components = _interopRequireWildcard(_components);
	
	_tcombValidation2['default'].form = components;
	_tcombValidation2['default'].form.File = _tcombValidation2['default'].irreducible('File', function (x) {
	  return x instanceof File;
	});
	
	module.exports = _tcombValidation2['default'];

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.getComponent = getComponent;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombValidation = __webpack_require__(114);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	var _uvdomReact = __webpack_require__(124);
	
	var _util = __webpack_require__(126);
	
	var _classnames = __webpack_require__(125);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Nil = _tcombValidation2['default'].Nil;
	var assert = _tcombValidation2['default'].assert;
	var SOURCE = 'tcomb-form';
	var noobj = Object.freeze({});
	var noarr = Object.freeze([]);
	var noop = function noop() {};
	
	function getComponent(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var type = _x,
	        options = _x2;
	    name = undefined;
	    _again = false;
	
	    if (options.factory) {
	      return options.factory;
	    }
	    var name = _tcombValidation2['default'].getTypeName(type);
	    switch (type.meta.kind) {
	      case 'irreducible':
	        return type === _tcombValidation2['default'].Bool ? Checkbox : type === _tcombValidation2['default'].Dat ? Datetime : Textbox;
	      case 'struct':
	        return Struct;
	      case 'list':
	        return List;
	      case 'enums':
	        return Select;
	      case 'maybe':
	      case 'subtype':
	        _x = type.meta.type;
	        _x2 = options;
	        _again = true;
	        continue _function;
	
	      default:
	        _tcombValidation2['default'].fail('[' + SOURCE + '] unsupported type ' + name);
	    }
	  }
	}
	
	function sortByText(a, b) {
	  return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
	}
	
	function getComparator(order) {
	  return ({
	    asc: sortByText,
	    desc: function desc(a, b) {
	      return -sortByText(a, b);
	    }
	  })[order];
	}
	
	var decorators = {
	
	  template: function template(name) {
	    return function (Component) {
	      Component.prototype.getTemplate = function getTemplate() {
	        return this.props.options.template || this.props.ctx.templates[name];
	      };
	    };
	  },
	
	  attrs: function attrs(Component) {
	    Component.prototype.getAttrs = function getAttrs() {
	      var attrs = _tcombValidation2['default'].mixin({}, this.props.options.attrs);
	      attrs.id = this.getId();
	      attrs.name = this.getName();
	      if (attrs.className) {
	        var _attrs$className;
	
	        attrs.className = (_attrs$className = {}, _attrs$className[_classnames2['default'](attrs.className)] = true, _attrs$className);
	      }
	      return attrs;
	    };
	  },
	
	  templates: function templates(Component) {
	    Component.prototype.getTemplates = function getTemplates() {
	      return _util.merge(this.props.ctx.templates, this.props.options.templates);
	    };
	  }
	
	};
	
	exports.decorators = decorators;
	
	var Component = (function (_React$Component) {
	  _inherits(Component, _React$Component);
	
	  _createClass(Component, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  function Component(props) {
	    _classCallCheck(this, Component);
	
	    _React$Component.call(this, props);
	    this.typeInfo = _util.getTypeInfo(props.type);
	    this.state = {
	      hasError: false,
	      value: this.getTransformer().format(props.value)
	    };
	  }
	
	  Component.prototype.getTransformer = function getTransformer() {
	    return this.props.options.transformer || this.constructor.transformer;
	  };
	
	  Component.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    var should = nextState.value !== this.state.value || nextState.hasError !== this.state.hasError || nextProps.options !== this.props.options || nextProps.type !== this.props.type;
	    // console.log(nextState.value !== this.state.value,
	    //   nextState.hasError !== this.state.hasError,
	    //   nextProps.options !== this.props.options,
	    //   nextProps.type !== this.props.type,
	    //   should);
	    return should;
	  };
	
	  Component.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.type !== this.props.type) {
	      this.typeInfo = _util.getTypeInfo(props.type);
	    }
	    this.setState({ value: this.getTransformer().format(props.value) });
	  };
	
	  Component.prototype.onChange = function onChange(value) {
	    var _this = this;
	
	    this.setState({ value: value }, function () {
	      _this.props.onChange(value, _this.props.ctx.path);
	    });
	  };
	
	  Component.prototype.getValidationOptions = function getValidationOptions() {
	    return {
	      path: this.props.ctx.path,
	      context: _tcombValidation2['default'].mixin(_tcombValidation2['default'].mixin({}, this.props.context || this.props.ctx.context), { options: this.props.options })
	    };
	  };
	
	  Component.prototype.isValueNully = function isValueNully() {
	    return Nil.is(this.getTransformer().parse(this.state.value));
	  };
	
	  Component.prototype.removeErrors = function removeErrors() {
	    this.setState({ hasError: false });
	  };
	
	  Component.prototype.validate = function validate() {
	    var value = this.getTransformer().parse(this.state.value);
	    var result = _tcombValidation2['default'].validate(value, this.props.type, this.getValidationOptions());
	    this.setState({ hasError: !result.isValid() });
	    return result;
	  };
	
	  Component.prototype.getAuto = function getAuto() {
	    return this.props.options.auto || this.props.ctx.auto;
	  };
	
	  Component.prototype.getI18n = function getI18n() {
	    return this.props.options.i18n || this.props.ctx.i18n;
	  };
	
	  Component.prototype.getDefaultLabel = function getDefaultLabel() {
	    var ctx = this.props.ctx;
	    if (ctx.label) {
	      return ctx.label + (this.typeInfo.isMaybe ? this.getI18n().optional : this.getI18n().required);
	    }
	  };
	
	  Component.prototype.getLabel = function getLabel() {
	    var ctx = this.props.ctx;
	    var legend = this.props.options.legend;
	    var label = this.props.options.label;
	    label = label || legend;
	    if (Nil.is(label) && ctx.auto === 'labels') {
	      label = this.getDefaultLabel();
	    }
	    return label;
	  };
	
	  Component.prototype.getError = function getError() {
	    var error = this.props.options.error || this.typeInfo.getValidationErrorMessage;
	    if (_tcombValidation2['default'].Func.is(error)) {
	      var validationOptions = this.getValidationOptions();
	      var value = this.getTransformer().parse(this.state.value);
	      return error(value, validationOptions.path, validationOptions.context);
	    }
	    return error;
	  };
	
	  Component.prototype.hasError = function hasError() {
	    return this.props.options.hasError || this.state.hasError;
	  };
	
	  Component.prototype.getConfig = function getConfig() {
	    return _util.merge(this.props.ctx.config, this.props.options.config);
	  };
	
	  Component.prototype.getId = function getId() {
	    var attrs = this.props.options.attrs || noobj;
	    if (attrs.id) {
	      return attrs.id;
	    }
	    if (!this.uid) {
	      this.uid = this.props.ctx.uidGenerator.next();
	    }
	    return this.uid;
	  };
	
	  Component.prototype.getName = function getName() {
	    return this.props.options.name || this.props.ctx.name || this.getId();
	  };
	
	  Component.prototype.getLocals = function getLocals() {
	    var options = this.props.options;
	    var value = this.state.value;
	    return {
	      typeInfo: this.typeInfo,
	      path: this.props.ctx.path,
	      error: this.getError(),
	      hasError: this.hasError(),
	      label: this.getLabel(),
	      onChange: this.onChange.bind(this),
	      config: this.getConfig(),
	      value: value,
	      disabled: options.disabled,
	      help: options.help
	    };
	  };
	
	  Component.prototype.render = function render() {
	    var locals = this.getLocals();
	    // getTemplate is the only required implementation when extending Component
	    assert(_tcombValidation2['default'].Func.is(this.getTemplate), '[' + SOURCE + '] missing getTemplate method of component ' + this.constructor.name);
	    var template = this.getTemplate();
	    return _uvdomReact.compile(template(locals));
	  };
	
	  return Component;
	})(_react2['default'].Component);
	
	exports.Component = Component;
	
	function toNull(value) {
	  return _tcombValidation2['default'].Str.is(value) && value.trim() === '' || Nil.is(value) ? null : value;
	}
	
	function parseNumber(value) {
	  var n = parseFloat(value);
	  var isNumeric = value - n + 1 >= 0;
	  return isNumeric ? n : toNull(value);
	}
	
	var Textbox = (function (_Component) {
	  _inherits(Textbox, _Component);
	
	  function Textbox() {
	    _classCallCheck(this, _Textbox);
	
	    _Component.apply(this, arguments);
	  }
	
	  Textbox.prototype.getTransformer = function getTransformer() {
	    var options = this.props.options;
	    return options.transformer ? options.transformer : this.typeInfo.innerType === _tcombValidation2['default'].Num ? Textbox.numberTransformer : Textbox.transformer;
	  };
	
	  Textbox.prototype.getPlaceholder = function getPlaceholder() {
	    var attrs = this.props.options.attrs || noobj;
	    var placeholder = attrs.placeholder;
	    if (Nil.is(placeholder) && this.getAuto() === 'placeholders') {
	      placeholder = this.getDefaultLabel();
	    }
	    return placeholder;
	  };
	
	  Textbox.prototype.getLocals = function getLocals() {
	    var locals = _Component.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.attrs.placeholder = this.getPlaceholder();
	    locals.type = this.props.options.type || 'text';
	    return locals;
	  };
	
	  _createClass(Textbox, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : value;
	      },
	      parse: toNull
	    },
	    enumerable: true
	  }, {
	    key: 'numberTransformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : String(value);
	      },
	      parse: parseNumber
	    },
	    enumerable: true
	  }]);
	
	  var _Textbox = Textbox;
	  Textbox = decorators.template('textbox')(Textbox) || Textbox;
	  Textbox = decorators.attrs(Textbox) || Textbox;
	  return Textbox;
	})(Component);
	
	exports.Textbox = Textbox;
	
	var Checkbox = (function (_Component2) {
	  _inherits(Checkbox, _Component2);
	
	  function Checkbox() {
	    _classCallCheck(this, _Checkbox);
	
	    _Component2.apply(this, arguments);
	  }
	
	  Checkbox.prototype.getLocals = function getLocals() {
	    var locals = _Component2.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    // checkboxes must always have a label
	    locals.label = locals.label || this.getDefaultLabel();
	    return locals;
	  };
	
	  _createClass(Checkbox, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? false : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Checkbox = Checkbox;
	  Checkbox = decorators.template('checkbox')(Checkbox) || Checkbox;
	  Checkbox = decorators.attrs(Checkbox) || Checkbox;
	  return Checkbox;
	})(Component);
	
	exports.Checkbox = Checkbox;
	
	var Select = (function (_Component3) {
	  _inherits(Select, _Component3);
	
	  function Select() {
	    _classCallCheck(this, _Select);
	
	    _Component3.apply(this, arguments);
	  }
	
	  Select.prototype.getTransformer = function getTransformer() {
	    var options = this.props.options;
	    if (options.transformer) {
	      return options.transformer;
	    }
	    if (this.isMultiple()) {
	      return Select.multipleTransformer;
	    }
	    return Select.transformer(this.getNullOption());
	  };
	
	  Select.prototype.getNullOption = function getNullOption() {
	    return this.props.options.nullOption || { value: '', text: '-' };
	  };
	
	  Select.prototype.isMultiple = function isMultiple() {
	    return this.typeInfo.innerType.meta.kind === 'list';
	  };
	
	  Select.prototype.getEnum = function getEnum() {
	    return this.isMultiple() ? _util.getTypeInfo(this.typeInfo.innerType.meta.type).innerType : this.typeInfo.innerType;
	  };
	
	  Select.prototype.getOptions = function getOptions() {
	    var options = this.props.options;
	    var items = options.options ? options.options.slice() : _util.getOptionsOfEnum(this.getEnum());
	    if (options.order) {
	      items.sort(getComparator(options.order));
	    }
	    var nullOption = this.getNullOption();
	    if (!this.isMultiple() && options.nullOption !== false) {
	      items.unshift(nullOption);
	    }
	    return items;
	  };
	
	  Select.prototype.getLocals = function getLocals() {
	    var locals = _Component3.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.options = this.getOptions();
	    locals.isMultiple = this.isMultiple();
	    return locals;
	  };
	
	  _createClass(Select, null, [{
	    key: 'transformer',
	    value: function value(nullOption) {
	      return {
	        format: function format(value) {
	          return Nil.is(value) && nullOption ? nullOption.value : value;
	        },
	        parse: function parse(value) {
	          return nullOption && nullOption.value === value ? null : value;
	        }
	      };
	    },
	    enumerable: true
	  }, {
	    key: 'multipleTransformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? noarr : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Select = Select;
	  Select = decorators.template('select')(Select) || Select;
	  Select = decorators.attrs(Select) || Select;
	  return Select;
	})(Component);
	
	exports.Select = Select;
	
	var Radio = (function (_Component4) {
	  _inherits(Radio, _Component4);
	
	  function Radio() {
	    _classCallCheck(this, _Radio);
	
	    _Component4.apply(this, arguments);
	  }
	
	  Radio.prototype.getOptions = function getOptions() {
	    var options = this.props.options;
	    var items = options.options ? options.options.slice() : _util.getOptionsOfEnum(this.typeInfo.innerType);
	    if (options.order) {
	      items.sort(getComparator(options.order));
	    }
	    return items;
	  };
	
	  Radio.prototype.getLocals = function getLocals() {
	    var locals = _Component4.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.options = this.getOptions();
	    return locals;
	  };
	
	  _createClass(Radio, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Radio = Radio;
	  Radio = decorators.template('radio')(Radio) || Radio;
	  Radio = decorators.attrs(Radio) || Radio;
	  return Radio;
	})(Component);
	
	exports.Radio = Radio;
	
	var Datetime = (function (_Component5) {
	  _inherits(Datetime, _Component5);
	
	  function Datetime() {
	    _classCallCheck(this, _Datetime);
	
	    _Component5.apply(this, arguments);
	  }
	
	  Datetime.prototype.getOrder = function getOrder() {
	    return this.props.options.order || ['M', 'D', 'YY'];
	  };
	
	  Datetime.prototype.getLocals = function getLocals() {
	    var locals = _Component5.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.order = this.getOrder();
	    return locals;
	  };
	
	  _createClass(Datetime, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return _tcombValidation2['default'].Arr.is(value) ? value : _tcombValidation2['default'].Dat.is(value) ? [value.getFullYear(), value.getMonth(), value.getDate()].map(String) : [null, null, null];
	      },
	      parse: function parse(value) {
	        value = value.map(parseNumber);
	        return value.every(_tcombValidation2['default'].Num.is) ? new Date(value[0], value[1], value[2]) : value.every(Nil.is) ? null : value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Datetime = Datetime;
	  Datetime = decorators.template('date')(Datetime) || Datetime;
	  Datetime = decorators.attrs(Datetime) || Datetime;
	  return Datetime;
	})(Component);
	
	exports.Datetime = Datetime;
	
	var Struct = (function (_Component6) {
	  _inherits(Struct, _Component6);
	
	  function Struct() {
	    _classCallCheck(this, _Struct);
	
	    _Component6.apply(this, arguments);
	  }
	
	  Struct.prototype.isValueNully = function isValueNully() {
	    var _this2 = this;
	
	    return Object.keys(this.refs).every(function (ref) {
	      return _this2.refs[ref].isValueNully();
	    });
	  };
	
	  Struct.prototype.removeErrors = function removeErrors() {
	    var _this3 = this;
	
	    this.setState({ hasError: false });
	    Object.keys(this.refs).forEach(function (ref) {
	      return _this3.refs[ref].removeErrors();
	    });
	  };
	
	  Struct.prototype.validate = function validate() {
	    var value = {};
	    var errors = [];
	    var hasError = false;
	    var result = undefined;
	
	    if (this.typeInfo.isMaybe && this.isValueNully()) {
	      this.removeErrors();
	      return new _tcombValidation2['default'].ValidationResult({ errors: [], value: null });
	    }
	
	    for (var ref in this.refs) {
	      if (this.refs.hasOwnProperty(ref)) {
	        result = this.refs[ref].validate();
	        errors = errors.concat(result.errors);
	        value[ref] = result.value;
	      }
	    }
	
	    if (errors.length === 0) {
	      var InnerType = this.typeInfo.innerType;
	      value = new InnerType(value);
	      if (this.typeInfo.isSubtype && errors.length === 0) {
	        result = _tcombValidation2['default'].validate(value, this.props.type, this.getValidationOptions());
	        hasError = !result.isValid();
	        errors = errors.concat(result.errors);
	      }
	    }
	
	    this.setState({ hasError: hasError });
	    return new _tcombValidation2['default'].ValidationResult({ errors: errors, value: value });
	  };
	
	  Struct.prototype.onChange = function onChange(fieldName, fieldValue, path, kind) {
	    var _this4 = this;
	
	    var value = _tcombValidation2['default'].mixin({}, this.state.value);
	    value[fieldName] = fieldValue;
	    this.setState({ value: value }, function () {
	      _this4.props.onChange(value, path, kind);
	    });
	  };
	
	  Struct.prototype.getTemplate = function getTemplate() {
	    return this.props.options.template || this.getTemplates().struct;
	  };
	
	  Struct.prototype.getTypeProps = function getTypeProps() {
	    return this.typeInfo.innerType.meta.props;
	  };
	
	  Struct.prototype.getOrder = function getOrder() {
	    return this.props.options.order || Object.keys(this.getTypeProps());
	  };
	
	  Struct.prototype.getInputs = function getInputs() {
	    var _props = this.props;
	    var options = _props.options;
	    var ctx = _props.ctx;
	
	    var props = this.getTypeProps();
	    var auto = this.getAuto();
	    var i18n = this.getI18n();
	    var config = this.getConfig();
	    var templates = this.getTemplates();
	    var value = this.state.value;
	    var inputs = {};
	
	    for (var prop in props) {
	      if (props.hasOwnProperty(prop)) {
	        var propType = props[prop];
	        var propOptions = options.fields && options.fields[prop] ? options.fields[prop] : noobj;
	        inputs[prop] = _react2['default'].createElement(getComponent(propType, propOptions), {
	          key: prop,
	          ref: prop,
	          type: propType,
	          options: propOptions,
	          value: value[prop],
	          onChange: this.onChange.bind(this, prop),
	          ctx: {
	            context: ctx.context,
	            uidGenerator: ctx.uidGenerator,
	            auto: auto,
	            config: config,
	            name: ctx.name ? ctx.name + '[' + prop + ']' : prop,
	            label: _util.humanize(prop),
	            i18n: i18n,
	            templates: templates,
	            path: ctx.path.concat(prop)
	          }
	        });
	      }
	    }
	    return inputs;
	  };
	
	  Struct.prototype.getLocals = function getLocals() {
	    var options = this.props.options;
	    var locals = _Component6.prototype.getLocals.call(this);
	    locals.order = this.getOrder();
	    locals.inputs = this.getInputs();
	    locals.className = options.className;
	    return locals;
	  };
	
	  _createClass(Struct, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? noobj : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Struct = Struct;
	  Struct = decorators.templates(Struct) || Struct;
	  return Struct;
	})(Component);
	
	exports.Struct = Struct;
	
	function toSameLength(value, keys, uidGenerator) {
	  if (value.length === keys.length) {
	    return keys;
	  }
	  var ret = [];
	  for (var i = 0, len = value.length; i < len; i++) {
	    ret[i] = keys[i] || uidGenerator.next();
	  }
	  return ret;
	}
	
	var List = (function (_Component7) {
	  _inherits(List, _Component7);
	
	  _createClass(List, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? noarr : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  function List(props) {
	    _classCallCheck(this, _List);
	
	    _Component7.call(this, props);
	    this.state.keys = this.state.value.map(function () {
	      return props.ctx.uidGenerator.next();
	    });
	  }
	
	  List.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.type !== this.props.type) {
	      this.typeInfo = _util.getTypeInfo(props.type);
	    }
	    var value = this.getTransformer().format(props.value);
	    this.setState({
	      value: value,
	      keys: toSameLength(value, this.state.keys, props.ctx.uidGenerator)
	    });
	  };
	
	  List.prototype.isValueNully = function isValueNully() {
	    return this.state.value.length === 0;
	  };
	
	  List.prototype.removeErrors = function removeErrors() {
	    var _this5 = this;
	
	    this.setState({ hasError: false });
	    Object.keys(this.refs).forEach(function (ref) {
	      return _this5.refs[ref].removeErrors();
	    });
	  };
	
	  List.prototype.validate = function validate() {
	    var value = [];
	    var errors = [];
	    var hasError = false;
	    var result = undefined;
	
	    if (this.typeInfo.isMaybe && this.isValueNully()) {
	      this.removeErrors();
	      return new _tcombValidation2['default'].ValidationResult({ errors: [], value: null });
	    }
	
	    for (var i = 0, len = this.state.value.length; i < len; i++) {
	      result = this.refs[i].validate();
	      errors = errors.concat(result.errors);
	      value.push(result.value);
	    }
	
	    // handle subtype
	    if (this.typeInfo.isSubtype && errors.length === 0) {
	      result = _tcombValidation2['default'].validate(value, this.props.type, this.getValidationOptions());
	      hasError = !result.isValid();
	      errors = errors.concat(result.errors);
	    }
	
	    this.setState({ hasError: hasError });
	    return new _tcombValidation2['default'].ValidationResult({ errors: errors, value: value });
	  };
	
	  List.prototype.onChange = function onChange(value, keys, path, kind) {
	    var _this6 = this;
	
	    keys = toSameLength(value, keys, this.props.ctx.uidGenerator);
	    this.setState({ value: value, keys: keys }, function () {
	      _this6.props.onChange(value, path, kind);
	    });
	  };
	
	  List.prototype.addItem = function addItem(evt) {
	    evt.preventDefault();
	    var value = this.state.value.concat(undefined);
	    var keys = this.state.keys.concat(this.props.ctx.uidGenerator.next());
	    this.onChange(value, keys, this.props.ctx.path.concat(value.length - 1), 'add');
	  };
	
	  List.prototype.onItemChange = function onItemChange(itemIndex, itemValue, path, kind) {
	    var value = this.state.value.slice();
	    value[itemIndex] = itemValue;
	    this.onChange(value, this.state.keys, path, kind);
	  };
	
	  List.prototype.removeItem = function removeItem(i, evt) {
	    evt.preventDefault();
	    var value = this.state.value.slice();
	    value.splice(i, 1);
	    var keys = this.state.keys.slice();
	    keys.splice(i, 1);
	    this.onChange(value, keys, this.props.ctx.path.concat(i), 'remove');
	  };
	
	  List.prototype.moveUpItem = function moveUpItem(i, evt) {
	    evt.preventDefault();
	    if (i > 0) {
	      this.onChange(_util.move(this.state.value.slice(), i, i - 1), _util.move(this.state.keys.slice(), i, i - 1), this.props.ctx.path.concat(i), 'moveUp');
	    }
	  };
	
	  List.prototype.moveDownItem = function moveDownItem(i, evt) {
	    evt.preventDefault();
	    if (i < this.state.value.length - 1) {
	      this.onChange(_util.move(this.state.value.slice(), i, i + 1), _util.move(this.state.keys.slice(), i, i + 1), this.props.ctx.path.concat(i), 'moveDown');
	    }
	  };
	
	  List.prototype.getTemplate = function getTemplate() {
	    return this.props.options.template || this.getTemplates().list;
	  };
	
	  List.prototype.getItems = function getItems() {
	    var _this7 = this;
	
	    var _props2 = this.props;
	    var options = _props2.options;
	    var ctx = _props2.ctx;
	
	    var auto = this.getAuto();
	    var i18n = this.getI18n();
	    var config = this.getConfig();
	    var templates = this.getTemplates();
	    var value = this.state.value;
	    var type = this.typeInfo.innerType.meta.type;
	    var Component = getComponent(type, options.item || noobj);
	    return value.map(function (value, i) {
	      var buttons = [];
	      if (!options.disableRemove) {
	        buttons.push({ label: i18n.remove, click: _this7.removeItem.bind(_this7, i) });
	      }
	      if (!options.disableOrder) {
	        buttons.push({ label: i18n.up, click: _this7.moveUpItem.bind(_this7, i) });
	      }
	      if (!options.disableOrder) {
	        buttons.push({ label: i18n.down, click: _this7.moveDownItem.bind(_this7, i) });
	      }
	      return {
	        input: _react2['default'].createElement(Component, {
	          ref: i,
	          type: type,
	          options: options.item || noobj,
	          value: value,
	          onChange: _this7.onItemChange.bind(_this7, i),
	          ctx: {
	            context: ctx.context,
	            uidGenerator: ctx.uidGenerator,
	            auto: auto,
	            config: config,
	            i18n: i18n,
	            name: ctx.name ? ctx.name + '[' + i + ']' : String(i),
	            templates: templates,
	            path: ctx.path.concat(i)
	          }
	        }),
	        key: _this7.state.keys[i],
	        buttons: buttons
	      };
	    });
	  };
	
	  List.prototype.getLocals = function getLocals() {
	    var options = this.props.options;
	    var i18n = this.getI18n();
	    var locals = _Component7.prototype.getLocals.call(this);
	    locals.add = options.disableAdd ? null : {
	      label: i18n.add,
	      click: this.addItem.bind(this)
	    };
	    locals.items = this.getItems();
	    locals.className = options.className;
	    return locals;
	  };
	
	  var _List = List;
	  List = decorators.templates(List) || List;
	  return List;
	})(Component);
	
	exports.List = List;
	
	var Form = (function (_React$Component2) {
	  _inherits(Form, _React$Component2);
	
	  function Form() {
	    _classCallCheck(this, Form);
	
	    _React$Component2.apply(this, arguments);
	  }
	
	  Form.prototype.validate = function validate() {
	    return this.refs.input.validate();
	  };
	
	  Form.prototype.getValue = function getValue(raw) {
	    var result = this.validate();
	    return raw === true ? result : result.isValid() ? result.value : null;
	  };
	
	  Form.prototype.getComponent = function getComponent(path) {
	    path = _tcombValidation2['default'].Str.is(path) ? path.split('.') : path;
	    return path.reduce(function (input, name) {
	      return input.refs[name];
	    }, this.refs.input);
	  };
	
	  Form.prototype.render = function render() {
	
	    var type = this.props.type;
	    var options = this.props.options || noobj;
	    var i18n = Form.i18n;
	    var templates = Form.templates;
	
	    assert(_tcombValidation2['default'].isType(type), '[' + SOURCE + '] missing required prop type');
	    assert(_tcombValidation2['default'].Obj.is(options), '[' + SOURCE + '] prop options must be an object');
	    assert(_tcombValidation2['default'].Obj.is(templates), '[' + SOURCE + '] missing templates config');
	    assert(_tcombValidation2['default'].Obj.is(i18n), '[' + SOURCE + '] missing i18n config');
	
	    // this is in the render method because I need this._reactInternalInstance
	    this.uidGenerator = this.uidGenerator || new _util.UIDGenerator(this._reactInternalInstance ? this._reactInternalInstance._rootNodeID : '');
	
	    var Component = getComponent(type, options);
	    return _react2['default'].createElement(Component, {
	      ref: 'input',
	      type: type,
	      options: options,
	      value: this.props.value,
	      onChange: this.props.onChange || noop,
	      ctx: this.props.ctx || {
	        context: this.props.context,
	        uidGenerator: this.uidGenerator,
	        auto: 'labels',
	        templates: templates,
	        i18n: i18n,
	        path: []
	      }
	    });
	  };
	
	  return Form;
	})(_react2['default'].Component);
	
	exports.Form = Form;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(3);
	var cx = __webpack_require__(125);
	
	// compile: x -> ReactElement
	function compile(x) {
	
	  // with host elements, compile behaves like the identity
	  if (React.isValidElement(x)) {
	    return x;
	  }
	
	  if (Array.isArray(x)) {
	    return x.map(compile);
	  }
	
	  if (typeof x === 'object' && x !== null) {
	
	    // attrs
	    var attrs = mixin({}, x.attrs);
	    if (attrs.className) {
	      attrs.className = cx(attrs.className) || null; // avoid class=""
	    }
	    if (x.key != null) { attrs.key = x.key; }
	    if (x.ref != null) { attrs.ref = x.ref; }
	
	    // events
	    if (x.events) {
	      for (var name in x.events) {
	        attrs[camelizeEvent(name)] = x.events[name];
	      }
	    }
	
	    // children
	    var children = compile(x.children);
	
	    // build ReactElement
	    return React.createElement.apply(React, [x.tag, attrs].concat(children));
	  }
	
	  return x;
	}
	
	//
	// helpers
	//
	
	// transforms an event name to a React event name
	// click -> onClick
	// blur -> onBlur
	function camelizeEvent(name) {
	  return 'on' + name.charAt(0).toUpperCase() + name.substring(1);
	}
	
	function mixin(x, y) {
	  if (!y) { return x; }
	  for (var k in y) {
	    if (y.hasOwnProperty(k)) {
	      x[k] = y[k];
	    }
	  }
	  return x;
	}
	
	module.exports = {
	  compile: compile
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes += ' ' + arg;
				} else if (Array.isArray(arg)) {
					classes += ' ' + classNames.apply(null, arg);
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes += ' ' + key;
						}
					}
				}
			}
	
			return classes.substr(1);
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getOptionsOfEnum = getOptionsOfEnum;
	exports.getTypeInfo = getTypeInfo;
	exports.humanize = humanize;
	exports.merge = merge;
	exports.move = move;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _tcombValidation = __webpack_require__(114);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	function getOptionsOfEnum(type) {
	  var enums = type.meta.map;
	  return Object.keys(enums).map(function (value) {
	    return {
	      value: value,
	      text: enums[value]
	    };
	  });
	}
	
	function getTypeInfo(type) {
	
	  var innerType = type;
	  var isMaybe = false;
	  var isSubtype = false;
	  var kind = undefined;
	  var innerGetValidationErrorMessage = undefined;
	
	  while (innerType) {
	    kind = innerType.meta.kind;
	    if (_tcombValidation2['default'].Func.is(innerType.getValidationErrorMessage)) {
	      innerGetValidationErrorMessage = innerType.getValidationErrorMessage;
	    }
	    if (kind === 'maybe') {
	      isMaybe = true;
	      innerType = innerType.meta.type;
	      continue;
	    }
	    if (kind === 'subtype') {
	      isSubtype = true;
	      innerType = innerType.meta.type;
	      continue;
	    }
	    break;
	  }
	
	  var getValidationErrorMessage = innerGetValidationErrorMessage ? function (value, path, context) {
	    var result = _tcombValidation2['default'].validate(value, type, { path: path, context: context });
	    if (!result.isValid()) {
	      for (var i = 0, len = result.errors.length; i < len; i++) {
	        if (_tcombValidation2['default'].Func.is(result.errors[i].expected.getValidationErrorMessage)) {
	          return result.errors[i].message;
	        }
	      }
	      return innerGetValidationErrorMessage(value, path, context);
	    }
	  } : undefined;
	
	  return {
	    type: type,
	    isMaybe: isMaybe,
	    isSubtype: isSubtype,
	    innerType: innerType,
	    getValidationErrorMessage: getValidationErrorMessage
	  };
	}
	
	// thanks to https://github.com/epeli/underscore.string
	
	function underscored(s) {
	  return s.trim().replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
	}
	
	function capitalize(s) {
	  return s.charAt(0).toUpperCase() + s.slice(1);
	}
	
	function humanize(s) {
	  return capitalize(underscored(s).replace(/_id$/, '').replace(/_/g, ' '));
	}
	
	function merge(a, b) {
	  return _tcombValidation.mixin(_tcombValidation.mixin({}, a), b, true);
	}
	
	function move(arr, fromIndex, toIndex) {
	  var element = arr.splice(fromIndex, 1)[0];
	  arr.splice(toIndex, 0, element);
	  return arr;
	}
	
	var UIDGenerator = (function () {
	  function UIDGenerator(seed) {
	    _classCallCheck(this, UIDGenerator);
	
	    this.seed = seed;
	    this.counter = 0;
	  }
	
	  UIDGenerator.prototype.next = function next() {
	    var id = this.seed + this.counter++;
	    return id;
	  };
	
	  return UIDGenerator;
	})();
	
	exports.UIDGenerator = UIDGenerator;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.textbox = textbox;
	exports.checkbox = checkbox;
	exports.select = select;
	exports.radio = radio;
	exports.date = date;
	exports.struct = struct;
	exports.list = list;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcombValidation = __webpack_require__(114);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	var _uvdomBootstrap = __webpack_require__(128);
	
	var _uvdomBootstrap2 = _interopRequireDefault(_uvdomBootstrap);
	
	var Any = _tcombValidation2['default'].Any;
	var maybe = _tcombValidation2['default'].maybe;
	var noobj = {};
	
	var Positive = _tcombValidation2['default'].subtype(_tcombValidation2['default'].Num, function (n) {
	  return n % 1 === 0 && n >= 0;
	}, 'Positive');
	
	var Cols = _tcombValidation2['default'].tuple([Positive, Positive], 'Cols');
	
	var Breakpoints = _tcombValidation2['default'].struct({
	  xs: maybe(Cols),
	  sm: maybe(Cols),
	  md: maybe(Cols),
	  lg: maybe(Cols)
	}, 'Breakpoints');
	
	Breakpoints.prototype.getBreakpoints = function (index) {
	  var breakpoints = {};
	  for (var size in this) {
	    if (this.hasOwnProperty(size) && !_tcombValidation2['default'].Nil.is(this[size])) {
	      breakpoints[size] = this[size][index];
	    }
	  }
	  return breakpoints;
	};
	
	Breakpoints.prototype.getLabelClassName = function () {
	  return _uvdomBootstrap2['default'].getBreakpoints(this.getBreakpoints(0));
	};
	
	Breakpoints.prototype.getInputClassName = function () {
	  return _uvdomBootstrap2['default'].getBreakpoints(this.getBreakpoints(1));
	};
	
	Breakpoints.prototype.getOffsetClassName = function () {
	  return _tcombValidation2['default'].mixin(_uvdomBootstrap2['default'].getOffsets(this.getBreakpoints(1)), _uvdomBootstrap2['default'].getBreakpoints(this.getBreakpoints(1)));
	};
	
	var Size = _tcombValidation2['default'].enums.of('xs sm md lg', 'Size');
	
	var TextboxConfig = _tcombValidation2['default'].struct({
	  addonBefore: Any,
	  addonAfter: Any,
	  horizontal: maybe(Breakpoints),
	  size: maybe(Size),
	  buttonBefore: Any,
	  buttonAfter: Any
	}, 'TextboxConfig');
	
	var CheckboxConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'CheckboxConfig');
	
	var SelectConfig = _tcombValidation2['default'].struct({
	  addonBefore: Any,
	  addonAfter: Any,
	  horizontal: maybe(Breakpoints),
	  size: maybe(Size)
	}, 'SelectConfig');
	
	var RadioConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'RadioConfig');
	
	var DateConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'DateConfig');
	
	var StructConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'StructConfig');
	
	var ListConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'ListConfig');
	
	function getLabel(_ref) {
	  var label = _ref.label;
	  var breakpoints = _ref.breakpoints;
	  var htmlFor = _ref.htmlFor;
	  var id = _ref.id;
	  var align = _ref.align;
	
	  if (!label) {
	    return;
	  }
	
	  var className = breakpoints ? breakpoints.getLabelClassName() : null;
	
	  return _uvdomBootstrap2['default'].getLabel({
	    align: align,
	    className: className,
	    htmlFor: htmlFor,
	    id: id,
	    label: label
	  });
	}
	
	function getHelp(_ref2) {
	  var help = _ref2.help;
	  var attrs = _ref2.attrs;
	
	  if (!help) {
	    return;
	  }
	  return _uvdomBootstrap2['default'].getHelpBlock({
	    help: help,
	    id: attrs.id + '-tip'
	  });
	}
	
	function getError(_ref3) {
	  var hasError = _ref3.hasError;
	  var error = _ref3.error;
	
	  if (!hasError || !error) {
	    return;
	  }
	  return _uvdomBootstrap2['default'].getErrorBlock({
	    error: error,
	    hasError: hasError
	  });
	}
	
	function getHiddenTextbox(_ref4) {
	  var value = _ref4.value;
	  var name = _ref4.name;
	
	  return {
	    tag: 'input',
	    attrs: {
	      type: 'hidden',
	      value: value,
	      name: name
	    }
	  };
	}
	
	function getInputGroupButton(button) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'input-group-btn': true
	      }
	    },
	    children: button
	  };
	}
	
	function textbox(locals) {
	
	  var config = new TextboxConfig(locals.config || noobj);
	
	  if (locals.type === 'hidden') {
	    return getHiddenTextbox(locals);
	  }
	
	  var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	  var control = undefined;
	
	  if (locals.type === 'static') {
	    control = _uvdomBootstrap2['default'].getStatic(locals.value);
	  } else {
	
	    var tag = 'textarea';
	    if (locals.type !== 'textarea') {
	      tag = 'input';
	      attrs.type = locals.type;
	    }
	
	    attrs.className = _tcombValidation2['default'].mixin({}, attrs.className);
	    attrs.className['form-control'] = true;
	
	    attrs.disabled = locals.disabled;
	    if (locals.type !== 'file') {
	      attrs.value = locals.value;
	    }
	    attrs.onChange = locals.type === 'file' ? function (evt) {
	      return locals.onChange(evt.target.files[0]);
	    } : function (evt) {
	      return locals.onChange(evt.target.value);
	    };
	
	    if (locals.help) {
	      attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	    }
	
	    control = {
	      tag: tag,
	      attrs: attrs
	    };
	    if (config.addonBefore || config.addonAfter || config.buttonBefore || config.buttonAfter) {
	      control = _uvdomBootstrap2['default'].getInputGroup([config.buttonBefore ? getInputGroupButton(config.buttonBefore) : null, config.addonBefore ? _uvdomBootstrap2['default'].getAddon(config.addonBefore) : null, control, config.addonAfter ? _uvdomBootstrap2['default'].getAddon(config.addonAfter) : null, config.buttonAfter ? getInputGroupButton(config.buttonAfter) : null]);
	    }
	  }
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    htmlFor: attrs.id,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	
	  var children = [label, control, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [control, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function checkbox(locals) {
	
	  var config = new CheckboxConfig(locals.config || noobj);
	
	  var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	  attrs.type = 'checkbox';
	  attrs.disabled = locals.disabled;
	  attrs.checked = locals.value;
	  attrs.onChange = function (evt) {
	    return locals.onChange(evt.target.checked);
	  };
	
	  if (locals.help) {
	    attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	  }
	
	  var control = _uvdomBootstrap2['default'].getCheckbox(attrs, locals.label);
	
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [control, error, help];
	
	  if (config.horizontal) {
	    children = {
	      tag: 'div',
	      attrs: {
	        className: config.horizontal.getOffsetClassName()
	      },
	      children: children
	    };
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function select(locals) {
	
	  var config = new SelectConfig(locals.config || noobj);
	
	  var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	
	  attrs.className = _tcombValidation2['default'].mixin({}, attrs.className);
	  attrs.className['form-control'] = true;
	
	  attrs.multiple = locals.isMultiple;
	  attrs.disabled = locals.disabled;
	  attrs.value = locals.value;
	  attrs.onChange = function (evt) {
	    var value = locals.isMultiple ? Array.prototype.slice.call(evt.target.options).filter(function (option) {
	      return option.selected;
	    }).map(function (option) {
	      return option.value;
	    }) : evt.target.value;
	    locals.onChange(value);
	  };
	
	  if (locals.help) {
	    attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	  }
	
	  var options = locals.options.map(function (x) {
	    return x.label ? _uvdomBootstrap2['default'].getOptGroup(x) : _uvdomBootstrap2['default'].getOption(x);
	  });
	
	  var control = {
	    tag: 'select',
	    attrs: attrs,
	    children: options
	  };
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    htmlFor: attrs.id,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [label, control, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [control, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function radio(locals) {
	
	  var config = new RadioConfig(locals.config || noobj);
	
	  var id = locals.attrs.id;
	  var onChange = function onChange(evt) {
	    return locals.onChange(evt.target.value);
	  };
	
	  var controls = locals.options.map(function (option, i) {
	
	    var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	    attrs.type = 'radio';
	    attrs.checked = option.value === locals.value;
	    attrs.disabled = locals.disabled;
	    attrs.value = option.value;
	    attrs.autoFocus = attrs.autoFocus && i === 0;
	    attrs.id = id + '_' + i;
	    attrs['aria-describedby'] = attrs['aria-describedby'] || (locals.label ? id : null);
	    attrs.onChange = onChange;
	
	    return _uvdomBootstrap2['default'].getRadio(attrs, option.text, option.value);
	  });
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    id: id,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [label, controls, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [controls, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function range(n) {
	  var result = [];
	  for (var i = 1; i <= n; i++) {
	    result.push(i);
	  }
	  return result;
	}
	
	function padLeft(x, len) {
	  var str = String(x);
	  var times = len - str.length;
	  for (var i = 0; i < times; i++) {
	    str = '0' + str;
	  }
	  return str;
	}
	
	function toOption(value, text) {
	  return {
	    tag: 'option',
	    attrs: { value: value + '' },
	    children: text
	  };
	}
	
	var nullOption = [toOption('', '-')];
	
	var days = nullOption.concat(range(31).map(function (i) {
	  return toOption(i, padLeft(i, 2));
	}));
	
	var months = nullOption.concat(range(12).map(function (i) {
	  return toOption(i - 1, padLeft(i, 2));
	}));
	
	function date(locals) {
	
	  var config = new DateConfig(locals.config || noobj);
	  var value = locals.value.slice();
	
	  function onDayChange(evt) {
	    value[2] = evt.target.value === '-' ? null : evt.target.value;
	    locals.onChange(value);
	  }
	
	  function onMonthChange(evt) {
	    value[1] = evt.target.value === '-' ? null : evt.target.value;
	    locals.onChange(value);
	  }
	
	  function onYearChange(evt) {
	    value[0] = evt.target.value.trim() === '' ? null : evt.target.value.trim();
	    locals.onChange(value);
	  }
	
	  var parts = {
	
	    D: {
	      tag: 'li',
	      key: 'D',
	      children: {
	        tag: 'select',
	        attrs: {
	          disabled: locals.disabled,
	          className: {
	            'form-control': true
	          },
	          value: value[2]
	        },
	        events: {
	          change: onDayChange
	        },
	        children: days
	      }
	    },
	
	    M: {
	      tag: 'li',
	      key: 'M',
	      children: {
	        tag: 'select',
	        attrs: {
	          disabled: locals.disabled,
	          className: {
	            'form-control': true
	          },
	          value: value[1]
	        },
	        events: {
	          change: onMonthChange
	        },
	        children: months
	      }
	    },
	
	    YY: {
	      tag: 'li',
	      key: 'YY',
	      children: {
	        tag: 'input',
	        attrs: {
	          disabled: locals.disabled,
	          type: 'text',
	          size: 5,
	          className: {
	            'form-control': true
	          },
	          value: value[0]
	        },
	        events: {
	          change: onYearChange
	        }
	      }
	    }
	
	  };
	
	  var control = {
	    tag: 'ul',
	    attrs: {
	      className: {
	        'nav nav-pills': true
	      }
	    },
	    children: locals.order.map(function (id) {
	      return parts[id];
	    })
	  };
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [label, control, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [control, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function struct(locals) {
	
	  var config = new StructConfig(locals.config || noobj);
	  var children = [];
	
	  if (locals.help) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      children: locals.help
	    }));
	  }
	
	  if (locals.error && locals.hasError) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      type: 'danger',
	      children: locals.error
	    }));
	  }
	
	  children = children.concat(locals.order.map(function (name) {
	    return locals.inputs[name];
	  }));
	
	  var className = {};
	  if (locals.className) {
	    className[locals.className] = true;
	  }
	
	  return _uvdomBootstrap2['default'].getFieldset({
	    className: className,
	    disabled: locals.disabled,
	    legend: locals.label,
	    children: children
	  });
	}
	
	function list(locals) {
	
	  var config = new ListConfig(locals.config || noobj);
	  var children = [];
	
	  if (locals.help) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      children: locals.help
	    }));
	  }
	
	  if (locals.error && locals.hasError) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      type: 'danger',
	      children: locals.error
	    }));
	  }
	
	  children = children.concat(locals.items.map(function (item) {
	    if (item.buttons.length === 0) {
	      return _uvdomBootstrap2['default'].getRow({
	        key: item.key,
	        children: [_uvdomBootstrap2['default'].getCol({
	          breakpoints: { xs: 12 },
	          children: item.input
	        })]
	      });
	    }
	    return _uvdomBootstrap2['default'].getRow({
	      key: item.key,
	      children: [_uvdomBootstrap2['default'].getCol({
	        breakpoints: { sm: 8, xs: 6 },
	        children: item.input
	      }), _uvdomBootstrap2['default'].getCol({
	        breakpoints: { sm: 4, xs: 6 },
	        children: _uvdomBootstrap2['default'].getButtonGroup(item.buttons.map(function (button, i) {
	          return _uvdomBootstrap2['default'].getButton({
	            click: button.click,
	            key: i,
	            label: button.label
	          });
	        }))
	      })]
	    });
	  }));
	
	  if (locals.add) {
	    children.push({
	      tag: 'div',
	      attrs: { className: 'row' },
	      children: {
	        tag: 'div',
	        attrs: { className: 'col-lg-12' },
	        children: {
	          tag: 'div',
	          attrs: { style: { marginBottom: '15px' } },
	          children: _uvdomBootstrap2['default'].getButton(locals.add)
	        }
	      }
	    });
	  }
	
	  var className = {};
	  if (locals.className) {
	    className[locals.className] = true;
	  }
	
	  return _uvdomBootstrap2['default'].getFieldset({
	    className: className,
	    disabled: locals.disabled,
	    legend: locals.label,
	    children: children
	  });
	}

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  getAddon: __webpack_require__(129),
	  getAlert: __webpack_require__(130),
	  getBreakpoints: __webpack_require__(131),
	  getButton: __webpack_require__(132),
	  getButtonGroup: __webpack_require__(133),
	  getCheckbox: __webpack_require__(134),
	  getCol: __webpack_require__(135),
	  getErrorBlock: __webpack_require__(136),
	  getFieldset: __webpack_require__(137),
	  getFormGroup: __webpack_require__(138),
	  getHelpBlock: __webpack_require__(139),
	  getInputGroup: __webpack_require__(140),
	  getLabel: __webpack_require__(141),
	  getOffsets: __webpack_require__(143),
	  getOptGroup: __webpack_require__(144),
	  getOption: __webpack_require__(145),
	  getRadio: __webpack_require__(146),
	  getRow: __webpack_require__(147),
	  getStatic: __webpack_require__(148)
	};

/***/ },
/* 129 */
/***/ function(module, exports) {

	'use strict';
	
	function getAddon(addon) {
	  return {
	    tag: 'span',
	    attrs: {
	      className: {
	        'input-group-addon': true
	      }
	    },
	    children: addon
	  };
	}
	
	module.exports = getAddon;

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	function getAlert(opts) {
	
	  var type = opts.type || 'info';
	  var className = {
	    'alert': true
	  };
	  className['alert-' + type] = true;
	
	  return {
	    tag: 'div',
	    attrs: {
	      className: className
	    },
	    children: opts.children
	  };
	}
	
	module.exports = getAlert;

/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	function getBreakpoints(breakpoints) {
	  var className = {};
	  for (var size in breakpoints) {
	    if (breakpoints.hasOwnProperty(size)) {
	      className['col-' + size + '-' + breakpoints[size]] = true;
	    }
	  }
	  return className;
	}
	
	module.exports = getBreakpoints;

/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	
	  Example:
	
	  {
	    type: 'primary',
	    block: true,
	    active: true,
	    size: 'lg',
	    disabled: true,
	    autoFocus: true,
	    events: {
	      ...
	    }
	  }
	
	*/
	
	function getButton(opts) {
	
	  var type = opts.type || 'default';
	
	  var className = {
	    'btn': true,
	    'btn-block': opts.block,
	    'active': opts.active
	  };
	  className['btn-' + type] = true;
	  if (opts.size) {
	    className['btn-' + opts.size] = true;
	  }
	
	  var events = opts.events || {
	    click: opts.click
	  };
	
	  return {
	    tag: 'button',
	    attrs: {
	      type: 'button',
	      disabled: opts.disabled,
	      className: className,
	      autoFocus: opts.autoFocus
	    },
	    events: events,
	    children: opts.label,
	    key: opts.key
	  }
	}
	
	module.exports = getButton;


/***/ },
/* 133 */
/***/ function(module, exports) {

	'use strict';
	
	function getButtonGroup(buttons) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'btn-group': true
	      }
	    },
	    children: buttons
	  };
	};
	
	module.exports = getButtonGroup;
	


/***/ },
/* 134 */
/***/ function(module, exports) {

	'use strict';
	
	function getCheckbox(attrs, label) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'checkbox': true,
	        'disabled': attrs.disabled
	      }
	    },
	    children: {
	      tag: 'label',
	      attrs: {
	        htmlFor: attrs.id
	      },
	      children: [
	        {
	          tag: 'input',
	          attrs: attrs
	        },
	        ' ',
	        label
	      ]
	    }
	  };
	}
	
	module.exports = getCheckbox;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getBreakpoints = __webpack_require__(131);
	
	function getCol(opts) {
	
	  var className = opts.breakpoints ? getBreakpoints(opts.breakpoints) : null;
	
	  return {
	    tag: 'div',
	    attrs: {
	      className: className
	    },
	    children: opts.children
	  };
	}
	
	module.exports = getCol;

/***/ },
/* 136 */
/***/ function(module, exports) {

	'use strict';
	
	function getErrorBlock(opts) {
	  return {
	    tag: 'span',
	    attrs: {
	      className: {
	        'help-block': true,
	        'error-block': opts.hasError
	      }
	    },
	    children: opts.error
	  };
	}
	
	module.exports = getErrorBlock;
	


/***/ },
/* 137 */
/***/ function(module, exports) {

	'use strict';
	
	function getFieldset(opts) {
	
	  var children = opts.children.slice();
	
	  if (opts.legend) {
	    children.unshift({
	      tag: 'legend',
	      children: opts.legend
	    });
	  }
	
	  return {
	    tag: 'fieldset',
	    attrs: {
	      className: opts.className,
	      disabled: opts.disabled
	    },
	    children: children
	  };
	};
	
	module.exports = getFieldset;
	


/***/ },
/* 138 */
/***/ function(module, exports) {

	'use strict';
	
	function getFormGroup(opts) {
	
	  var className = {
	    'form-group': true,
	    'has-error': opts.hasError
	  };
	  if (opts.className) {
	    className[opts.className] = true;
	  }
	
	  return {
	    tag: 'div',
	    attrs: {
	      className: className
	    },
	    children: opts.children
	  };
	}
	
	module.exports = getFormGroup;

/***/ },
/* 139 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	
	  Example:
	
	  {
	    help: 'my help',
	    hasError: true,
	    id: 'password-tip'
	  }
	
	*/
	
	function getHelpBlock(opts) {
	  return {
	    tag: 'span',
	    attrs: {
	      className: {
	        'help-block': true,
	        'error-block': opts.hasError
	      },
	      // aria support
	      id: opts.id,
	      role: 'tooltip'
	    },
	    children: opts.help
	  };
	}
	
	module.exports = getHelpBlock;
	


/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	function getInputGroup(children) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'input-group': true
	      }
	    },
	    children: children
	  };
	}
	
	module.exports = getInputGroup;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var mixin = __webpack_require__(142);
	
	/*
	
	  Example:
	
	  {
	    label: 'my label',
	    htmlFor: 'inputId',
	    id: 'myid',
	    align: 'right',
	    className: {}
	  }
	
	*/
	
	function getLabel(opts) {
	
	  var className = mixin({
	    'control-label': true
	  }, opts.className);
	
	  if (opts.align) {
	    className['text-' + opts.align] = true;
	  }
	
	  return {
	    tag: 'label',
	    attrs: {
	      htmlFor: opts.htmlFor,
	      id: opts.id,
	      className: className
	    },
	    children: opts.label
	  };
	}
	
	module.exports = getLabel;
	


/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	function mixin(a, b) {
	  if (!b) { return a; }
	  for (var k in b) {
	    if (b.hasOwnProperty(k)) {
	      a[k] = b[k];
	    }
	  }
	  return a;
	}
	
	module.exports = mixin;

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	function getOffsets(breakpoints) {
	  var className = {};
	  for (var size in breakpoints) {
	    if (breakpoints.hasOwnProperty(size)) {
	      className['col-' + size + '-offset-' + (12 - breakpoints[size])] = true;
	    }
	  }
	  return className;
	}
	
	module.exports = getOffsets;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getOption = __webpack_require__(145);
	
	/*
	
	  Example:
	
	  {
	    label: 'group1',
	    options: [
	      {value: 'value1', text: 'description1'},
	      {value: 'value3', text: 'description3'}
	    ]
	  }
	
	*/
	
	function getOptGroup(opts) {
	  return {
	    tag: 'optgroup',
	    attrs: {
	      disabled: opts.disabled,
	      label: opts.label
	    },
	    children: opts.options.map(getOption),
	    key: opts.label
	  };
	}
	
	module.exports = getOptGroup;
	


/***/ },
/* 145 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	
	  Example:
	
	  {
	    value: '1',
	    text: 'option 1'
	  }
	
	*/
	
	function getOption(opts) {
	  return {
	    tag: 'option',
	    attrs: {
	      disabled: opts.disabled,
	      value: opts.value
	    },
	    children: opts.text,
	    key: opts.value
	  };
	}
	
	module.exports = getOption;
	


/***/ },
/* 146 */
/***/ function(module, exports) {

	'use strict';
	
	function getRadio(attrs, text, key) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'radio': true,
	        'disabled': attrs.disabled
	      }
	    },
	    children: {
	      tag: 'label',
	      attrs: {
	        htmlFor: attrs.id,
	      },
	      children: [
	        {
	          tag: 'input',
	          attrs: attrs
	        },
	        ' ',
	        text
	      ]
	    },
	    key: key
	  };
	}
	
	module.exports = getRadio;

/***/ },
/* 147 */
/***/ function(module, exports) {

	'use strict';
	
	function getRow(opts) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'row': true
	      }
	    },
	    children: opts.children,
	    key: opts.key
	  };
	}
	
	module.exports = getRow;

/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	function getStatic(value) {
	  return {
	    tag: 'p',
	    attrs: {
	      className: {
	        'form-control-static': true
	      }
	    },
	    children: value
	  };
	}
	
	module.exports = getStatic;

/***/ },
/* 149 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  optional: ' (optional)',
	  required: '',
	  add: 'Add',
	  remove: 'Remove',
	  up: 'Up',
	  down: 'Down'
	};
	module.exports = exports['default'];

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Locale = __webpack_require__(17);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Mobile = __webpack_require__(151);
	
	var _Mobile2 = _interopRequireDefault(_Mobile);
	
	var _Gender = __webpack_require__(152);
	
	var _Gender2 = _interopRequireDefault(_Gender);
	
	var _Email = __webpack_require__(120);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _Datetime = __webpack_require__(23);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _Register_Country = __webpack_require__(63);
	
	var _Register_Country2 = _interopRequireDefault(_Register_Country);
	
	var Verified = _tcomb2['default'].struct({
	  email: _Email2['default'],
	  mobile: _Mobile2['default'],
	  mobile_country: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  name: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  surname: _tcomb2['default'].maybe(_tcomb2['default'].Str),
	  birth_date: _Datetime2['default'],
	  gender: _Gender2['default'],
	  country: _Register_Country2['default'],
	  district: _tcomb2['default'].Str,
	  zip: _tcomb2['default'].Str,
	  com_locale: _Locale2['default'],
	  rcs_privacy_needed: _tcomb2['default'].Bool
	}, 'Verified');
	
	module.exports = Verified;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	//const digitsRegExp = /^\d*$/;
	
	var Mobile = _tcomb2['default'].String; // t.refinement(t.String, (s) => digitsRegExp.test(s), 'Mobile');
	
	exports['default'] = Mobile;
	module.exports = exports['default'];

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Gender = _tcomb2['default'].enums.of(['M', 'F']);
	
	module.exports = Gender;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Field = _tcomb2['default'].enums.of('email birth_date zip district mobile gender country', 'Field');
	
	module.exports = Field;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(101),
	    createFind = __webpack_require__(155);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias detect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.result(_.find(users, function(chr) {
	 *   return chr.age < 40;
	 * }), 'user');
	 * // => 'barney'
	 *
	 * // using the `_.matches` callback shorthand
	 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.result(_.find(users, 'active', false), 'user');
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.result(_.find(users, 'active'), 'user');
	 * // => 'barney'
	 */
	var find = createFind(baseEach);
	
	module.exports = find;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(76),
	    baseFind = __webpack_require__(156),
	    baseFindIndex = __webpack_require__(157),
	    isArray = __webpack_require__(40);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(eachFunc, fromRight) {
	  return function(collection, predicate, thisArg) {
	    predicate = baseCallback(predicate, thisArg, 3);
	    if (isArray(collection)) {
	      var index = baseFindIndex(collection, predicate, fromRight);
	      return index > -1 ? collection[index] : undefined;
	    }
	    return baseFind(collection, predicate, eachFunc);
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 156 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ },
/* 157 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(125);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tcombReact = __webpack_require__(113);
	
	var Alert = (function (_React$Component) {
	  _inherits(Alert, _React$Component);
	
	  function Alert() {
	    _classCallCheck(this, _Alert);
	
	    _get(Object.getPrototypeOf(_Alert.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Alert, [{
	    key: 'getContainerClasses',
	    value: function getContainerClasses() {
	      var type = this.props.type;
	      return (0, _classnames2['default'])({
	        'alert': true,
	        'success': type === 'success',
	        'error': type === 'error',
	        'warning': type === 'warning',
	        'danger': type === 'danger',
	        'info': type === 'info'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: this.getContainerClasses() },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Alert = Alert;
	  Alert = (0, _tcombReact.props)({
	    children: _tcombReact.t.Any,
	    type: _tcombReact.t.maybe(_tcombReact.t.Str)
	  })(Alert) || Alert;
	  return Alert;
	})(_react2['default'].Component);
	
	exports['default'] = Alert;
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _tcombReact = __webpack_require__(113);
	
	var Confirm = (function (_React$Component) {
	  _inherits(Confirm, _React$Component);
	
	  function Confirm() {
	    var _this = this;
	
	    _classCallCheck(this, _Confirm);
	
	    _get(Object.getPrototypeOf(_Confirm.prototype), 'constructor', this).apply(this, arguments);
	
	    this.doYes = function (evt) {
	      evt.preventDefault();
	      _this.props.callback(true);
	    };
	
	    this.doNo = function (evt) {
	      evt.preventDefault();
	      _this.props.callback(false);
	    };
	  }
	
	  _createClass(Confirm, [{
	    key: 'scrollTop',
	    value: function scrollTop() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollTop();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var style = {
	        maxWidth: this.props.width
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement('div', { className: 'overlay' }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'web-modal' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-body', style: style },
	            _react2['default'].createElement(
	              'div',
	              { className: 'modal-header' },
	              _react2['default'].createElement(
	                'h1',
	                null,
	                this.props.title
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'modal-section' },
	              this.props.children
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'modal-footer' },
	              _react2['default'].createElement(
	                'button',
	                { onClick: this.doYes },
	                this.props.locale.language_bundle().bool.TRUE
	              ),
	              _react2['default'].createElement(
	                'button',
	                { className: 'primary', onClick: this.doNo },
	                this.props.locale.language_bundle().bool.FALSE
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Confirm = Confirm;
	  Confirm = (0, _tcombReact.props)({
	    title: _tcombReact.t.Str,
	    locale: _domainLocale2['default'],
	    callback: _tcombReact.t.Func,
	    width: _tcombReact.t.Str,
	    children: _tcombReact.t.ReactElement
	  })(Confirm) || Confirm;
	  return Confirm;
	})(_react2['default'].Component);
	
	exports['default'] = Confirm;
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HTMLComponent = __webpack_require__(161);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _tcombReact = __webpack_require__(113);
	
	var _micromd = __webpack_require__(162);
	
	var _micromd2 = _interopRequireDefault(_micromd);
	
	var MarkdownComponent = (function (_React$Component) {
	  _inherits(MarkdownComponent, _React$Component);
	
	  function MarkdownComponent() {
	    _classCallCheck(this, _MarkdownComponent);
	
	    _get(Object.getPrototypeOf(_MarkdownComponent.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(MarkdownComponent, [{
	    key: 'render',
	    value: function render() {
	      if (!this.props.children) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        _HTMLComponent2['default'],
	        null,
	        (0, _micromd2['default'])(this.props.children)
	      );
	    }
	  }]);
	
	  var _MarkdownComponent = MarkdownComponent;
	  MarkdownComponent = (0, _tcombReact.props)({
	    children: _tcombReact.t.Str
	  })(MarkdownComponent) || MarkdownComponent;
	  return MarkdownComponent;
	})(_react2['default'].Component);
	
	exports['default'] = MarkdownComponent;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(113);
	
	var HTMLComponent = (function (_React$Component) {
	  _inherits(HTMLComponent, _React$Component);
	
	  function HTMLComponent() {
	    _classCallCheck(this, _HTMLComponent);
	
	    _get(Object.getPrototypeOf(_HTMLComponent.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(HTMLComponent, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2['default'].createElement('span', { dangerouslySetInnerHTML: { __html: this.props.children } });
	    }
	  }]);
	
	  var _HTMLComponent = HTMLComponent;
	  HTMLComponent = (0, _tcombReact.props)({
	    children: _tcombReact.t.Str
	  })(HTMLComponent) || HTMLComponent;
	  return HTMLComponent;
	})(_react2['default'].Component);
	
	exports['default'] = HTMLComponent;
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _lodashStringEscape = __webpack_require__(54);
	
	var _lodashStringEscape2 = _interopRequireDefault(_lodashStringEscape);
	
	// converte un tag in html
	// - i p sono convertiti semplicemente in testo con gli a capo
	// sostituiti da <br/>
	// - le liste con le liste corrispondenti ol, ul a seconda che
	// siano ordinate o no
	
	function renderTag(tag) {
	  var name = tag.name;
	  var args = tag.args;
	
	  if (name === 'p') {
	    return args.join('<br/>');
	  }
	  var lis = args.map(function (x) {
	    return '<li>' + x.replace(lists[name], '') + '</li>'; // toglie "- " o "+ "
	  }).join('');
	  return '<' + name + '>' + lis + '</' + name + '>';
	}
	
	// elenco trasformazioni inline
	var inline = {
	  strong: function strong(src) {
	    return src.replace(/(\*\*)(?=\S)([^\r]*?\S[*]*)\1/g, "<strong>$2</strong>");
	  },
	  em: function em(src) {
	    return src.replace(/(\*)(?=\S)([^\r]*?\S)\1/g, "<em>$2</em>");
	  },
	  link: function link(src) {
	    return src.replace(/(\[((?:\[[^\]]*\]|[^\[\]])*)\]\([ \t]*()<?(.*?)>?[ \t]*((['"])(.*?)\6[ \t]*)?\))/g, function (wholeMatch, m1, text, m3, url) {
	      var isMailto = url.indexOf('mailto:') === 0;
	      var self = url.indexOf('self:') === 0;
	      var isJS = url.indexOf('javascript:') === 0; // eslint-disable-line no-script-url
	      var target = undefined;
	      if (self) {
	        target = '_self';
	        url = url.substring(5, url.length);
	      } else if (isJS) {
	        target = '#';
	      } else if (!isMailto) {
	        target = '_blank';
	      }
	      var targetAttr = '';
	      if (!_tcomb2['default'].Nil.is(target)) {
	        targetAttr = ' target="' + target + '"';
	      }
	      // non uso attr() altrimenti farei due volte l'escape_html()
	      return '<a href="' + url + '"' + targetAttr + '>' + text + '</a>';
	    });
	  }
	};
	
	var lists = {
	  ul: /^- /,
	  ol: /^\+ /
	};
	
	// data una linea quel'è il tag più appropriato per
	// farne il rendering
	
	function detectTag(line) {
	  return lists.ul.exec(line) ? 'ul' : lists.ol.exec(line) ? 'ol' : 'p';
	}
	
	var transformations = ['link', 'strong', 'em'];
	
	exports['default'] = function (md) {
	  md = _tcomb2['default'].String(md);
	
	  var ret = function (md) {
	
	    // uniformo gli a capo a \n
	    var uniformed = md.replace(/\r\n|\r/g, '\n');
	
	    // elimino tag molesti
	    var escaped = (0, _lodashStringEscape2['default'])(uniformed);
	
	    // applico le trasformazioni inline
	    var inlined = transformations.reduce(function (ret, x) {
	      return inline[x](ret);
	    }, escaped);
	
	    // divido il sorgente ottenuto in blocchi divisi dagli a capo
	    // e faccio un trim delle righe
	    var lines = inlined.split('\n').map(function (s) {
	      return s.trim();
	    });
	
	    // analizzo i blocchi per determinare i tag
	    var tags = [];
	    var oldTag = undefined;
	    lines.forEach(function (line) {
	      var newTag = detectTag(line);
	      if (newTag !== oldTag) {
	        tags.push({
	          name: newTag,
	          args: []
	        });
	      }
	      tags[tags.length - 1].args.push(line);
	      oldTag = newTag;
	    });
	
	    // render dei tag trovati
	    return tags.map(renderTag).join('');
	  }.call(this, md);
	
	  return _tcomb2['default'].String(ret);
	};

	module.exports = exports['default'];

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = createCallback;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	// given the successHandler and the errorHandler returns a node like callback:
	// `err` as first argument, `result` as second argument
	
	function createCallback(successHandler, errorHandler) {
	  successHandler = _tcomb2['default'].Function(successHandler);
	  errorHandler = _tcomb2['default'].Function(errorHandler);
	
	  var ret = function (successHandler, errorHandler) {
	    return function (err, result) {
	      if (err) {
	        errorHandler(err);
	      } else {
	        successHandler(result);
	      }
	    };
	  }.call(this, successHandler, errorHandler);
	
	  return _tcomb2['default'].Function(ret);
	}

	module.exports = exports['default'];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsLayout = __webpack_require__(165);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _domainUser = __webpack_require__(117);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _componentsHeaderUser = __webpack_require__(175);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsContentPurchase = __webpack_require__(176);
	
	var _componentsContentPurchase2 = _interopRequireDefault(_componentsContentPurchase);
	
	var _componentsSponsor = __webpack_require__(188);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(113);
	
	var Purchase = (function (_React$Component) {
	  _inherits(Purchase, _React$Component);
	
	  function Purchase() {
	    _classCallCheck(this, _Purchase);
	
	    _get(Object.getPrototypeOf(_Purchase.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Purchase, [{
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], { user: this.props.user,
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goChangePassword: this.props.goChangePassword,
	        goPurchases: this.props.goPurchases,
	        doLogout: this.props.doLogout });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), sponsor: this.getSponsor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentPurchase2['default'], {
	          locale: locale,
	          purchase: this.props.purchase,
	          pending_purchase_message: this.props.pending_purchase_message,
	          user: this.props.user,
	          goAccount: this.props.goAccount,
	          goChangePassword: this.props.goChangePassword,
	          goPurchases: this.props.goPurchases,
	          doLogout: this.props.doLogout,
	          doAcceptCookies: this.props.doAcceptCookies,
	          message: this.props.message,
	          share_purchase: this.props.share_purchase,
	          custom_payments: this.props.custom_payments,
	          themeBgColor: this.props.themeBgColor,
	          themeBtnColor: this.props.themeBgColor,
	          doSendGiftCardCode: this.props.doSendGiftCardCode })
	      );
	    }
	  }]);
	
	  var _Purchase = Purchase;
	  Purchase = (0, _tcombReact.props)({
	    locale: _tcombForm2['default'].Obj,
	    purchase: _tcombForm2['default'].Obj,
	    pending_purchase_message: _tcombForm2['default'].Str,
	    user: _domainUser2['default'],
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    share_purchase: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    custom_payments: _tcombForm2['default'].maybe(_tcombForm2['default'].list(_tcombForm2['default'].Obj)),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    doSendGiftCardCode: _tcombForm2['default'].Func
	  })(Purchase) || Purchase;
	  return Purchase;
	})(_react2['default'].Component);
	
	exports['default'] = Purchase;
	module.exports = exports['default'];

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsFooter = __webpack_require__(166);
	
	var _componentsFooter2 = _interopRequireDefault(_componentsFooter);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(113);
	
	var Layout = (function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, _Layout);
	
	    _get(Object.getPrototypeOf(_Layout.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Layout, [{
	    key: 'getPartners',
	    value: function getPartners() {
	      if (_tcombReact.t.Nil.is(this.props.partners)) {
	        return null;
	      }
	
	      var partnersStyle = {
	        textAlign: this.props.partners.align
	      };
	      var logos = this.props.partners.logos.map(function (logo, index) {
	        return _react2['default'].createElement(
	          'a',
	          { key: index, href: logo.link, target: '_blank' },
	          _react2['default'].createElement('img', { src: logo.image })
	        );
	      });
	      return _react2['default'].createElement(
	        'div',
	        { id: 'partners', style: partnersStyle },
	        logos
	      );
	    }
	  }, {
	    key: 'getFooter',
	    value: function getFooter() {
	      return _react2['default'].createElement(_componentsFooter2['default'], { locale: this.props.locale, doAcceptCookies: this.props.doAcceptCookies });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var containerHeader1172Style = {
	        backgroundColor: this.props.bgColor,
	        color: this.props.color
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement('div', { id: 'modal-container' }),
	        _react2['default'].createElement(
	          'div',
	          { id: 'view' },
	          this.getPartners(),
	          _react2['default'].createElement(
	            'div',
	            { id: 'containerHeader1172', style: containerHeader1172Style },
	            _react2['default'].createElement(
	              'div',
	              { id: 'containerHeader960' },
	              this.props.header,
	              this.props.sponsor
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { id: 'containerBody' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'container' },
	              this.props.children
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { id: 'containerFooter' },
	            this.getFooter()
	          ),
	          _react2['default'].createElement('div', { id: 'shield' }),
	          _react2['default'].createElement(
	            'div',
	            { id: 'ajax' },
	            _react2['default'].createElement('div', null)
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Layout = Layout;
	  Layout = (0, _tcombReact.props)({
	    header: _tcombReact.t.maybe(_tcombReact.t.ReactElement),
	    sponsor: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    children: _tcombReact.t.Any,
	    locale: _domainLocale2['default'],
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func),
	    bgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    color: _tcombReact.t.maybe(_domainColor2['default']),
	    partners: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(Layout) || Layout;
	  return Layout;
	})(_react2['default'].Component);
	
	exports['default'] = Layout;
	module.exports = exports['default'];

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGetCopyright = __webpack_require__(167);
	
	var _domainGetCopyright2 = _interopRequireDefault(_domainGetCopyright);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _Conditions = __webpack_require__(168);
	
	var _Conditions2 = _interopRequireDefault(_Conditions);
	
	var _PolicyCookies = __webpack_require__(170);
	
	var _PolicyCookies2 = _interopRequireDefault(_PolicyCookies);
	
	var _HowItWorks = __webpack_require__(171);
	
	var _HowItWorks2 = _interopRequireDefault(_HowItWorks);
	
	var _CookiesDisclaimer = __webpack_require__(172);
	
	var _CookiesDisclaimer2 = _interopRequireDefault(_CookiesDisclaimer);
	
	var _tcombReact = __webpack_require__(113);
	
	var Footer = (function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, _Footer);
	
	    _get(Object.getPrototypeOf(_Footer.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'footer' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-25 medium-50 small-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              (0, _domainGetCopyright2['default'])()
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-25 medium-50 small-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              _react2['default'].createElement(_Conditions2['default'], { locale: locale })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-25 medium-50 small-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              _react2['default'].createElement(_PolicyCookies2['default'], { locale: locale })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-25 medium-50 small-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              _react2['default'].createElement(_HowItWorks2['default'], { locale: locale })
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(_CookiesDisclaimer2['default'], { locale: locale, doAcceptCookies: this.props.doAcceptCookies })
	        )
	      );
	    }
	  }]);
	
	  var _Footer = Footer;
	  Footer = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func)
	  })(Footer) || Footer;
	  return Footer;
	})(_react2['default'].Component);
	
	exports['default'] = Footer;
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getCopyright;
	
	function getCopyright() {
	  //return 'Copyright &copy; 2010-2015 madai';
	  return 'Copyright © 2010-2020 madai';
	}

	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainGetMadaiURL = __webpack_require__(169);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _tcombReact = __webpack_require__(113);
	
	var Conditions = (function (_React$Component) {
	  _inherits(Conditions, _React$Component);
	
	  function Conditions() {
	    _classCallCheck(this, _Conditions);
	
	    _get(Object.getPrototypeOf(_Conditions.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Conditions, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      function getHref() {
	        if (locale.toJSON() === 'it_IT') {
	          return 'https://it.madai.com/terms.html';
	        } else {
	          return "https://madai.com/terms.html";
	        }
	        /*
	        const _locale = locale.toString();
	        const country = locale.country.toLowerCase();
	        if (_locale === 'en_ZA') {
	          return 'http://za.shop.madai.com/FAQ_en.html';
	        } else if (_locale === 'en_US') {
	          return 'http://us.shop.madai.com/FAQ_en.html';
	        } else if (_locale === 'it_IT') {
	          return 'http://it.madai.com/FAQ_it.html';
	        }
	        else {
	          return getMadaiURL() + country + '/terms-of-use.html';
	        }*/
	      }
	
	      return _react2['default'].createElement(
	        'a',
	        { target: '_blank', href: getHref() },
	        (0, _domainGet_bundle2['default'])(this.props.locale).footer.conditions
	      );
	    }
	  }]);
	
	  var _Conditions = Conditions;
	  Conditions = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(Conditions) || Conditions;
	  return Conditions;
	})(_react2['default'].Component);
	
	exports['default'] = Conditions;
	module.exports = exports['default'];

/***/ },
/* 169 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getMadaiURL;
	
	function getMadaiURL() {
	  return 'https://madai.com';
	  //return 'http://shop.madai.com/consumer/';
	}

	module.exports = exports['default'];

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainGetMadaiURL = __webpack_require__(169);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _tcombReact = __webpack_require__(113);
	
	var PolicyCookies = (function (_React$Component) {
	  _inherits(PolicyCookies, _React$Component);
	
	  function PolicyCookies() {
	    _classCallCheck(this, _PolicyCookies);
	
	    _get(Object.getPrototypeOf(_PolicyCookies.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PolicyCookies, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      function getHref() {
	        if (locale.toJSON() === 'it_IT') {
	          return 'https://it.madai.com/privacy.html';
	        } else {
	          return "https://madai.com/privacy.html";
	        }
	
	        /*const _locale = locale.toString();
	        const country = locale.country.toLowerCase();
	        if (_locale === 'en_ZA') {
	          return 'http://za.shop.madai.com/privacy-policy_en.html';
	        } else if (_locale === 'en_US') {
	          return 'http://us.shop.madai.com/privacy-policy_en.html';
	        } else if (_locale === 'it_IT') {
	          return 'http://it.madai.com/privacy-policy_it.html';
	        }
	        else {
	          return getMadaiURL() + country + '/privacy.html';
	        }*/
	      }
	
	      return _react2['default'].createElement(
	        'a',
	        { target: '_blank', href: getHref() },
	        (0, _domainGet_bundle2['default'])(this.props.locale).footer.policy_cookies
	      );
	    }
	  }]);
	
	  var _PolicyCookies = PolicyCookies;
	  PolicyCookies = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(PolicyCookies) || PolicyCookies;
	  return PolicyCookies;
	})(_react2['default'].Component);
	
	exports['default'] = PolicyCookies;
	module.exports = exports['default'];

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainGetMadaiURL = __webpack_require__(169);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _tcombReact = __webpack_require__(113);
	
	var HowItWorks = (function (_React$Component) {
	  _inherits(HowItWorks, _React$Component);
	
	  function HowItWorks() {
	    _classCallCheck(this, _HowItWorks);
	
	    _get(Object.getPrototypeOf(_HowItWorks.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(HowItWorks, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      function getHref() {
	        if (locale.toJSON() === 'it_IT') {
	          return 'https://it.madai.com/faqs.html';
	        } else {
	          return "https://madai.com/faqs.html";
	        }
	        /*const _locale = locale.toString();
	        const country = locale.country.toLowerCase();
	        if (_locale === 'en_ZA') {
	          return 'http://za.shop.madai.com/FAQ_en.html';
	        } else if (_locale === 'en_US') {
	          return 'http://us.shop.madai.com/FAQ_en.html';
	        } else if (_locale === 'it_IT') {
	          return 'http://it.madai.com/FAQ_it.html';
	        }
	        else {
	          return getMadaiURL() + country + '/how-it-works.html';
	        }*/
	      }
	
	      return _react2['default'].createElement(
	        'a',
	        { target: '_blank', href: getHref() },
	        (0, _domainGet_bundle2['default'])(this.props.locale).footer.how_it_works
	      );
	    }
	  }]);
	
	  var _HowItWorks = HowItWorks;
	  HowItWorks = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(HowItWorks) || HowItWorks;
	  return HowItWorks;
	})(_react2['default'].Component);
	
	exports['default'] = HowItWorks;
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainGetPrivacyURL = __webpack_require__(173);
	
	var _domainGetPrivacyURL2 = _interopRequireDefault(_domainGetPrivacyURL);
	
	var _HTMLComponent = __webpack_require__(161);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _lodashStringTemplate = __webpack_require__(25);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var _tcombReact = __webpack_require__(113);
	
	var _cookiesJs = __webpack_require__(67);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	var CookiesDisclaimer = (function (_React$Component) {
	  _inherits(CookiesDisclaimer, _React$Component);
	
	  function CookiesDisclaimer() {
	    var _this = this;
	
	    _classCallCheck(this, _CookiesDisclaimer);
	
	    _get(Object.getPrototypeOf(_CookiesDisclaimer.prototype), 'constructor', this).apply(this, arguments);
	
	    this.doAcceptCookies = function (evt) {
	      evt.preventDefault();
	
	      if (_this.props.doAcceptCookies && !_this.areCookiesAccepted()) {
	        _this.props.doAcceptCookies();
	      }
	    };
	  }
	
	  _createClass(CookiesDisclaimer, [{
	    key: 'areCookiesAccepted',
	    value: function areCookiesAccepted() {
	      return _cookiesJs2['default'].get('accept_cookies');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.doAcceptCookies) {
	        return null;
	      }
	
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).footer.cookies_disclaimer;
	      var description = (0, _lodashStringTemplate2['default'])(bundle.description)({
	        privacy_url: (0, _domainGetPrivacyURL2['default'])()
	      });
	
	      if (this.areCookiesAccepted()) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'cookies_disclaimer' },
	        _react2['default'].createElement(
	          'p',
	          null,
	          _react2['default'].createElement(
	            _HTMLComponent2['default'],
	            null,
	            description
	          )
	        ),
	        _react2['default'].createElement(
	          'button',
	          { id: 'do_accept_cookies', onClick: this.doAcceptCookies, className: 'small' },
	          bundle.do_accept_cookies
	        )
	      );
	    }
	  }]);
	
	  var _CookiesDisclaimer = CookiesDisclaimer;
	  CookiesDisclaimer = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func)
	  })(CookiesDisclaimer) || CookiesDisclaimer;
	  return CookiesDisclaimer;
	})(_react2['default'].Component);
	
	exports['default'] = CookiesDisclaimer;
	module.exports = exports['default'];

/***/ },
/* 173 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getPrivacyURL;
	
	function getPrivacyURL() {
	  return 'http://it.madai.com/index.php/norme-sulla-privacy';
	}

	module.exports = exports['default'];

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var is_color_regexp = /^#([a-f0-9]{6}|[a-f0-9]{3})$/i;
	
	var is_color = function is_color(s) {
	  return is_color_regexp.test(s);
	};
	
	var Color = _tcomb2['default'].subtype(_tcomb2['default'].Str, is_color);
	
	module.exports = Color;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainUser = __webpack_require__(117);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainVerified = __webpack_require__(150);
	
	var _domainVerified2 = _interopRequireDefault(_domainVerified);
	
	var _domainRegistered = __webpack_require__(119);
	
	var _domainRegistered2 = _interopRequireDefault(_domainRegistered);
	
	var _domainAnonymous = __webpack_require__(118);
	
	var _domainAnonymous2 = _interopRequireDefault(_domainAnonymous);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(113);
	
	var User = (function (_React$Component) {
	  _inherits(User, _React$Component);
	
	  function User() {
	    var _this = this;
	
	    _classCallCheck(this, _User);
	
	    _get(Object.getPrototypeOf(_User.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goAccount = function (evt) {
	      evt.preventDefault();
	      _this.props.goAccount();
	    };
	
	    this.goPurchases = function (evt) {
	      evt.preventDefault();
	      _this.props.goPurchases();
	    };
	
	    this.goChangePassword = function (evt) {
	      evt.preventDefault();
	      _this.props.goChangePassword();
	    };
	
	    this.doLogout = function (evt) {
	      evt.preventDefault();
	      _this.props.doLogout();
	    };
	
	    this.goProduct = function (evt) {
	      evt.preventDefault();
	      _this.props.goProduct();
	    };
	
	    this.goCatalog = function (evt) {
	      evt.preventDefault();
	      _this.props.goCatalog();
	    };
	  }
	
	  _createClass(User, [{
	    key: 'getColorStyle',
	    value: function getColorStyle() {
	      if (!this.props.color) {
	        return null;
	      }
	      return {
	        color: this.props.color
	      };
	    }
	  }, {
	    key: 'styleBtnColor',
	    value: function styleBtnColor() {
	      return {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(evt) {
	      evt.preventDefault();
	      var classes = document.getElementById('actions').className.split(' ');
	      if (classes.indexOf('show') === -1) {
	        document.getElementById('actions').className = 'large-100 show';
	      } else {
	        document.getElementById('actions').className = 'large-100 hide';
	      }
	    }
	  }, {
	    key: 'getEmail',
	    value: function getEmail() {
	      if (_domainAnonymous2['default'].is(this.props.user)) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_actions', style: this.styleBtnColor(), onClick: this.toggle },
	        _react2['default'].createElement(
	          'span',
	          { className: 'container-email' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'email' },
	            this.props.user.email
	          )
	        )
	      )
	
	      //<a href='#' id='go_actions' style={this.getColorStyle()} onClick={this.toggle}><span className="container-email"><span>{this.props.user.email}</span></span></a>
	      ;
	    }
	  }, {
	    key: 'getDxContent',
	    value: function getDxContent() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'actions', className: 'large-100 hide' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cell' },
	          _react2['default'].createElement('div', { className: 'triangle-up' }),
	          this.getActions()
	        )
	      );
	    }
	  }, {
	    key: 'getActionsForVerified',
	    value: function getActionsForVerified() {
	      var navigation_bundle = (0, _domainGet_bundle2['default'])(this.props.locale).navigation;
	      return _react2['default'].createElement(
	        'ul',
	        { className: 'nav' },
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goAccount },
	            navigation_bundle.go_account
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goPurchases },
	            navigation_bundle.go_purchases
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goChangePassword },
	            navigation_bundle.go_change_password
	          )
	        ),
	        _react2['default'].createElement('li', { className: 'divider' }),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.doLogout },
	            navigation_bundle.do_logout
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getActionsForRegistered',
	    value: function getActionsForRegistered() {
	      var navigation_bundle = (0, _domainGet_bundle2['default'])(this.props.locale).navigation;
	      return _react2['default'].createElement(
	        'ul',
	        { className: 'nav' },
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goPurchases },
	            navigation_bundle.go_purchases
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.goChangePassword },
	            navigation_bundle.go_change_password
	          )
	        ),
	        _react2['default'].createElement('li', { className: 'divider' }),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.doLogout },
	            navigation_bundle.do_logout
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getActions',
	    value: function getActions() {
	      if (_domainAnonymous2['default'].is(this.props.user)) {
	        return null;
	      }
	      if (_domainVerified2['default'].is(this.props.user)) {
	        return this.getActionsForVerified();
	      } else if (_domainRegistered2['default'].is(this.props.user)) {
	        return this.getActionsForRegistered();
	      }
	    }
	  }, {
	    key: 'goGoProductLink',
	    value: function goGoProductLink() {
	      if (!this.props.goProduct) {
	        return null;
	      }
	      //return (<a href='#' id='go_product' style={this.getColorStyle()} onClick={this.goProduct}>{get_bundle(this.props.locale).navigation.go_product}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_product', style: this.styleBtnColor(), onClick: this.goProduct },
	        (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_product
	      );
	    }
	  }, {
	    key: 'goGoCatalogLink',
	    value: function goGoCatalogLink() {
	      if (!this.props.goCatalog) {
	        return null;
	      }
	      var style = _extends({}, this.styleBtnColor());
	
	      if (this.props.goProduct) {
	        style.marginLeft = '20px';
	      }
	      //return (<a href='#' id='go_catalog' style={this.getColorStyle()} onClick={this.goCatalog}>{get_bundle(this.props.locale).navigation.go_catalog}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_catalog', style: style, onClick: this.goCatalog },
	        (0, _domainGet_bundle2['default'])(this.props.locale).navigation.go_catalog
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-70' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.goGoProductLink(),
	              this.goGoCatalogLink()
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-30 large-text-right' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.getEmail()
	            )
	          ),
	          this.getDxContent()
	        )
	      );
	    }
	  }]);
	
	  var _User = User;
	  User = (0, _tcombReact.props)({
	    goAccount: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goPurchases: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    goProduct: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goCatalog: _tcombReact.t.maybe(_tcombReact.t.Func),
	    user: _domainUser2['default'],
	    locale: _tcombReact.t.Obj,
	    color: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(User) || User;
	  return User;
	})(_react2['default'].Component);
	
	exports['default'] = User;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainAmount = __webpack_require__(177);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainUser = __webpack_require__(117);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _StdTable = __webpack_require__(179);
	
	var _StdTable2 = _interopRequireDefault(_StdTable);
	
	var _StdCustomPayment = __webpack_require__(180);
	
	var _StdCustomPayment2 = _interopRequireDefault(_StdCustomPayment);
	
	var _DefaultUi = __webpack_require__(182);
	
	var _DefaultUi2 = _interopRequireDefault(_DefaultUi);
	
	var _Alert = __webpack_require__(158);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _HTMLComponent = __webpack_require__(161);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _MarkdownComponent = __webpack_require__(160);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _PurchasePaymentGateway = __webpack_require__(183);
	
	var _PurchasePaymentGateway2 = _interopRequireDefault(_PurchasePaymentGateway);
	
	var _PurchaseStripeGateway = __webpack_require__(184);
	
	var _PurchaseStripeGateway2 = _interopRequireDefault(_PurchaseStripeGateway);
	
	var _PurchaseStripeScaGateway = __webpack_require__(185);
	
	var _PurchaseStripeScaGateway2 = _interopRequireDefault(_PurchaseStripeScaGateway);
	
	var _PurchasePaymentUrl = __webpack_require__(187);
	
	var _PurchasePaymentUrl2 = _interopRequireDefault(_PurchasePaymentUrl);
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(113);
	
	var _lodashStringTemplate = __webpack_require__(25);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var FormType = _tcombForm2['default'].struct({
	  madaiCoupon: _tcombForm2['default'].Str
	}, 'madaiCoupon');
	
	var Purchase = (function (_React$Component) {
	  _inherits(Purchase, _React$Component);
	
	  function Purchase() {
	    var _this = this;
	
	    _classCallCheck(this, _Purchase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_Purchase.prototype), 'constructor', this).apply(this, args);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	      if (value) {
	        _this.props.doSendGiftCardCode(value.madaiCoupon);
	      }
	    };
	
	    this.state = {
	      options: this.getOptions()
	    };
	  }
	
	  _createClass(Purchase, [{
	    key: 'getStatus',
	    value: function getStatus() {
	      return this.props.purchase.status;
	    }
	  }, {
	    key: 'isPending',
	    value: function isPending() {
	      return this.getStatus() === 'PENDING';
	    }
	  }, {
	    key: 'isPaid',
	    value: function isPaid() {
	      return this.getStatus() === 'PAID';
	    }
	  }, {
	    key: 'isShipped',
	    value: function isShipped() {
	      return this.getStatus() === 'SHIPPED';
	    }
	  }, {
	    key: 'isCanceled',
	    value: function isCanceled() {
	      return this.getStatus() === 'SHIPPED';
	    }
	  }, {
	    key: 'hasInvoice',
	    value: function hasInvoice() {
	      return this.props.purchase.invoice;
	    }
	  }, {
	    key: 'hasGiftCardCodeAssigned',
	    value: function hasGiftCardCodeAssigned() {
	      return this.props.purchase.gift_card_code !== null;
	    }
	  }, {
	    key: 'showGiftCardForm',
	    value: function showGiftCardForm() {
	      return !this.props.purchase.gift_card_not_supported && this.isPending() && !this.hasGiftCardCodeAssigned();
	    }
	  }, {
	    key: 'getTotal',
	    value: function getTotal() {
	      return this.props.purchase.amount + (this.props.purchase.domicile ? this.props.purchase.domicile.shipping.cost : 0);
	    }
	  }, {
	    key: 'getTotalLabel',
	    value: function getTotalLabel(bundle) {
	      return _tcombForm2['default'].Num.is(this.props.purchase.payment_amount) ? bundle.summary.total : bundle.summary.payment_total;
	    }
	  }, {
	    key: 'getPaymentMessage',
	    value: function getPaymentMessage() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).template_message;
	      if (this.isPending()) {
	        if (this.props.pending_purchase_message) {
	          return _react2['default'].createElement(
	            _Alert2['default'],
	            { type: 'warning' },
	            _react2['default'].createElement(
	              _MarkdownComponent2['default'],
	              null,
	              this.props.pending_purchase_message
	            )
	          );
	        } else {
	          return _react2['default'].createElement(
	            _Alert2['default'],
	            { type: 'warning' },
	            _react2['default'].createElement(
	              _MarkdownComponent2['default'],
	              null,
	              bundle['purchase.PENDING']
	            )
	          );
	        }
	      } else if (this.isPaid() || this.isShipped()) {
	        return _react2['default'].createElement(
	          _Alert2['default'],
	          { type: 'success' },
	          _react2['default'].createElement(
	            _MarkdownComponent2['default'],
	            null,
	            bundle['purchase.PAID']
	          )
	        );
	      } else if (this.isCanceled()) {
	        return _react2['default'].createElement(
	          _Alert2['default'],
	          { type: 'error' },
	          _react2['default'].createElement(
	            _MarkdownComponent2['default'],
	            null,
	            bundle['purchase.CANCELED']
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'getSummaryRows',
	    value: function getSummaryRows() {
	      var _props = this.props;
	      var locale = _props.locale;
	      var purchase = _props.purchase;
	
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	
	      var total = this.getTotal();
	
	      var summary_rows = [[bundle.summary.price, _domainAmount2['default'].format(locale, purchase.currency, purchase.amount)], [bundle.summary.shipping, _domainAmount2['default'].format(locale, purchase.currency, purchase.domicile ? purchase.domicile.shipping.cost : 0)], [this.getTotalLabel(bundle), _domainAmount2['default'].format(locale, purchase.currency, total)]];
	      if (_tcombForm2['default'].Num.is(purchase.payment_amount)) {
	        var gift_card_discount = total - purchase.payment_amount;
	        summary_rows.push([bundle.summary.gift_card_discount, ' - ' + _domainAmount2['default'].format(locale, purchase.currency, gift_card_discount)], [bundle.summary.payment_total, _domainAmount2['default'].format(locale, purchase.currency, purchase.payment_amount)]);
	      }
	      return summary_rows;
	    }
	  }, {
	    key: 'getSummary',
	    value: function getSummary() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'summary' },
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _domainGet_bundle2['default'])(this.props.locale).order.summary.title
	        ),
	        _react2['default'].createElement(
	          _StdTable2['default'],
	          null,
	          this.getSummaryRows()
	        )
	      );
	    }
	  }, {
	    key: 'getDetailRows',
	    value: function getDetailRows(bundle) {
	      return [[bundle.summary.id, this.props.purchase.id], [bundle.summary.tick, this.props.locale.format_date(this.props.purchase.tick)], [bundle.summary.product, this.props.purchase.product], [bundle.summary.quantity, '1']];
	    }
	  }, {
	    key: 'getDetail',
	    value: function getDetail() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          bundle.summary.details_title
	        ),
	        _react2['default'].createElement(
	          _StdTable2['default'],
	          null,
	          this.getDetailRows(bundle)
	        )
	      );
	    }
	  }, {
	    key: 'getCustomPayments',
	    value: function getCustomPayments() {
	      return this.props.custom_payments.map(function (custom_payment, index) {
	        return _react2['default'].createElement(_StdCustomPayment2['default'], { key: index, description: custom_payment.purchase_description, image: custom_payment.image });
	      });
	    }
	  }, {
	    key: 'getPaymentGateways',
	    value: function getPaymentGateways() {
	      var _this2 = this;
	
	      return this.props.purchase.payment.gateways.map(function (gateway, index) {
	        if (gateway.type === 'stripe') {
	          //return null
	          return _react2['default'].createElement(
	            _PurchaseStripeGateway2['default'],
	            { key: index, html: gateway.html },
	            (0, _domainGet_bundle2['default'])(_this2.props.locale).payment[gateway.type]
	          );
	        } else if (gateway.type === 'stripe_sca') {
	          var stripe_sca = JSON.parse(gateway.html);
	          console.log(stripe_sca);
	          return _react2['default'].createElement(
	            _PurchaseStripeScaGateway2['default'],
	            { key: index, stripe_sca: stripe_sca },
	            (0, _domainGet_bundle2['default'])(_this2.props.locale).payment['stripe']
	          );
	        } else {
	          return _react2['default'].createElement(
	            _PurchasePaymentGateway2['default'],
	            { key: index, html: gateway.html },
	            (0, _domainGet_bundle2['default'])(_this2.props.locale).payment[gateway.type]
	          );
	        }
	      });
	    }
	  }, {
	    key: 'getPaymentUrl',
	    value: function getPaymentUrl() {
	      return _react2['default'].createElement(_PurchasePaymentUrl2['default'], { url: this.props.purchase.payment.url, label: (0, _domainGet_bundle2['default'])(this.props.locale).go_payment });
	    }
	  }, {
	    key: 'getPayment',
	    value: function getPayment() {
	      if (this.props.purchase.payment) {
	        if (this.props.purchase.payment.gateways) {
	          return this.getPaymentGateways();
	        } else {
	          return this.getPaymentUrl();
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getPaymentsSection',
	    value: function getPaymentsSection(bundle) {
	      if (!this.isPending()) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          bundle.payment
	        ),
	        this.getCustomPayments(),
	        this.getPayment()
	      );
	    }
	  }, {
	    key: 'getDomicilieRows',
	    value: function getDomicilieRows(domicile) {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order.domicile;
	      return [[bundle.name, domicile.name], [bundle.surname, domicile.surname], [bundle.address, domicile.address], [bundle.co, domicile.co], [bundle.town, domicile.town], [bundle.district, domicile.district], [bundle.zip, domicile.zip], [bundle.country, this.props.locale.display_country(domicile.shipping.country)], [bundle.email, domicile.email], [bundle.mobile, domicile.mobile], [bundle.alt_email, domicile.alt_email], [bundle.alt_mobile, domicile.alt_mobile]];
	    }
	  }, {
	    key: 'getCouponRows',
	    value: function getCouponRows(coupon) {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order.domicile;
	      return [[bundle.name, coupon.name], [bundle.surname, coupon.surname], [bundle.email, coupon.email], [bundle.mobile, coupon.mobile]];
	    }
	  }, {
	    key: 'getContact',
	    value: function getContact() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      if (this.props.purchase.domicile) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            bundle.domicile.title
	          ),
	          _react2['default'].createElement(
	            _StdTable2['default'],
	            null,
	            this.getDomicilieRows(this.props.purchase.domicile)
	          )
	        );
	      } else if (this.props.purchase.coupon) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            bundle.coupon.title
	          ),
	          _react2['default'].createElement(
	            _StdTable2['default'],
	            null,
	            this.getCouponRows(this.props.purchase.coupon)
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getInvoice',
	    value: function getInvoice() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      if (!this.props.purchase.invoice) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          bundle.invoice.title
	        ),
	        _react2['default'].createElement(
	          _StdTable2['default'],
	          null,
	          this.getInvoiceRows(this.props.purchase.invoice)
	        )
	      );
	    }
	  }, {
	    key: 'getInvoiceRows',
	    value: function getInvoiceRows(invoice) {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      return [[bundle.invoice.name, invoice.name], [bundle.invoice.vat, invoice.vat], [bundle.invoice.address, invoice.address], [bundle.invoice.town, invoice.town], [bundle.invoice.district, invoice.district], [bundle.invoice.zip, invoice.zip]];
	    }
	  }, {
	    key: 'getGiftCardSection',
	    value: function getGiftCardSection(bundle) {
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	      if (this.hasGiftCardCodeAssigned()) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            bundle.gift_card.assigned_title
	          ),
	          _react2['default'].createElement(
	            _HTMLComponent2['default'],
	            null,
	            (0, _lodashStringTemplate2['default'])(bundle.gift_card.assigned)({
	              gift_card_code: this.props.purchase.gift_card_code
	            })
	          )
	        );
	      } else if (this.showGiftCardForm()) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            bundle.gift_card.title
	          ),
	          _react2['default'].createElement(
	            'form',
	            { onSubmit: this.onSubmit },
	            _react2['default'].createElement(_tcombForm2['default'].form.Form, {
	              ref: 'form',
	              type: FormType,
	              options: this.state.options }),
	            _react2['default'].createElement(
	              'button',
	              { className: 'btn', style: btnStyle },
	              bundle.gift_card.do_send_gift_card_code
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).order;
	      return {
	        fields: {
	          madaiCoupon: {
	            label: bundle.gift_card.label,
	            help: bundle.gift_card.hint
	          }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).order;
	
	      return _react2['default'].createElement(
	        _DefaultUi2['default'],
	        { id: 'purchase', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.props.message,
	              this.getPaymentMessage(),
	              this.getSummary(),
	              this.getPaymentsSection(bundle),
	              this.getGiftCardSection(bundle),
	              _react2['default'].createElement('hr', null),
	              this.getDetail(),
	              this.getContact(),
	              this.getInvoice(),
	              this.props.share_purchase
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Purchase = Purchase;
	  Purchase = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    purchase: _tcombForm2['default'].Obj,
	    pending_purchase_message: _tcombForm2['default'].maybe(_tcombForm2['default'].Str),
	    user: _domainUser2['default'],
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    share_purchase: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    custom_payments: _tcombForm2['default'].maybe(_tcombForm2['default'].list(_tcombForm2['default'].Obj)),
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    doSendGiftCardCode: _tcombForm2['default'].Func
	  })(Purchase) || Purchase;
	  return Purchase;
	})(_react2['default'].Component);
	
	exports['default'] = Purchase;
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _Locale = __webpack_require__(17);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Currency = __webpack_require__(178);
	
	var _Currency2 = _interopRequireDefault(_Currency);
	
	var Amount = _tcomb2['default'].refinement(_tcomb2['default'].Num, function (n) {
	  return n >= 0;
	});
	
	Amount.format = function (locale, currency, amount) {
	  locale = (0, _Locale2['default'])(locale);
	  currency = (0, _Currency2['default'])(currency);
	  amount = Amount(amount);
	
	  var ret = function (locale, currency, amount) {
	    var bundle = locale.locale_bundle();
	    _tcomb2['default'].assert(_tcomb2['default'].Object.is(bundle));
	    var symbol = bundle.currency[currency];
	    return symbol + ' ' + locale.format_number(amount);
	  }.call(this, locale, currency, amount);
	
	  return _tcomb2['default'].String(ret);
	};
	
	exports['default'] = Amount;
	module.exports = exports['default'];

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Currency = _tcomb2['default'].enums.of('EUR CAD GBP USD ZAR BRL'.split(' '));
	
	module.exports = Currency;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(113);
	
	var StdTable = (function (_React$Component) {
	  _inherits(StdTable, _React$Component);
	
	  function StdTable() {
	    _classCallCheck(this, _StdTable);
	
	    _get(Object.getPrototypeOf(_StdTable.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(StdTable, [{
	    key: 'getRow',
	    value: function getRow(_ref, index) {
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var label = _ref2[0];
	      var value = _ref2[1];
	
	      if (_tcombReact.t.Nil.is(value)) {
	        return null;
	      }
	      return _react2['default'].createElement(
	        'tr',
	        { key: index },
	        _react2['default'].createElement(
	          'td',
	          { className: 'std-table-label' },
	          label
	        ),
	        _react2['default'].createElement(
	          'td',
	          { className: 'std-table-value' },
	          value
	        )
	      );
	    }
	  }, {
	    key: 'getRows',
	    value: function getRows() {
	      return this.props.children.map(this.getRow);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'table',
	        { className: 'std-table' },
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          this.getRows()
	        )
	      );
	    }
	  }]);
	
	  var _StdTable = StdTable;
	  StdTable = (0, _tcombReact.props)({
	    children: _tcombReact.t.Arr
	  })(StdTable) || StdTable;
	  return StdTable;
	})(_react2['default'].Component);
	
	exports['default'] = StdTable;
	module.exports = exports['default'];

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainURL = __webpack_require__(181);
	
	var _domainURL2 = _interopRequireDefault(_domainURL);
	
	var _MarkdownComponent = __webpack_require__(160);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _tcombReact = __webpack_require__(113);
	
	var StdCustomPayment = (function (_React$Component) {
	  _inherits(StdCustomPayment, _React$Component);
	
	  function StdCustomPayment() {
	    _classCallCheck(this, _StdCustomPayment);
	
	    _get(Object.getPrototypeOf(_StdCustomPayment.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(StdCustomPayment, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: 'custom' },
	          _react2['default'].createElement('img', { src: this.props.image })
	        ),
	        _react2['default'].createElement(
	          _MarkdownComponent2['default'],
	          null,
	          this.props.description
	        ),
	        _react2['default'].createElement('hr', null)
	      );
	    }
	  }]);
	
	  var _StdCustomPayment = StdCustomPayment;
	  StdCustomPayment = (0, _tcombReact.props)({
	    image: _domainURL2['default'],
	    description: _tcombReact.t.Str
	  })(StdCustomPayment) || StdCustomPayment;
	  return StdCustomPayment;
	})(_react2['default'].Component);
	
	exports['default'] = StdCustomPayment;
	module.exports = exports['default'];

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var is_url_regexp = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
	
	var URL = _tcomb2['default'].refinement(_tcomb2['default'].String, function (url) {
	  return is_url_regexp.test(url);
	});
	
	exports['default'] = URL;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(113);
	
	var _HTMLComponent = __webpack_require__(161);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var DefaultUi = (function (_React$Component) {
	  _inherits(DefaultUi, _React$Component);
	
	  function DefaultUi() {
	    _classCallCheck(this, _DefaultUi);
	
	    _get(Object.getPrototypeOf(_DefaultUi.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(DefaultUi, [{
	    key: 'render',
	    value: function render() {
	      var titleStyle = {
	        backgroundColor: this.props.themeBgColor,
	        color: this.props.themeBgFontColor
	      };
	      return _react2['default'].createElement(
	        'div',
	        { id: this.props.id },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell default-ui' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'box dark default-ui-title', style: titleStyle },
	                _react2['default'].createElement(
	                  'h1',
	                  { className: 'large-text-center' },
	                  _react2['default'].createElement(
	                    _HTMLComponent2['default'],
	                    null,
	                    this.props.title
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'box light default-ui-content' },
	                this.props.children
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _DefaultUi = DefaultUi;
	  DefaultUi = (0, _tcombReact.props)({
	    id: _tcombReact.t.Str,
	    doAcceptCookies: _tcombReact.t.maybe(_tcombReact.t.Func),
	    title: _tcombReact.t.Str,
	    children: _tcombReact.t.Any,
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(DefaultUi) || DefaultUi;
	  return DefaultUi;
	})(_react2['default'].Component);
	
	exports['default'] = DefaultUi;
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HTMLComponent = __webpack_require__(161);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _tcombReact = __webpack_require__(113);
	
	var PurchasePaymentGateway = (function (_React$Component) {
	  _inherits(PurchasePaymentGateway, _React$Component);
	
	  function PurchasePaymentGateway() {
	    _classCallCheck(this, _PurchasePaymentGateway);
	
	    _get(Object.getPrototypeOf(_PurchasePaymentGateway.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PurchasePaymentGateway, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _HTMLComponent2['default'],
	          null,
	          this.props.html
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          this.props.children
	        ),
	        _react2['default'].createElement('hr', null)
	      );
	    }
	  }]);
	
	  var _PurchasePaymentGateway = PurchasePaymentGateway;
	  PurchasePaymentGateway = (0, _tcombReact.props)({
	    html: _tcombReact.t.Str,
	    children: _tcombReact.t.Any
	  })(PurchasePaymentGateway) || PurchasePaymentGateway;
	  return PurchasePaymentGateway;
	})(_react2['default'].Component);
	
	exports['default'] = PurchasePaymentGateway;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(113);
	
	var PurchaseStripeGateway = (function (_React$Component) {
	  _inherits(PurchaseStripeGateway, _React$Component);
	
	  function PurchaseStripeGateway() {
	    _classCallCheck(this, _PurchaseStripeGateway);
	
	    _get(Object.getPrototypeOf(_PurchaseStripeGateway.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PurchaseStripeGateway, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      $('#stripeGatway').html(this.props.html);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement('div', { id: 'stripeGatway' }),
	        _react2['default'].createElement(
	          'div',
	          null,
	          this.props.children
	        ),
	        _react2['default'].createElement('hr', null)
	      );
	    }
	  }]);
	
	  var _PurchaseStripeGateway = PurchaseStripeGateway;
	  PurchaseStripeGateway = (0, _tcombReact.props)({
	    html: _tcombReact.t.Str,
	    children: _tcombReact.t.Any
	  })(PurchaseStripeGateway) || PurchaseStripeGateway;
	  return PurchaseStripeGateway;
	})(_react2['default'].Component);
	
	exports['default'] = PurchaseStripeGateway;
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(113);
	
	var _utilStripeCheckoutButton = __webpack_require__(186);
	
	var _utilStripeCheckoutButton2 = _interopRequireDefault(_utilStripeCheckoutButton);
	
	var PurchaseStripeScaGateway = (function (_React$Component) {
	  _inherits(PurchaseStripeScaGateway, _React$Component);
	
	  function PurchaseStripeScaGateway() {
	    var _this = this;
	
	    _classCallCheck(this, _PurchaseStripeScaGateway);
	
	    _get(Object.getPrototypeOf(_PurchaseStripeScaGateway.prototype), 'constructor', this).apply(this, arguments);
	
	    this.onClickPayment = function () {
	      var stripe_sca = _this.props.stripe_sca;
	      (0, _utilStripeCheckoutButton2['default'])(stripe_sca.sessionId, stripe_sca.publicKey);
	    };
	  }
	
	  _createClass(PurchaseStripeScaGateway, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { id: 'stripeScaGatway' },
	          _react2['default'].createElement(
	            'button',
	            { id: 'checkout-button-sca', onClick: this.onClickPayment.bind(this), /*className="stripe-button-el"*/style: { fontSize: '13px' } },
	            _react2['default'].createElement(
	              'span',
	              null,
	              'Pay with Card'
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          this.props.children
	        ),
	        _react2['default'].createElement('hr', null)
	      );
	    }
	  }]);
	
	  var _PurchaseStripeScaGateway = PurchaseStripeScaGateway;
	  PurchaseStripeScaGateway = (0, _tcombReact.props)({
	    stripe_sca: _tcombReact.t.Any,
	    children: _tcombReact.t.Any
	  })(PurchaseStripeScaGateway) || PurchaseStripeScaGateway;
	  return PurchaseStripeScaGateway;
	})(_react2['default'].Component);
	
	exports['default'] = PurchaseStripeScaGateway;
	module.exports = exports['default'];

	/*componentDidMount() {
	  $('#stripeScaGatway').html('<button id="checkout-button" onClick={this.onClickPayment} className="stripe-button"><span>Pay with Carddddddddddddd</span></button>');    
	}
	*/

/***/ },
/* 186 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = stripeCheckoutButton;
	
	function stripeCheckoutButton(sessionId, publicKey) {
	    if (Stripe) {
	        var stripe = Stripe(publicKey);
	        stripe.redirectToCheckout({
	            sessionId: sessionId
	        }).then(function (result) {});
	    }
	}

	module.exports = exports["default"];

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainURL = __webpack_require__(181);
	
	var _domainURL2 = _interopRequireDefault(_domainURL);
	
	var _tcombReact = __webpack_require__(113);
	
	var PurchasePaymentUrl = (function (_React$Component) {
	  _inherits(PurchasePaymentUrl, _React$Component);
	
	  function PurchasePaymentUrl() {
	    _classCallCheck(this, _PurchasePaymentUrl);
	
	    _get(Object.getPrototypeOf(_PurchasePaymentUrl.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PurchasePaymentUrl, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'a',
	        { target: '_top', href: this.props.url },
	        this.props.label
	      );
	    }
	  }]);
	
	  var _PurchasePaymentUrl = PurchasePaymentUrl;
	  PurchasePaymentUrl = (0, _tcombReact.props)({
	    url: _domainURL2['default'],
	    label: _tcombReact.t.Str
	  })(PurchasePaymentUrl) || PurchasePaymentUrl;
	  return PurchasePaymentUrl;
	})(_react2['default'].Component);
	
	exports['default'] = PurchasePaymentUrl;
	module.exports = exports['default'];

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(113);
	
	var Sponsor = (function (_React$Component) {
	  _inherits(Sponsor, _React$Component);
	
	  function Sponsor() {
	    _classCallCheck(this, _Sponsor);
	
	    _get(Object.getPrototypeOf(_Sponsor.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Sponsor, [{
	    key: 'hasSponsor',
	    value: function hasSponsor() {
	      return !!this.props.sponsor;
	    }
	  }, {
	    key: 'useWelcomeSponsor',
	    value: function useWelcomeSponsor() {
	      return !!this.props.options.isWelcome;
	    }
	  }, {
	    key: 'showTutorial',
	    value: function showTutorial() {
	      return !!this.props.options.showTutorial;
	    }
	  }, {
	    key: 'getDefaultImages',
	    value: function getDefaultImages() {
	      return {
	        logo: _react2['default'].createElement('img', { className: 'large-100', src: 'https://static.madai.com/pub/default_images_sponsor_madai/logo_madai_new.jpeg' }),
	        cover: _react2['default'].createElement('img', { className: 'large-100 large-pull-left', src: 'https://static.madai.com/pub/default_images_sponsor_madai/cover_image_new.jpg' }),
	        tutorial: null //(this.showTutorial()) ? <img className='large-100' src="https://static.madai.com/pub/default_images_sponsor_madai/tutorial_red.jpg" /> : null
	      };
	    }
	  }, {
	    key: 'getLogo',
	    value: function getLogo() {
	      if (this.useWelcomeSponsor()) {
	        return this.props.sponsor.welcome_logo || this.props.sponsor.logo;
	      } else {
	        return this.props.sponsor.logo;
	      }
	    }
	  }, {
	    key: 'getCover',
	    value: function getCover() {
	      if (this.useWelcomeSponsor()) {
	        return this.props.sponsor.welcome_image || this.props.sponsor.image;
	      } else {
	        return this.props.sponsor.image;
	      }
	    }
	  }, {
	    key: 'getTutorialImage',
	    value: function getTutorialImage() {
	      if (!this.showTutorial()) {
	        return null;
	      }
	      var src = this.getTutorialSrc();
	      if (_tcombReact.t.Nil.is(src)) {
	        return null;
	      }
	      return _react2['default'].createElement('img', { className: 'large-100', src: src });
	    }
	  }, {
	    key: 'getTutorialSrc',
	    value: function getTutorialSrc() {
	      if (this.useWelcomeSponsor()) {
	        return this.props.sponsor.welcome_tutorial || this.props.sponsor.tutorial;
	      } else {
	        return this.props.sponsor.tutorial;
	      }
	    }
	  }, {
	    key: 'getImages',
	    value: function getImages() {
	      if (!this.hasSponsor()) {
	        return this.getDefaultImages();
	      }
	      return {
	        logo: _react2['default'].createElement('img', { className: 'large-100', src: this.getLogo() }),
	        cover: _react2['default'].createElement('img', { className: 'large-100 large-pull-left', src: this.getCover() }),
	        tutorial: this.getTutorialImage()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var images = this.getImages();
	      return _react2['default'].createElement(
	        'div',
	        { id: 'sponsor' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100 small-hide' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-pull-left logo' },
	              images.logo
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-pull-left cover' },
	              images.cover
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'tutorial small-hide' },
	            images.tutorial
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Sponsor = Sponsor;
	  Sponsor = (0, _tcombReact.props)({
	    isWelcome: _tcombReact.t.maybe(_tcombReact.t.Bool),
	    locale: _tcombReact.t.Obj,
	    sponsor: _tcombReact.t.maybe(_tcombReact.t.Obj),
	    options: _tcombReact.t.maybe(_tcombReact.t.Obj)
	  })(Sponsor) || Sponsor;
	  return Sponsor;
	})(_react2['default'].Component);
	
	exports['default'] = Sponsor;
	module.exports = exports['default'];

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsLayout = __webpack_require__(165);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _domainUser = __webpack_require__(117);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _componentsHeaderUser = __webpack_require__(175);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsContentPurchases = __webpack_require__(190);
	
	var _componentsContentPurchases2 = _interopRequireDefault(_componentsContentPurchases);
	
	var _componentsSponsor = __webpack_require__(188);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _tcombReact = __webpack_require__(113);
	
	var Purchases = (function (_React$Component) {
	  _inherits(Purchases, _React$Component);
	
	  function Purchases() {
	    _classCallCheck(this, _Purchases);
	
	    _get(Object.getPrototypeOf(_Purchases.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Purchases, [{
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], { user: this.props.user,
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goChangePassword: this.props.goChangePassword,
	        goPurchases: this.props.goPurchases,
	        doLogout: this.props.doLogout });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), sponsor: this.getSponsor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentPurchases2['default'], {
	          locale: locale,
	          purchases: this.props.purchases,
	          user: this.props.user,
	          goPurchase: this.props.goPurchase,
	          goAccount: this.props.goAccount,
	          goChangePassword: this.props.goChangePassword,
	          goPurchases: this.props.goPurchases,
	          doLogout: this.props.doLogout,
	          doAcceptCookies: this.props.doAcceptCookies })
	      );
	    }
	  }]);
	
	  var _Purchases = Purchases;
	  Purchases = (0, _tcombReact.props)({
	    locale: _tcombReact.t.Obj,
	    purchases: _tcombReact.t.Obj,
	    user: _domainUser2['default'],
	    goPurchase: _tcombReact.t.Func,
	    goAccount: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func
	  })(Purchases) || Purchases;
	  return Purchases;
	})(_react2['default'].Component);
	
	exports['default'] = Purchases;
	module.exports = exports['default'];

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainAmount = __webpack_require__(177);
	
	var _domainAmount2 = _interopRequireDefault(_domainAmount);
	
	var _domainUser = __webpack_require__(117);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainIsEmpty = __webpack_require__(191);
	
	var _domainIsEmpty2 = _interopRequireDefault(_domainIsEmpty);
	
	var _Table = __webpack_require__(192);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _DefaultUi = __webpack_require__(182);
	
	var _DefaultUi2 = _interopRequireDefault(_DefaultUi);
	
	var _lodashCollectionSortByOrder = __webpack_require__(193);
	
	var _lodashCollectionSortByOrder2 = _interopRequireDefault(_lodashCollectionSortByOrder);
	
	var _tcombReact = __webpack_require__(113);
	
	var Purchases = (function (_React$Component) {
	  _inherits(Purchases, _React$Component);
	
	  function Purchases() {
	    _classCallCheck(this, _Purchases);
	
	    _get(Object.getPrototypeOf(_Purchases.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Purchases, [{
	    key: 'onClick',
	    value: function onClick(id, evt) {
	      evt.preventDefault();
	      this.props.goPurchase(id);
	    }
	  }, {
	    key: 'hasRows',
	    value: function hasRows() {
	      return this.props.purchases && !(0, _domainIsEmpty2['default'])(this.props.purchases);
	    }
	  }, {
	    key: 'getRow',
	    value: function getRow(bundle, purchase) {
	      return _react2['default'].createElement(
	        'tr',
	        { key: purchase.id },
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { onClick: this.onClick.bind(this, purchase.id), href: '#' },
	            purchase.product
	          )
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          _domainAmount2['default'].format(this.props.locale, purchase.currency, purchase.amount)
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          bundle.status[purchase.status]
	        )
	      );
	    }
	  }, {
	    key: 'getRowsTable',
	    value: function getRowsTable(bundle) {
	      var _this = this;
	
	      return (0, _lodashCollectionSortByOrder2['default'])(this.props.purchases, 'tick', 'desc').map(function (purchase) {
	        return _this.getRow(bundle, purchase);
	      });
	    }
	  }, {
	    key: 'getContentHTML',
	    value: function getContentHTML(rows, bundle) {
	      var striped = true;
	      if (this.hasRows()) {
	        return _react2['default'].createElement(
	          _Table2['default'],
	          { columns: bundle.table, striped: striped },
	          rows
	        );
	      } else {
	        return _react2['default'].createElement(
	          'em',
	          null,
	          bundle.no_purchases
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).purchases;
	      var rows = this.getRowsTable(bundle);
	
	      return _react2['default'].createElement(
	        _DefaultUi2['default'],
	        { id: 'purchases', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.getContentHTML(rows, bundle)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Purchases = Purchases;
	  Purchases = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    purchases: _tcombReact.t.Obj,
	    user: _domainUser2['default'],
	    themeBgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombReact.t.maybe(_domainColor2['default']),
	    goPurchase: _tcombReact.t.Func,
	    goAccount: _tcombReact.t.Func,
	    goChangePassword: _tcombReact.t.Func,
	    goPurchases: _tcombReact.t.Func,
	    doLogout: _tcombReact.t.Func,
	    doAcceptCookies: _tcombReact.t.Func
	  })(Purchases) || Purchases;
	  return Purchases;
	})(_react2['default'].Component);
	
	exports['default'] = Purchases;
	module.exports = exports['default'];

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = isEmpty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	function isEmpty(x) {
	  _tcomb2['default'].assert(_tcomb2['default'].Obj.is(x));
	  for (var k in x) {
	    if (x.hasOwnProperty(k)) {
	      return false;
	    }
	  }
	  return true;
	}

	module.exports = exports['default'];

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(125);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tcombReact = __webpack_require__(113);
	
	var Table = (function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  function Table() {
	    _classCallCheck(this, _Table);
	
	    _get(Object.getPrototypeOf(_Table.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Table, [{
	    key: 'render',
	    value: function render() {
	      var className = {
	        table: true,
	        'table-striped': this.props.striped
	      };
	      return _react2['default'].createElement(
	        'table',
	        { className: (0, _classnames2['default'])(className) },
	        _react2['default'].createElement(
	          'thead',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            null,
	            this.props.columns.map(function (column, i) {
	              return _react2['default'].createElement(
	                'th',
	                { key: i },
	                column
	              );
	            })
	          )
	        ),
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  var _Table = Table;
	  Table = (0, _tcombReact.props)({
	    striped: _tcombReact.t.Bool,
	    columns: _tcombReact.t.Arr,
	    children: _tcombReact.t.Any
	  })(Table) || Table;
	  return Table;
	})(_react2['default'].Component);
	
	exports['default'] = Table;
	module.exports = exports['default'];

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortByOrder = __webpack_require__(194),
	    isArray = __webpack_require__(40),
	    isIterateeCall = __webpack_require__(51);
	
	/**
	 * This method is like `_.sortByAll` except that it allows specifying the
	 * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	 * values are sorted in ascending order. Otherwise, a value is sorted in
	 * ascending order if its corresponding order is "asc", and descending if "desc".
	 *
	 * If a property name is provided for an iteratee the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If an object is provided for an iteratee the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {boolean[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 42 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // sort by `user` in ascending order and by `age` in descending order
	 * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	 * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	 */
	function sortByOrder(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (guard && isIterateeCall(iteratees, orders, guard)) {
	    orders = undefined;
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseSortByOrder(collection, iteratees, orders);
	}
	
	module.exports = sortByOrder;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(195),
	    baseCallback = __webpack_require__(76),
	    baseMap = __webpack_require__(107),
	    baseSortBy = __webpack_require__(108),
	    compareMultiple = __webpack_require__(196);
	
	/**
	 * The base implementation of `_.sortByOrder` without param guards.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {boolean[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseSortByOrder(collection, iteratees, orders) {
	  var index = -1;
	
	  iteratees = arrayMap(iteratees, function(iteratee) { return baseCallback(iteratee); });
	
	  var result = baseMap(collection, function(value) {
	    var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseSortByOrder;


/***/ },
/* 195 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var baseCompareAscending = __webpack_require__(110);
	
	/**
	 * Used by `_.sortByOrder` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	 * a value is sorted in ascending order if its corresponding order is "asc", and
	 * descending if "desc".
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * ((order === 'asc' || order === true) ? 1 : -1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainUser = __webpack_require__(117);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _componentsLayout = __webpack_require__(165);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsHeaderUser = __webpack_require__(175);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsSponsor = __webpack_require__(188);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _componentsContentChangePassword = __webpack_require__(198);
	
	var _componentsContentChangePassword2 = _interopRequireDefault(_componentsContentChangePassword);
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(113);
	
	var ChangePassword = (function (_React$Component) {
	  _inherits(ChangePassword, _React$Component);
	
	  function ChangePassword() {
	    _classCallCheck(this, _ChangePassword);
	
	    _get(Object.getPrototypeOf(_ChangePassword.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ChangePassword, [{
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], { user: this.props.user,
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goChangePassword: this.props.goChangePassword,
	        goPurchases: this.props.goPurchases,
	        doLogout: this.props.doLogout });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), sponsor: this.getSponsor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentChangePassword2['default'], {
	          locale: locale,
	          doChangePassword: this.props.doChangePassword,
	          user: this.props.user,
	          message: this.props.message,
	          goAccount: this.props.goAccount,
	          goChangePassword: this.props.goChangePassword,
	          goPurchases: this.props.goChangePassword,
	          doLogout: this.props.doLogout,
	          doAcceptCookies: this.props.doAcceptCookies })
	      );
	    }
	  }]);
	
	  var _ChangePassword = ChangePassword;
	  ChangePassword = (0, _tcombReact.props)({
	    locale: _tcombForm2['default'].Obj,
	    doChangePassword: _tcombForm2['default'].Func,
	    user: _domainUser2['default'],
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func
	  })(ChangePassword) || ChangePassword;
	  return ChangePassword;
	})(_react2['default'].Component);
	
	exports['default'] = ChangePassword;
	module.exports = exports['default'];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(4);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainPassword = __webpack_require__(199);
	
	var _domainPassword2 = _interopRequireDefault(_domainPassword);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _DefaultUi = __webpack_require__(182);
	
	var _DefaultUi2 = _interopRequireDefault(_DefaultUi);
	
	var _domainUser = __webpack_require__(117);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _Alert = __webpack_require__(158);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(113);
	
	var FormType = _tcombForm2['default'].struct({
	  old_password: _domainPassword2['default'],
	  new_password: _domainPassword2['default'],
	  confirm_password: _domainPassword2['default']
	});
	
	var ChangePassword = (function (_React$Component) {
	  _inherits(ChangePassword, _React$Component);
	
	  function ChangePassword() {
	    var _this = this;
	
	    _classCallCheck(this, _ChangePassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_ChangePassword.prototype), 'constructor', this).apply(this, args);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var bundle = (0, _domainGet_bundle2['default'])(_this.props.locale).change_password;
	      var value = _this.refs.form.getValue();
	
	      if (value) {
	        if (value.new_password !== value.confirm_password) {
	          _reactDom2['default'].render(_react2['default'].createElement(
	            _Alert2['default'],
	            { type: 'error' },
	            bundle['confirm_password_error']
	          ), document.getElementById('message'));
	        } else {
	          _this.props.doChangePassword(value.old_password, value.new_password);
	        }
	      }
	    };
	
	    this.state = {
	      options: this.getOptions()
	    };
	  }
	
	  _createClass(ChangePassword, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).change_password;
	      return {
	        fields: {
	          old_password: {
	            label: bundle.current_password,
	            type: 'password',
	            minLength: 6
	          },
	          new_password: {
	            label: bundle.new_password,
	            type: 'password',
	            minLength: 6
	          },
	          confirm_password: {
	            label: bundle.confirm_password,
	            type: 'password',
	            minLength: 6
	          }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).change_password;
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        _DefaultUi2['default'],
	        { id: 'change_password', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	        _react2['default'].createElement(
	          'div',
	          { id: 'message' },
	          this.props.message
	        ),
	        _react2['default'].createElement(
	          'form',
	          { onSubmit: this.onSubmit },
	          _react2['default'].createElement(_tcombForm2['default'].form.Form, {
	            ref: 'form',
	            type: FormType,
	            options: this.state.options }),
	          _react2['default'].createElement(
	            'button',
	            { className: 'btn', style: btnStyle },
	            bundle.do_save
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ChangePassword = ChangePassword;
	  ChangePassword = (0, _tcombReact.props)({
	    locale: _tcombForm2['default'].Obj,
	    doChangePassword: _tcombForm2['default'].Func,
	    user: _domainUser2['default'],
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func
	  })(ChangePassword) || ChangePassword;
	  return ChangePassword;
	})(_react2['default'].Component);
	
	exports['default'] = ChangePassword;
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Password = _tcomb2['default'].subtype(_tcomb2['default'].Str, function (x) {
	  return x.length >= 6;
	});
	
	module.exports = Password;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsLayout = __webpack_require__(165);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsHeaderUser = __webpack_require__(175);
	
	var _componentsHeaderUser2 = _interopRequireDefault(_componentsHeaderUser);
	
	var _componentsContentAccount = __webpack_require__(201);
	
	var _componentsContentAccount2 = _interopRequireDefault(_componentsContentAccount);
	
	var _componentsSponsor = __webpack_require__(188);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _domainUser = __webpack_require__(117);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(113);
	
	var Account = (function (_React$Component) {
	  _inherits(Account, _React$Component);
	
	  function Account() {
	    _classCallCheck(this, _Account);
	
	    _get(Object.getPrototypeOf(_Account.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Account, [{
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderUser2['default'], {
	        user: this.props.user,
	        locale: this.props.locale,
	        goAccount: this.props.goAccount,
	        goChangePassword: this.props.goChangePassword,
	        goPurchases: this.props.goPurchases,
	        doLogout: this.props.doLogout });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), sponsor: this.getSponsor(), locale: locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentAccount2['default'], {
	          districts: this.props.districts,
	          loadDistricts: this.props.loadDistricts,
	          doUpdateAccount: this.props.doUpdateAccount,
	          locale: this.props.locale,
	          user: this.props.user,
	          doAcceptCookies: this.props.doAcceptCookies,
	          goAccount: this.props.goAccount,
	          goChangePassword: this.props.goChangePassword,
	          goPurchases: this.props.goPurchases,
	          doLogout: this.props.doLogout,
	          message: this.props.message })
	      );
	    }
	  }]);
	
	  var _Account = Account;
	  Account = (0, _tcombReact.props)({
	    districts: _tcombForm2['default'].Arr,
	    loadDistricts: _tcombForm2['default'].Func,
	    doUpdateAccount: _tcombForm2['default'].Func,
	    locale: _tcombForm2['default'].Obj,
	    user: _domainUser2['default'],
	    doAcceptCookies: _tcombForm2['default'].Func,
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement)
	  })(Account) || Account;
	  return Account;
	})(_react2['default'].Component);
	
	exports['default'] = Account;
	module.exports = exports['default'];

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DefaultUi = __webpack_require__(182);
	
	var _DefaultUi2 = _interopRequireDefault(_DefaultUi);
	
	var _HTMLComponent = __webpack_require__(161);
	
	var _HTMLComponent2 = _interopRequireDefault(_HTMLComponent);
	
	var _MarkdownComponent = __webpack_require__(160);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainUser = __webpack_require__(117);
	
	var _domainUser2 = _interopRequireDefault(_domainUser);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainGender = __webpack_require__(152);
	
	var _domainGender2 = _interopRequireDefault(_domainGender);
	
	var _domainCom_Locale = __webpack_require__(202);
	
	var _domainCom_Locale2 = _interopRequireDefault(_domainCom_Locale);
	
	var _domainCountries = __webpack_require__(73);
	
	var _domainCountries2 = _interopRequireDefault(_domainCountries);
	
	var _utilGetConditions = __webpack_require__(203);
	
	var _utilGetConditions2 = _interopRequireDefault(_utilGetConditions);
	
	var _utilGetPolicy = __webpack_require__(204);
	
	var _utilGetPolicy2 = _interopRequireDefault(_utilGetPolicy);
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(113);
	
	var _lodashStringTemplate = __webpack_require__(25);
	
	var _lodashStringTemplate2 = _interopRequireDefault(_lodashStringTemplate);
	
	var Account = (function (_React$Component) {
	  _inherits(Account, _React$Component);
	
	  function Account() {
	    var _this = this;
	
	    _classCallCheck(this, _Account);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_Account.prototype), 'constructor', this).apply(this, args);
	
	    this.onChange = function (value) {
	      if (value.country) {
	        if (value.country !== _this.state.value.country) {
	          _this.props.loadDistricts(value.country, function (districts) {
	            _this.districts = districts;
	            value.district = null;
	            _this.setState({
	              value: value,
	              options: _this.getOptions(value)
	            });
	          });
	        } else {
	          _this.setState({
	            value: value
	          });
	        }
	      } else {
	        _this.setState({
	          value: value,
	          options: _this.getOptions(value)
	        });
	      }
	    };
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	
	      if (value) {
	        _this.props.doUpdateAccount(value.name, value.surname, value.gender, value.birth_date.getTime(), value.country, value.district, value.zip, value.com_locale);
	      }
	    };
	
	    this.districts = this.props.districts;
	    var value = this.getValue();
	    this.state = {
	      value: value,
	      options: this.getOptions(value)
	    };
	  }
	
	  _createClass(Account, [{
	    key: 'getCountriesOptions',
	    value: function getCountriesOptions() {
	      return _domainCountries2['default'].to_options(this.props.locale).map(function (country) {
	        return {
	          value: country[0],
	          text: country[1]
	        };
	      });
	    }
	  }, {
	    key: 'getGenderOptions',
	    value: function getGenderOptions() {
	      return (0, _domainGet_bundle2['default'])(this.props.locale).user.gender_options.map(function (option) {
	        return {
	          value: option[0],
	          text: option[1]
	        };
	      });
	    }
	  }, {
	    key: 'getComLocaleOptions',
	    value: function getComLocaleOptions() {
	      var locale = this.props.locale;
	      var options = [];
	      for (var com_locale in _domainCom_Locale2['default'].meta.map) {
	        var l = _domainLocale2['default'].of(com_locale);
	        options.push({
	          value: com_locale,
	          text: locale.display_language(l.language) + ' (' + locale.display_country(l.country) + ')'
	        });
	      }
	      return options;
	    }
	  }, {
	    key: 'getDistrictsOptions',
	    value: function getDistrictsOptions(country) {
	      if (!country) {
	        return [];
	      }
	
	      return this.districts.map(function (district) {
	        return {
	          value: district[0],
	          text: district[1]
	        };
	      });
	    }
	  }, {
	    key: 'getDistrictsArray',
	    value: function getDistrictsArray() {
	      return this.districts.map(function (district) {
	        return district[0];
	      });
	    }
	  }, {
	    key: 'getCountriesArray',
	    value: function getCountriesArray() {
	      var countriesElements = [];
	      for (var country in _domainCountries2['default'].data) {
	        countriesElements.push(country);
	      }
	      return countriesElements;
	    }
	  }, {
	    key: 'getFormType',
	    value: function getFormType() {
	
	      var districtsArray = this.getDistrictsArray();
	      var District = _tcombForm2['default'].enums.of(districtsArray);
	
	      var countriesArray = this.getCountriesArray();
	      var CountryDomain = _tcombForm2['default'].enums.of(countriesArray);
	
	      return _tcombForm2['default'].struct({
	        name: _tcombForm2['default'].maybe(_tcombForm2['default'].Str),
	        surname: _tcombForm2['default'].maybe(_tcombForm2['default'].Str),
	        gender: _domainGender2['default'],
	        birth_date: _tcombForm2['default'].Dat,
	        country: CountryDomain,
	        district: District,
	        zip: _tcombForm2['default'].Str,
	        com_locale: _domainCom_Locale2['default'],
	        email: _tcombForm2['default'].Str,
	        mobile: _tcombForm2['default'].Str
	      }, 'Account');
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions(value) {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale).user;
	
	      return {
	        config: {
	          horizontal: {
	            md: [3, 9],
	            sm: [6, 6]
	          }
	        },
	        fields: {
	          name: {
	            label: bundle.name
	          },
	          surname: {
	            label: bundle.surname
	          },
	          gender: {
	            label: bundle.gender,
	            options: this.getGenderOptions()
	          },
	          birth_date: {
	            label: bundle.birth_date,
	            order: locale.getTcombFormDateOrder()
	          },
	          country: {
	            label: bundle.country,
	            options: this.getCountriesOptions(),
	            help: bundle.country_hint
	          },
	          district: {
	            label: bundle.district,
	            options: this.getDistrictsOptions(value.country)
	          },
	          zip: {
	            label: bundle.zip
	          },
	          com_locale: {
	            label: bundle.locale,
	            options: this.getComLocaleOptions(),
	            help: bundle.locale_hint
	          },
	          email: {
	            label: bundle.email,
	            type: 'static'
	          },
	          mobile: {
	            label: bundle.mobile,
	            type: 'static'
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      var user = this.props.user;
	
	      return {
	        name: user.name,
	        surname: user.surname,
	        gender: user.gender,
	        birth_date: new Date(user.birth_date),
	        country: user.country,
	        district: user.district,
	        zip: user.zip,
	        com_locale: user.com_locale.toJSON(),
	        email: user.email,
	        mobile: user.mobile
	      };
	    }
	  }, {
	    key: 'getHelp',
	    value: function getHelp() {
	      return _react2['default'].createElement(
	        _MarkdownComponent2['default'],
	        null,
	        (0, _domainGet_bundle2['default'])(this.props.locale)['account']['help']
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).account;
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        _DefaultUi2['default'],
	        { id: 'account', title: bundle.title, themeBgColor: this.props.themeBgColor, themeBgFontColor: this.props.themeBgFontColor },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-30 medium-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'alert info help' },
	                this.getHelp()
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-70 medium-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.props.message,
	              _react2['default'].createElement(
	                'form',
	                { onSubmit: this.onSubmit },
	                _react2['default'].createElement(_tcombForm2['default'].form.Form, {
	                  ref: 'form',
	                  type: this.getFormType(),
	                  options: this.state.options,
	                  value: this.state.value,
	                  onChange: this.onChange }),
	                _react2['default'].createElement(
	                  'button',
	                  { className: 'large-left-30p small-left-0p btn', style: btnStyle },
	                  bundle.do_save
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'large-left-30p small-left-0p disclaimer' },
	                  _react2['default'].createElement(
	                    'small',
	                    null,
	                    _react2['default'].createElement(
	                      _HTMLComponent2['default'],
	                      null,
	                      (0, _lodashStringTemplate2['default'])(bundle.disclaimer)({
	                        conditions: (0, _utilGetConditions2['default'])(locale),
	                        policy: (0, _utilGetPolicy2['default'])(locale)
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Account = Account;
	  Account = (0, _tcombReact.props)({
	    districts: _tcombForm2['default'].Arr,
	    loadDistricts: _tcombForm2['default'].Func,
	    doUpdateAccount: _tcombForm2['default'].Func,
	    locale: _tcombForm2['default'].Obj,
	    user: _domainUser2['default'],
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    doAcceptCookies: _tcombForm2['default'].Func,
	    goAccount: _tcombForm2['default'].Func,
	    goChangePassword: _tcombForm2['default'].Func,
	    goPurchases: _tcombForm2['default'].Func,
	    doLogout: _tcombForm2['default'].Func,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement)
	  })(Account) || Account;
	  return Account;
	})(_react2['default'].Component);
	
	exports['default'] = Account;
	module.exports = exports['default'];

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var Com_Locale = _tcomb2['default'].enums.of('fr_FR en_GB en_US es_ES it_IT en_ZA de_DE pt_BR');
	
	module.exports = Com_Locale;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getConditions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domainGetMadaiURL = __webpack_require__(169);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var madai_url = (0, _domainGetMadaiURL2['default'])();
	
	function getConditions(locale) {
	  function getHref() {
	    return "https://madai.com/privacy_us.html";
	    /*const _locale = locale.toString();
	    const country = locale.country.toLowerCase();
	    if (_locale === 'en_ZA') {
	      return 'http://za.shop.madai.com/FAQ_en.html';
	    } else if (_locale === 'en_US') {
	      return 'http://us.shop.madai.com/FAQ_en.html';
	    } else if (_locale === 'it_IT') {
	      return 'http://it.madai.com/FAQ_it.html';
	    }
	    else {
	      return madai_url + country + '/terms-of-use.html';
	    }*/
	  }
	
	  return '<a target="_blank" href="' + getHref() + '">' + (0, _domainGet_bundle2['default'])(locale).footer.conditions + '</a>';
	}

	module.exports = exports['default'];

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getPolicy;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domainGetMadaiURL = __webpack_require__(169);
	
	var _domainGetMadaiURL2 = _interopRequireDefault(_domainGetMadaiURL);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var madai_url = (0, _domainGetMadaiURL2['default'])();
	
	function getPolicy(locale) {
	  function getHref() {
	    return "https://madai.com/faq_us.html";
	    /*const _locale = locale.toString();
	    const country = locale.country.toLowerCase();
	    if (_locale === 'en_ZA') {
	      return 'http://za.shop.madai.com/privacy-policy_en.html';
	    } else if (_locale === 'en_US') {
	      return 'http://us.shop.madai.com/privacy-policy_en.html';
	    } else if (_locale === 'it_IT') {
	      return 'http://it.madai.com/privacy-policy_IT.html';
	    }
	    else {
	      return madai_url + country + '/privacy.html';
	    }*/
	  }
	
	  return '<a target="_blank" href="' + getHref() + '">' + (0, _domainGet_bundle2['default'])(locale).footer.policy + '</a>';
	}

	module.exports = exports['default'];

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsLayout = __webpack_require__(165);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsContentLogin = __webpack_require__(206);
	
	var _componentsContentLogin2 = _interopRequireDefault(_componentsContentLogin);
	
	var _componentsSponsor = __webpack_require__(188);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _tcombReact = __webpack_require__(113);
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var Login = (function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login() {
	    _classCallCheck(this, _Login);
	
	    _get(Object.getPrototypeOf(_Login.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Login, [{
	    key: 'getHeader',
	    value: function getHeader() {
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'login_header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement('div', { className: 'large-100 large-text-right' })
	        )
	      );
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { locale: locale, header: this.getHeader(), sponsor: this.getSponsor(), doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentLogin2['default'], {
	          locale: locale,
	          message: this.props.message,
	          doLogin: this.props.doLogin,
	          goResendPassword: this.props.goResendPassword,
	          goFacebookLogin: this.props.goFacebookLogin,
	          goGoogleLogin: this.props.goGoogleLogin,
	          goTwitterLogin: this.props.goTwitterLogin,
	          goMicrosoftLogin: this.props.goMicrosoftLogin })
	      );
	    }
	  }]);
	
	  var _Login = Login;
	  Login = (0, _tcombReact.props)({
	    locale: _tcombForm2['default'].Obj,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    goResendPassword: _tcombForm2['default'].Func,
	    doLogin: _tcombForm2['default'].Func,
	    goFacebookLogin: _tcombForm2['default'].Func,
	    goGoogleLogin: _tcombForm2['default'].Func,
	    goTwitterLogin: _tcombForm2['default'].Func,
	    goMicrosoftLogin: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func,
	    goRegister: _tcombForm2['default'].maybe(_tcombForm2['default'].Func)
	  })(Login) || Login;
	  return Login;
	})(_react2['default'].Component);
	
	exports['default'] = Login;
	module.exports = exports['default'];

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainEmail = __webpack_require__(120);
	
	var _domainEmail2 = _interopRequireDefault(_domainEmail);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _domainPassword = __webpack_require__(199);
	
	var _domainPassword2 = _interopRequireDefault(_domainPassword);
	
	var _Message = __webpack_require__(207);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _Alert = __webpack_require__(158);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _MarkdownComponent = __webpack_require__(160);
	
	var _MarkdownComponent2 = _interopRequireDefault(_MarkdownComponent);
	
	var _SocialLogins = __webpack_require__(208);
	
	var _SocialLogins2 = _interopRequireDefault(_SocialLogins);
	
	var _tcombReact = __webpack_require__(113);
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var FormType = _tcombForm2['default'].struct({
	  email: _domainEmail2['default'],
	  password: _domainPassword2['default']
	});
	
	var value =  false ? {
	  email: 'verified@domain.com',
	  password: 'verified'
	} : {};
	
	var Login = (function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login() {
	    var _this = this;
	
	    _classCallCheck(this, _Login);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _get(Object.getPrototypeOf(_Login.prototype), 'constructor', this).apply(this, args);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	      if (value) {
	        _this.props.doLogin(value.email, value.password);
	      }
	    };
	
	    this.goResendPassword = function (evt) {
	      evt.preventDefault();
	      _this.props.goResendPassword();
	    };
	
	    this.state = {
	      options: this.getOptions()
	    };
	  }
	
	  _createClass(Login, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).login;
	      return {
	        fields: {
	          email: {
	            label: bundle.email
	          },
	          password: {
	            type: 'password',
	            label: bundle.password
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getSxContent',
	    value: function getSxContent() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).login;
	      return _react2['default'].createElement(
	        'div',
	        { className: 'left-image' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'left-claim' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _MarkdownComponent2['default'],
	              null,
	              bundle.claim.title
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _MarkdownComponent2['default'],
	              null,
	              bundle.claim.remember
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _MarkdownComponent2['default'],
	              null,
	              bundle.claim.call_to_action
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getDefaultMessage',
	    value: function getDefaultMessage() {
	      return _react2['default'].createElement(
	        _Message2['default'],
	        { bgColor: this.props.themeBgColor, fontColor: this.props.themeBgFontColor },
	        (0, _domainGet_bundle2['default'])(this.props.locale).login.title
	      );
	    }
	  }, {
	    key: 'getMessage',
	    value: function getMessage() {
	      if (this.props.message) {
	        return this.props.message;
	      }
	
	      return this.getDefaultMessage();
	    }
	  }, {
	    key: 'getAlert',
	    value: function getAlert() {
	      if (!this.props.message) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        _Alert2['default'],
	        { type: 'warning' },
	        _react2['default'].createElement(
	          _MarkdownComponent2['default'],
	          null,
	          (0, _domainGet_bundle2['default'])(this.props.locale).login.warning
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).login;
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	      return _react2['default'].createElement(
	        'div',
	        { id: 'login', className: 'cols' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-100' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 small-hide ' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                this.getSxContent()
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 large-pull-right small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                _react2['default'].createElement(
	                  'div',
	                  { id: 'login_actions' },
	                  this.getMessage(),
	                  _react2['default'].createElement(
	                    'div',
	                    { id: 'form', className: 'box light' },
	                    _react2['default'].createElement(
	                      'form',
	                      { onSubmit: this.onSubmit },
	                      _react2['default'].createElement(_tcombForm2['default'].form.Form, {
	                        ref: 'form',
	                        type: FormType,
	                        options: this.state.options,
	                        value: value }),
	                      _react2['default'].createElement(
	                        'p',
	                        null,
	                        _react2['default'].createElement(
	                          'a',
	                          { href: '#', id: 'go_resend_password', onClick: this.goResendPassword },
	                          bundle.go_resend_password
	                        )
	                      ),
	                      _react2['default'].createElement(
	                        'button',
	                        { id: 'do_login', className: 'btn', style: btnStyle },
	                        bundle.do_login
	                      )
	                    )
	                  ),
	                  _react2['default'].createElement(_SocialLogins2['default'], {
	                    title: bundle.other_logins,
	                    goFacebook: this.props.goFacebookLogin,
	                    goGoogle: this.props.goGoogleLogin,
	                    goTwitter: this.props.goTwitterLogin,
	                    goMicrosoft: this.props.goMicrosoftLogin }),
	                  this.getAlert()
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Login = Login;
	  Login = (0, _tcombReact.props)({
	    locale: _domainLocale2['default'],
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement),
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    goResendPassword: _tcombForm2['default'].Func,
	    doLogin: _tcombForm2['default'].Func,
	    goFacebookLogin: _tcombForm2['default'].Func,
	    goGoogleLogin: _tcombForm2['default'].Func,
	    goTwitterLogin: _tcombForm2['default'].Func,
	    goMicrosoftLogin: _tcombForm2['default'].Func,
	    goRegister: _tcombForm2['default'].maybe(_tcombForm2['default'].Func)
	  })(Login) || Login;
	  return Login;
	})(_react2['default'].Component);
	
	exports['default'] = Login;
	module.exports = exports['default'];

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(113);
	
	var Message = (function (_React$Component) {
	  _inherits(Message, _React$Component);
	
	  function Message() {
	    _classCallCheck(this, _Message);
	
	    _get(Object.getPrototypeOf(_Message.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Message, [{
	    key: 'getStyle',
	    value: function getStyle() {
	      if (!this.props.bgColor) {
	        return null;
	      }
	      return {
	        backgroundColor: this.props.bgColor,
	        color: this.props.fontColor
	      };
	    }
	  }, {
	    key: 'getTriangleStyle',
	    value: function getTriangleStyle() {
	      if (!this.props.bgColor) {
	        return null;
	      }
	      return {
	        borderTopColor: this.props.bgColor
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'message box title', style: this.getStyle() },
	        this.props.children,
	        _react2['default'].createElement('div', { className: 'triangle-down', style: this.getTriangleStyle() })
	      );
	    }
	  }]);
	
	  var _Message = Message;
	  Message = (0, _tcombReact.props)({
	    children: _tcombReact.t.Any,
	    bgColor: _tcombReact.t.maybe(_domainColor2['default']),
	    fontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(Message) || Message;
	  return Message;
	})(_react2['default'].Component);
	
	exports['default'] = Message;
	module.exports = exports['default'];

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombReact = __webpack_require__(113);
	
	var SocialLogins = (function (_React$Component) {
	  _inherits(SocialLogins, _React$Component);
	
	  function SocialLogins() {
	    var _this = this;
	
	    _classCallCheck(this, _SocialLogins);
	
	    _get(Object.getPrototypeOf(_SocialLogins.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goFacebook = function (evt) {
	      evt.preventDefault();
	      _this.props.goFacebook();
	    };
	
	    this.goGoogle = function (evt) {
	      evt.preventDefault();
	      _this.props.goGoogle();
	    };
	
	    this.goTwitter = function (evt) {
	      evt.preventDefault();
	      _this.props.goTwitter();
	    };
	
	    this.goMicrosoft = function (evt) {
	      evt.preventDefault();
	      _this.props.goMicrosoft();
	    };
	
	    this.goLogin = function (evt) {
	      evt.preventDefault();
	      _this.props.goLogin();
	    };
	  }
	
	  _createClass(SocialLogins, [{
	    key: 'getMadaiLogin',
	    value: function getMadaiLogin() {
	      if (!this.props.goLogin) {
	        return null;
	      }
	
	      return _react2['default'].createElement('div', { id: 'go_madai_login', onClick: this.goLogin, title: 'Madai' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'logins', className: 'box light' },
	        _react2['default'].createElement(
	          'h2',
	          null,
	          this.props.title
	        ),
	        _react2['default'].createElement(
	          'div',
	          { id: 'logins-container' },
	          _react2['default'].createElement('div', { id: 'go_facebook_login', onClick: this.goFacebook, title: 'Facebook' }),
	          _react2['default'].createElement('div', { id: 'go_google_login', onClick: this.goGoogle, title: 'Google' }),
	          _react2['default'].createElement('div', { id: 'go_twitter_login', onClick: this.goTwitter, title: 'Twitter' }),
	          _react2['default'].createElement('div', { id: 'go_microsoft_login', onClick: this.goMicrosoft, title: 'Microsoft' }),
	          this.getMadaiLogin()
	        )
	      );
	    }
	  }]);
	
	  var _SocialLogins = SocialLogins;
	  SocialLogins = (0, _tcombReact.props)({
	    title: _tcombReact.t.Str,
	    goFacebook: _tcombReact.t.Func,
	    goGoogle: _tcombReact.t.Func,
	    goTwitter: _tcombReact.t.Func,
	    goMicrosoft: _tcombReact.t.Func,
	    goLogin: _tcombReact.t.maybe(_tcombReact.t.Func)
	  })(SocialLogins) || SocialLogins;
	  return SocialLogins;
	})(_react2['default'].Component);
	
	exports['default'] = SocialLogins;
	module.exports = exports['default'];

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainSponsor = __webpack_require__(210);
	
	var _domainSponsor2 = _interopRequireDefault(_domainSponsor);
	
	var _componentsLayout = __webpack_require__(165);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsContentResendPassword = __webpack_require__(211);
	
	var _componentsContentResendPassword2 = _interopRequireDefault(_componentsContentResendPassword);
	
	var _componentsHeaderResendPassword = __webpack_require__(212);
	
	var _componentsHeaderResendPassword2 = _interopRequireDefault(_componentsHeaderResendPassword);
	
	var _componentsSponsor = __webpack_require__(188);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(113);
	
	var ResendPassword = (function (_React$Component) {
	  _inherits(ResendPassword, _React$Component);
	
	  function ResendPassword() {
	    _classCallCheck(this, _ResendPassword);
	
	    _get(Object.getPrototypeOf(_ResendPassword.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ResendPassword, [{
	    key: 'getHeader',
	    value: function getHeader() {
	      return _react2['default'].createElement(_componentsHeaderResendPassword2['default'], {
	        goLogin: this.props.goLogin,
	        goLoginLabel: (0, _domainGet_bundle2['default'])(this.props.locale).resend_password.go_login });
	    }
	  }, {
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { header: this.getHeader(), sponsor: this.getSponsor(), locale: this.props.locale, doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(_componentsContentResendPassword2['default'], {
	          locale: this.props.locale,
	          goLogin: this.props.goLogin,
	          doAcceptCookies: this.props.doAcceptCookies,
	          doResendPassword: this.props.doResendPassword,
	          message: this.props.message })
	      );
	    }
	  }]);
	
	  var _ResendPassword = ResendPassword;
	  ResendPassword = (0, _tcombReact.props)({
	    locale: _tcombForm2['default'].Obj,
	    sponsor: _tcombForm2['default'].maybe(_domainSponsor2['default']),
	    goLogin: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func,
	    doResendPassword: _tcombForm2['default'].Func,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement)
	  })(ResendPassword) || ResendPassword;
	  return ResendPassword;
	})(_react2['default'].Component);
	
	exports['default'] = ResendPassword;
	module.exports = exports['default'];

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcomb = __webpack_require__(1);
	
	var _tcomb2 = _interopRequireDefault(_tcomb);
	
	var _URL = __webpack_require__(181);
	
	var _URL2 = _interopRequireDefault(_URL);
	
	var _Color = __webpack_require__(174);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var Background_Position = _tcomb2['default'].enums.of(['left top', 'left center', 'left bottom', 'right top', 'right center', 'right bottom', 'center top', 'center center', 'center bottom'], 'Background_Position');
	
	var Repeat = _tcomb2['default'].enums.of(['repeat', 'repeat-x', 'repeat-y', 'no-repeat'], 'Repeat');
	
	var Attachment = _tcomb2['default'].enums.of(['scroll', 'fixed'], 'Attachment');
	
	var Sponsor_Background = _tcomb2['default'].struct({
	  color: _tcomb2['default'].maybe(_Color2['default']),
	  image: _tcomb2['default'].maybe(_URL2['default']),
	  position: _tcomb2['default'].maybe(Background_Position),
	  repeat: _tcomb2['default'].maybe(Repeat),
	  attachment: _tcomb2['default'].maybe(Attachment)
	}, 'Sponsor_Background');
	
	var Sponsor = _tcomb2['default'].struct({
	  name: _tcomb2['default'].String,
	  logo: _tcomb2['default'].maybe(_URL2['default']),
	  tutorial: _tcomb2['default'].maybe(_URL2['default']),
	  description: _tcomb2['default'].maybe(_tcomb2['default'].String),
	  tagline: _tcomb2['default'].maybe(_tcomb2['default'].String),
	  privacy: _tcomb2['default'].maybe(_tcomb2['default'].String),
	  color: _Color2['default'],
	  bg_color: _Color2['default'],
	  image: _tcomb2['default'].maybe(_URL2['default']),
	  background: _tcomb2['default'].maybe(Sponsor_Background),
	  welcome_name: _tcomb2['default'].maybe(_tcomb2['default'].String),
	  welcome_logo: _tcomb2['default'].maybe(_URL2['default']),
	  welcome_image: _tcomb2['default'].maybe(_URL2['default']),
	  welcome_tutorial: _tcomb2['default'].maybe(_URL2['default']),
	  welcome_description: _tcomb2['default'].maybe(_tcomb2['default'].String),
	  welcome_color: _tcomb2['default'].maybe(_Color2['default']),
	  welcome_bg_color: _tcomb2['default'].maybe(_Color2['default'])
	}, 'Sponsor');
	
	exports['default'] = Sponsor;
	module.exports = exports['default'];

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainEmail = __webpack_require__(120);
	
	var _domainEmail2 = _interopRequireDefault(_domainEmail);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _componentsMessage = __webpack_require__(207);
	
	var _componentsMessage2 = _interopRequireDefault(_componentsMessage);
	
	var _componentsMarkdownComponent = __webpack_require__(160);
	
	var _componentsMarkdownComponent2 = _interopRequireDefault(_componentsMarkdownComponent);
	
	var _tcombForm = __webpack_require__(121);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _tcombReact = __webpack_require__(113);
	
	var FormType = _tcombForm2['default'].struct({
	  email: _domainEmail2['default']
	});
	
	var ResendPassword = (function (_React$Component) {
	  _inherits(ResendPassword, _React$Component);
	
	  function ResendPassword() {
	    var _this = this;
	
	    _classCallCheck(this, _ResendPassword);
	
	    _get(Object.getPrototypeOf(_ResendPassword.prototype), 'constructor', this).apply(this, arguments);
	
	    this.onSubmit = function (evt) {
	      evt.preventDefault();
	      var value = _this.refs.form.getValue();
	      if (value) {
	        _this.props.doResendPassword(value.email);
	      }
	    };
	  }
	
	  _createClass(ResendPassword, [{
	    key: 'getFormOptions',
	    value: function getFormOptions() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).resend_password;
	
	      return {
	        fields: {
	          email: {
	            help: bundle.email_hint
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getSxContent',
	    value: function getSxContent() {
	      var bundle = (0, _domainGet_bundle2['default'])(this.props.locale).login;
	      return _react2['default'].createElement(
	        'div',
	        { className: 'left-image' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'left-claim' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.title
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.remember
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'cell' },
	            _react2['default'].createElement(
	              _componentsMarkdownComponent2['default'],
	              null,
	              bundle.claim.call_to_action
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getDefaultMessage',
	    value: function getDefaultMessage() {
	      return _react2['default'].createElement(
	        _componentsMessage2['default'],
	        { bgColor: this.props.themeBgColor, fontColor: this.props.themeBgFontColor },
	        (0, _domainGet_bundle2['default'])(this.props.locale).resend_password.title
	      );
	    }
	  }, {
	    key: 'getMessage',
	    value: function getMessage() {
	      if (this.props.message) {
	        return this.props.message;
	      }
	
	      return this.getDefaultMessage();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var bundle = (0, _domainGet_bundle2['default'])(locale).resend_password;
	
	      var btnStyle = {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        { id: 'resend_password', className: 'cols' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'large-100' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'cols' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-60 small-hide' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell' },
	                this.getSxContent()
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'large-40 large-pull-right small-100' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'cell border-radius-all' },
	                this.getMessage(),
	                _react2['default'].createElement(
	                  'div',
	                  { id: 'form', className: 'box light' },
	                  _react2['default'].createElement(
	                    'form',
	                    { onSubmit: this.onSubmit },
	                    _react2['default'].createElement(_tcombForm2['default'].form.Form, {
	                      ref: 'form',
	                      type: FormType,
	                      options: this.getFormOptions() }),
	                    _react2['default'].createElement(
	                      'button',
	                      { className: 'btn', style: btnStyle },
	                      bundle.do_resend_password
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ResendPassword = ResendPassword;
	  ResendPassword = (0, _tcombReact.props)({
	    locale: _tcombForm2['default'].Obj,
	    themeBtnColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBgFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombForm2['default'].maybe(_domainColor2['default']),
	    goLogin: _tcombForm2['default'].Func,
	    doAcceptCookies: _tcombForm2['default'].Func,
	    doResendPassword: _tcombForm2['default'].Func,
	    message: _tcombForm2['default'].maybe(_tcombForm2['default'].ReactElement)
	  })(ResendPassword) || ResendPassword;
	  return ResendPassword;
	})(_react2['default'].Component);
	
	exports['default'] = ResendPassword;
	module.exports = exports['default'];

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainColor = __webpack_require__(174);
	
	var _domainColor2 = _interopRequireDefault(_domainColor);
	
	var _tcombReact = __webpack_require__(113);
	
	var ResendPassword = (function (_React$Component) {
	  _inherits(ResendPassword, _React$Component);
	
	  function ResendPassword() {
	    var _this = this;
	
	    _classCallCheck(this, _ResendPassword);
	
	    _get(Object.getPrototypeOf(_ResendPassword.prototype), 'constructor', this).apply(this, arguments);
	
	    this.goLogin = function (evt) {
	      evt.preventDefault();
	      _this.props.goLogin();
	    };
	
	    this.goProduct = function (evt) {
	      evt.preventDefault();
	      _this.props.goProduct();
	    };
	
	    this.goCatalog = function (evt) {
	      evt.preventDefault();
	      _this.props.goCatalog();
	    };
	  }
	
	  _createClass(ResendPassword, [{
	    key: 'getColorStyle',
	    value: function getColorStyle() {
	      if (!this.props.color) {
	        return null;
	      }
	      return {
	        color: this.props.color
	      };
	    }
	  }, {
	    key: 'styleBtnColor',
	    value: function styleBtnColor() {
	      return {
	        backgroundColor: this.props.themeBtnColor,
	        color: this.props.themeBtnFontColor
	      };
	    }
	  }, {
	    key: 'goGoProductLink',
	    value: function goGoProductLink() {
	      if (!this.props.goProduct) {
	        return null;
	      }
	      //return (<a href='#' id='go_product' style={this.getColorStyle()} onClick={this.goProduct}>{this.props.goProductLabel}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_product', style: this.styleBtnColor(), onClick: this.goProduct },
	        this.props.goProductLabel
	      );
	    }
	  }, {
	    key: 'goGoCatalogLink',
	    value: function goGoCatalogLink() {
	      if (!this.props.goCatalog) {
	        return null;
	      }
	
	      var style = _extends({}, this.styleBtnColor());
	
	      if (this.props.goProduct) {
	        style.marginLeft = '20px';
	      }
	      //return (<a href='#' id='go_catalog' style={this.getColorStyle()} onClick={this.goCatalog}>{this.props.goCatalogLabel}</a>);
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_catalog', style: style, onClick: this.goCatalog },
	        this.props.goCatalogLabel
	      );
	    }
	  }, {
	    key: 'goLoginLink',
	    value: function goLoginLink() {
	      if (!this.props.goLogin) {
	        return null;
	      }
	      //return <a href="#" id="go_login" style={this.getColorStyle()} onClick={this.goLogin}>{this.props.goLoginLabel}</a>
	      return _react2['default'].createElement(
	        'button',
	        { id: 'go_login', style: this.styleBtnColor(), onClick: this.goLogin },
	        this.props.goLoginLabel
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { id: 'header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-70' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.goGoProductLink(),
	              this.goGoCatalogLink()
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-30 large-text-right' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              this.goLoginLink()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _ResendPassword = ResendPassword;
	  ResendPassword = (0, _tcombReact.props)({
	    goLogin: _tcombReact.t.Func,
	    goLoginLabel: _tcombReact.t.Str,
	    goProduct: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goProductLabel: _tcombReact.t.maybe(_tcombReact.t.Str),
	    goCatalog: _tcombReact.t.maybe(_tcombReact.t.Func),
	    goCatalogLabel: _tcombReact.t.maybe(_tcombReact.t.Str),
	    color: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnColor: _tcombReact.t.maybe(_domainColor2['default']),
	    themeBtnFontColor: _tcombReact.t.maybe(_domainColor2['default'])
	  })(ResendPassword) || ResendPassword;
	  return ResendPassword;
	})(_react2['default'].Component);
	
	exports['default'] = ResendPassword;
	module.exports = exports['default'];

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsLayout = __webpack_require__(165);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _componentsSponsor = __webpack_require__(188);
	
	var _componentsSponsor2 = _interopRequireDefault(_componentsSponsor);
	
	var _tcombReact = __webpack_require__(113);
	
	var UnexpectedError = (function (_React$Component) {
	  _inherits(UnexpectedError, _React$Component);
	
	  function UnexpectedError() {
	    var _this = this;
	
	    _classCallCheck(this, _UnexpectedError);
	
	    _get(Object.getPrototypeOf(_UnexpectedError.prototype), 'constructor', this).apply(this, arguments);
	
	    this.doRefresh = function (evt) {
	      evt.preventDefault();
	      _this.props.doRefresh();
	    };
	  }
	
	  _createClass(UnexpectedError, [{
	    key: 'getSponsor',
	    value: function getSponsor() {
	      var options = {
	        showTutorial: false
	      };
	      return _react2['default'].createElement(_componentsSponsor2['default'], { locale: this.props.locale, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { locale: this.props.locale, sponsor: this.getSponsor(), doAcceptCookies: this.props.doAcceptCookies },
	        _react2['default'].createElement(
	          'div',
	          { id: 'unexpected_error' },
	          _react2['default'].createElement(
	            'h1',
	            null,
	            'An unexpected error has occured :-('
	          ),
	          _react2['default'].createElement(
	            'h2',
	            null,
	            'Please try again after a few moments: ',
	            _react2['default'].createElement(
	              'a',
	              { href: '#', target: '_self', onClick: this.doRefresh },
	              'click here'
	            )
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'If you continue to receive this page, please contact customer service at ',
	            _react2['default'].createElement(
	              'a',
	              { href: 'mailto:support@madai.com', target: '_new' },
	              'support@madai.com'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _UnexpectedError = UnexpectedError;
	  UnexpectedError = (0, _tcombReact.props)({
	    locale: _tcombReact.t.Obj,
	    doAcceptCookies: _tcombReact.t.Func,
	    doRefresh: _tcombReact.t.Func,
	    err: _tcombReact.t.Obj
	  })(UnexpectedError) || UnexpectedError;
	  return UnexpectedError;
	})(_react2['default'].Component);
	
	exports['default'] = UnexpectedError;
	module.exports = exports['default'];

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _componentsContentNoCookies = __webpack_require__(215);
	
	var _componentsContentNoCookies2 = _interopRequireDefault(_componentsContentNoCookies);
	
	var _componentsLayout = __webpack_require__(165);
	
	var _componentsLayout2 = _interopRequireDefault(_componentsLayout);
	
	var _tcombReact = __webpack_require__(113);
	
	var NoCookies = (function (_React$Component) {
	  _inherits(NoCookies, _React$Component);
	
	  function NoCookies() {
	    _classCallCheck(this, _NoCookies);
	
	    _get(Object.getPrototypeOf(_NoCookies.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NoCookies, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	      return _react2['default'].createElement(
	        _componentsLayout2['default'],
	        { locale: locale },
	        _react2['default'].createElement(_componentsContentNoCookies2['default'], { locale: locale })
	      );
	    }
	  }]);
	
	  var _NoCookies = NoCookies;
	  NoCookies = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(NoCookies) || NoCookies;
	  return NoCookies;
	})(_react2['default'].Component);
	
	exports['default'] = NoCookies;
	module.exports = exports['default'];

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _domainGet_bundle = __webpack_require__(111);
	
	var _domainGet_bundle2 = _interopRequireDefault(_domainGet_bundle);
	
	var _domainLocale = __webpack_require__(17);
	
	var _domainLocale2 = _interopRequireDefault(_domainLocale);
	
	var _componentsDefaultUi = __webpack_require__(182);
	
	var _componentsDefaultUi2 = _interopRequireDefault(_componentsDefaultUi);
	
	var _tcombReact = __webpack_require__(113);
	
	var NoCookies = (function (_React$Component) {
	  _inherits(NoCookies, _React$Component);
	
	  function NoCookies() {
	    _classCallCheck(this, _NoCookies);
	
	    _get(Object.getPrototypeOf(_NoCookies.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NoCookies, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	      var bundle = (0, _domainGet_bundle2['default'])(locale);
	
	      return _react2['default'].createElement(
	        _componentsDefaultUi2['default'],
	        { id: 'no_cookies', title: bundle.no_cookies.title },
	        _react2['default'].createElement(
	          'div',
	          { className: 'cols' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'large-100' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'cell' },
	              bundle.no_cookies.body
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _NoCookies = NoCookies;
	  NoCookies = (0, _tcombReact.props)({
	    locale: _domainLocale2['default']
	  })(NoCookies) || NoCookies;
	  return NoCookies;
	})(_react2['default'].Component);
	
	exports['default'] = NoCookies;
	module.exports = exports['default'];

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(125);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var getHelp = function getHelp(help) {
	  if (!help) {
	    return null;
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    { className: 'hint' },
	    help
	  );
	};
	
	var getError = function getError(error, hasError) {
	  if (!hasError || !error) {
	    return null;
	  }
	  return _react2['default'].createElement(
	    'div',
	    { className: 'error' },
	    error
	  );
	};
	
	var isHorizontal = function isHorizontal(locals) {
	  return locals && locals.config && locals.config.horizontal;
	};
	
	var getStackedForm = function getStackedForm(locals) {
	  return locals.order.map(function (inputLabel, index) {
	    return getStackedContainerComponent(locals.inputs[inputLabel], index);
	  });
	};
	
	var getInlineForm = function getInlineForm(locals) {
	  return locals.order.map(function (inputLabel, index) {
	    return getInlineContainerComponent(locals.inputs[inputLabel], index);
	  });
	};
	
	var getInlineContainerComponent = function getInlineContainerComponent(input, index) {
	  var _opts = {
	    'form-group': true,
	    'nr-form-cells-2': true
	  };
	  _opts['form-group-' + index] = true;
	  var classes = (0, _classnames2['default'])(_opts);
	  return _react2['default'].createElement(
	    'div',
	    { key: index, className: classes },
	    input
	  );
	};
	
	var getStackedContainerComponent = function getStackedContainerComponent(input, index) {
	  var _opts = {
	    'form-group': true,
	    'nr-form-cells-1': true
	  };
	  _opts['form-group-' + index] = true;
	  var classes = (0, _classnames2['default'])(_opts);
	  return _react2['default'].createElement(
	    'div',
	    { key: index, className: classes },
	    input
	  );
	};
	
	function struct(locals) {
	  if (isHorizontal(locals)) {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'form form-inline' },
	      getInlineForm(locals)
	    );
	  }
	  return _react2['default'].createElement(
	    'div',
	    { className: 'form form-stacked' },
	    getStackedForm(locals)
	  );
	}
	
	var getHiddenTextbox = function getHiddenTextbox(hiddenTextbox) {
	  return _react2['default'].createElement('input', { type: 'hidden', value: hiddenTextbox.value, name: hiddenTextbox.name });
	};
	
	var getStaticTextbox = function getStaticTextbox(locals) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      'div',
	      { className: 'form-cell form-cell-0' },
	      _react2['default'].createElement(
	        'label',
	        null,
	        locals.label
	      )
	    ),
	    _react2['default'].createElement(
	      'div',
	      { className: 'form-cell form-cell-1' },
	      locals.value
	    )
	  );
	};
	
	function getInputClasses(hasError) {
	  return (0, _classnames2['default'])({
	    'form-cell': true,
	    'form-cell-1': true,
	    'has-error': hasError
	  });
	}
	
	function getLabel(label, hasError) {
	  if (!label) {
	    return null;
	  }
	  var labelClasses = (0, _classnames2['default'])({
	    'form-cell': true,
	    'form-cell-0': true,
	    'has-error': hasError
	  });
	  return _react2['default'].createElement(
	    'div',
	    { className: labelClasses },
	    _react2['default'].createElement(
	      'label',
	      null,
	      label
	    )
	  );
	}
	
	function textbox(locals) {
	  if (locals.type === 'hidden') {
	    return getHiddenTextbox(locals);
	  }
	
	  if (locals.type === 'static') {
	    return getStaticTextbox(locals);
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    getLabel(locals.label, locals.hasError),
	    _react2['default'].createElement(
	      'div',
	      { className: getInputClasses(locals.hasError) },
	      _react2['default'].createElement(
	        'div',
	        { className: 'input-wrapper' },
	        getTextboxInput(locals)
	      )
	    )
	  );
	}
	
	function getTextboxInput(locals) {
	  var _onChange = function _onChange(evt) {
	    return locals.onChange(evt.target.value);
	  };
	
	  var name = locals.attrs['name'];
	
	  var tag = _react2['default'].createElement('input', { id: locals.attrs[name], type: locals.type, value: locals.value, onChange: _onChange });
	  if (locals.type === 'textarea') {
	    tag = _react2['default'].createElement('textarea', { id: locals.attrs[name], type: locals.type, value: locals.value, onChange: _onChange });
	  }
	
	  var classes = (0, _classnames2['default'])({
	    'input-wrapper': locals.isHorizontal
	  });
	  if (locals.type !== 'textarea') {
	    return _react2['default'].createElement(
	      'div',
	      { className: classes },
	      tag,
	      getError(locals.error, locals.hasError),
	      getHelp(locals.help)
	    );
	  }
	}
	
	function getCheckboxInput(locals) {
	  var _onChange = function _onChange(evt) {
	    return locals.onChange(evt.target.checked);
	  };
	
	  var classes = (0, _classnames2['default'])({
	    'input-wrapper': locals.isHorizontal ? true : false
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: classes },
	    _react2['default'].createElement('input', { id: locals.attrs.id, type: 'checkbox', disbled: locals.disabled, value: locals.value, onChange: _onChange })
	  );
	}
	
	function checkbox(locals) {
	  var inputClasses = (0, _classnames2['default'])({
	    'form-cell': true,
	    'form-cell-0': true,
	    'has-error': locals.hasError
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      'div',
	      { className: inputClasses },
	      getCheckboxInput(locals)
	    ),
	    _react2['default'].createElement(
	      'div',
	      { className: getInputClasses(locals.hasError) },
	      _react2['default'].createElement(
	        'label',
	        null,
	        locals.label
	      ),
	      getError(locals.error, locals.hasError),
	      getHelp(locals.help)
	    )
	  );
	}
	
	function select(locals) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    getLabel(locals.label, locals.hasError),
	    _react2['default'].createElement(
	      'div',
	      { className: getInputClasses(locals.hasError) },
	      _react2['default'].createElement(
	        'div',
	        { className: 'input-wrapper' },
	        getSelectInput(locals)
	      )
	    )
	  );
	}
	
	function getSelectInput(locals) {
	  var _onChange = function _onChange(evt) {
	    var value = locals.isMultiple ? Array.prototype.slice.call(evt.target.options).filter(function (option) {
	      return option.selected;
	    }).map(function (option) {
	      return option.value;
	    }) : evt.target.value;
	    locals.onChange(value);
	  };
	
	  var classes = (0, _classnames2['default'])({
	    'input-wrapper': locals.isHorizontal ? true : false
	  });
	
	  var getOptions = function getOptions() {
	    return locals.options.map(function (opt, index) {
	      return _react2['default'].createElement(
	        'option',
	        { key: index, value: opt.value },
	        opt.text
	      );
	    });
	  };
	
	  return _react2['default'].createElement(
	    'div',
	    { className: classes },
	    _react2['default'].createElement(
	      'select',
	      { id: locals.attrs.id, multiple: locals.multiple, disbled: locals.disabled, value: locals.value, onChange: _onChange },
	      getOptions()
	    ),
	    getError(locals.error, locals.hasError),
	    getHelp(locals.help)
	  );
	}
	
	function radio(locals) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    getLabel(locals.label, locals.hasError),
	    _react2['default'].createElement(
	      'div',
	      { className: getInputClasses(locals.hasError) },
	      _react2['default'].createElement(
	        'div',
	        { className: 'input-wrapper' },
	        getRadioInput(locals)
	      )
	    )
	  );
	}
	
	function getRadioInput(locals) {
	  var _onChange = function _onChange(evt) {
	    return locals.onChange(evt.target.value);
	  };
	
	  var id = locals.attrs.id;
	  return locals.options.map(function (opt, index) {
	    var isChecked = opt.value === locals.value;
	    var optId = id + '_' + index;
	
	    return _react2['default'].createElement(
	      'div',
	      { key: index, id: locals.attrs.name },
	      _react2['default'].createElement(
	        'div',
	        { className: 'group-input' },
	        _react2['default'].createElement('input', { id: optId, type: 'radio', disabled: locals.disabled, checked: isChecked, value: opt.value, onChange: _onChange })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'group-label' },
	        opt.text
	      )
	    );
	  });
	}
	
	function range(n) {
	  var result = [];
	  for (var i = 1; i <= n; i++) {
	    result.push(i);
	  }
	  return result;
	}
	
	function padLeft(x, len) {
	  var str = String(x);
	  var times = len - str.length;
	  for (var i = 0; i < times; i++) {
	    str = '0' + str;
	  }
	  return str;
	}
	
	function toOption(value, text, key) {
	  return _react2['default'].createElement(
	    'option',
	    { key: key, value: value },
	    text
	  );
	}
	
	var nullOption = function nullOption(key) {
	  return [toOption('', '-', key + '-0')];
	};
	
	var optionsDays = nullOption('days').concat(range(31).map(function (i) {
	  return toOption(i, padLeft(i, 2), 'days-' + i);
	}));
	
	var optionsMonths = nullOption('months').concat(range(12).map(function (i) {
	  return toOption(i - 1, padLeft(i, 2), 'months-' + i);
	}));
	
	function date(locals) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    getLabel(locals.label, locals.hasError),
	    _react2['default'].createElement(
	      'div',
	      { className: getInputClasses(locals.hasError) },
	      _react2['default'].createElement(
	        'div',
	        { className: 'input-wrapper' },
	        getDateInput(locals)
	      )
	    )
	  );
	}
	
	function getDateInput(locals) {
	  var value = locals.value.slice();
	
	  var onDayChange = function onDayChange(evt) {
	    value[2] = evt.target.value === '-' ? null : evt.target.value;
	    locals.onChange(value);
	  };
	
	  var onMonthChange = function onMonthChange(evt) {
	    value[1] = evt.target.value === '-' ? null : evt.target.value;
	    locals.onChange(value);
	  };
	
	  var onYearChange = function onYearChange(evt) {
	    value[0] = evt.target.value.trim() === '' ? null : evt.target.value.trim();
	    locals.onChange(value);
	  };
	
	  var days = function days() {
	    return _react2['default'].createElement(
	      'select',
	      { key: 'days', className: 'days', disabled: locals.disabled, value: value[2], onChange: onDayChange },
	      optionsDays
	    );
	  };
	
	  var months = function months() {
	    return _react2['default'].createElement(
	      'select',
	      { key: 'months', className: 'months', disabled: locals.disabled, value: value[1], onChange: onMonthChange },
	      optionsMonths
	    );
	  };
	
	  var years = function years() {
	    return _react2['default'].createElement('input', { key: 'years', className: 'years', type: 'text', disabled: locals.disabled, maxLength: 4, size: 4, value: value[0], onChange: onYearChange });
	  };
	
	  var parts = {
	    D: days(),
	    M: months(),
	    YY: years()
	  };
	
	  var children = locals.order.map(function (id) {
	    return parts[id];
	  });
	
	  var classes = (0, _classnames2['default'])({
	    'input-wrapper': locals.isHorizontal ? true : false
	  });
	  return _react2['default'].createElement(
	    'div',
	    { className: classes },
	    children,
	    getError(locals.error, locals.hasError),
	    getHelp(locals.help)
	  );
	}
	
	function list() {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    'list'
	  );
	}
	
	exports['default'] = {
	  textbox: textbox,
	  checkbox: checkbox,
	  select: select,
	  radio: radio,
	  date: date,
	  struct: struct,
	  list: list
	};
	module.exports = exports['default'];

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** user.min.js
 **/